import React from 'react';
const ICON_STROKE_COLOR = '#2A353D';
const icons = {
  videoFile: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H8C8.55228 23 9 22.5523 9 22C9 21.4477 8.55228 21 8 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V7C19 7.55228 19.4477 8 20 8C20.5523 8 21 7.55228 21 7V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM12 17C12 14.2386 14.2386 12 17 12C19.7614 12 22 14.2386 22 17C22 19.7614 19.7614 22 17 22C14.2386 22 12 19.7614 12 17ZM17 10C13.134 10 10 13.134 10 17C10 20.866 13.134 24 17 24C20.866 24 24 20.866 24 17C24 13.134 20.866 10 17 10ZM16.5547 14.1679C16.2478 13.9634 15.8533 13.9443 15.5281 14.1183C15.203 14.2923 15 14.6312 15 15V19C15 19.3688 15.203 19.7077 15.5281 19.8817C15.8533 20.0557 16.2478 20.0366 16.5547 19.8321L19.5547 17.8321C19.8329 17.6466 20 17.3344 20 17C20 16.6656 19.8329 16.3534 19.5547 16.1679L16.5547 14.1679Z"
        fill="#000000"
      />
    </svg>
  ),
  menu: (
    <svg width="4" height="16" viewBox="0 0 4 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.99999 8.83334C2.46023 8.83334 2.83332 8.46025 2.83332 8.00001C2.83332 7.53977 2.46023 7.16668 1.99999 7.16668C1.53975 7.16668 1.16666 7.53977 1.16666 8.00001C1.16666 8.46025 1.53975 8.83334 1.99999 8.83334Z"
        stroke="#98A2B3"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M1.99999 3.00001C2.46023 3.00001 2.83332 2.62691 2.83332 2.16668C2.83332 1.70644 2.46023 1.33334 1.99999 1.33334C1.53975 1.33334 1.16666 1.70644 1.16666 2.16668C1.16666 2.62691 1.53975 3.00001 1.99999 3.00001Z"
        stroke="#98A2B3"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M1.99999 14.6667C2.46023 14.6667 2.83332 14.2936 2.83332 13.8333C2.83332 13.3731 2.46023 13 1.99999 13C1.53975 13 1.16666 13.3731 1.16666 13.8333C1.16666 14.2936 1.53975 14.6667 1.99999 14.6667Z"
        stroke="#98A2B3"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  smallGrid: (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="11" height="11" rx="1" fill="#c6488c" />
      <rect y="12" width="11" height="11" rx="1" fill="#c6488c" />
      <rect x="12" width="11" height="11" rx="1" fill="#c6488c" />
      <rect x="12" y="12" width="11" height="11" rx="1" fill="#c6488c" />
    </svg>
  ),
  largeGrid: (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="16" width="7" height="7" rx="1" fill="#c6488c" />
      <rect y="8" width="7" height="7" rx="1" fill="#c6488c" />
      <rect width="7" height="7" rx="1" fill="#c6488c" />
      <rect x="16" y="16" width="7" height="7" rx="1" fill="#c6488c" />
      <rect x="16" y="8" width="7" height="7" rx="1" fill="#c6488c" />
      <rect x="16" width="7" height="7" rx="1" fill="#c6488c" />
      <rect x="8" y="16" width="7" height="7" rx="1" fill="#c6488c" />
      <rect x="8" y="8" width="7" height="7" rx="1" fill="#c6488c" />
      <rect x="8" width="7" height="7" rx="1" fill="#c6488c" />
    </svg>
  ),

  flashLight: (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 238 399"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M235.232 9.015C231.883 3.276 225.681 0 218.244 0H126.936C116.036 0 104.712 7.113 100.006 16.924L3.16999 218.041C0.00799274 224.601 0.202993 231.559 3.64099 237.078C7.10399 242.646 13.233 245.889 20.5 246.044L92.162 246.946L40.285 376.621C39.009 379.856 36.326 386.635 41.106 393.602C43.195 396.658 46.78 398.528 50.47 398.528H51.307C58.306 398.528 62.524 393.22 64.548 390.66L232.176 180.17C239.329 171.204 236.378 163.157 235.297 160.816C234.175 158.573 229.672 151.224 218.251 151.224H164.911L234.711 28.239C238.37 21.752 238.573 14.729 235.232 9.015Z"
        fill="#c6488c"
      />
    </svg>
  ),
  soldTag: (
    <svg
      width="18px"
      height="18px"
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
    >
      <g>
        <g>
          <path
            d="M507.137,249.793L263.443,4.927c-3.131-3.163-7.402-4.924-11.837-4.924H16.695C7.467,0.003,0,7.47,0,16.698v233.737    c0,4.434,1.761,8.674,4.892,11.804l244.867,244.867c6.521,6.521,17.087,6.521,23.609,0l233.737-233.737    C513.626,266.848,513.626,256.315,507.137,249.793z M116.869,166.958c-27.619,0-50.087-22.468-50.087-50.086    s22.468-50.087,50.087-50.087c27.619,0,50.086,22.468,50.086,50.087S144.487,166.958,116.869,166.958z"
            fill="#82ccf7ff"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  ),
  clock: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="#f77f00" strokeWidth="1.5" />
      <path
        d="M12 8V12L14 14"
        stroke="#f77f00"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  expiredClock: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="#ED1B24" strokeWidth="1.5" />
      <path
        d="M11.992 15H12.001"
        stroke="#ED1B24"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12L12 8"
        stroke="#ED1B24"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  iconPromote: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <g clipPath="url(#clip0_429_11262)">
          {' '}
          <path
            d="M10.5099 3.66452C11.3048 2.77651 12.6952 2.77651 13.4901 3.66452L14.1909 4.44729C14.596 4.89986 15.1849 5.14377 15.7914 5.11024L16.8404 5.05225C18.0304 4.98646 19.0135 5.96956 18.9477 7.1596L18.8898 8.20861C18.8562 8.81511 19.1001 9.40398 19.5527 9.80913L20.3355 10.5099C21.2235 11.3048 21.2235 12.6952 20.3355 13.4901L19.5527 14.1909C19.1001 14.596 18.8562 15.1849 18.8898 15.7914L18.9477 16.8404C19.0135 18.0304 18.0304 19.0135 16.8404 18.9477L15.7914 18.8898C15.1849 18.8562 14.596 19.1001 14.1909 19.5527L13.4901 20.3355C12.6952 21.2235 11.3048 21.2235 10.5099 20.3355L9.80913 19.5527C9.40398 19.1001 8.81511 18.8562 8.20861 18.8898L7.1596 18.9477C5.96956 19.0135 4.98646 18.0304 5.05225 16.8404L5.11024 15.7914C5.14377 15.1849 4.89986 14.596 4.44729 14.1909L3.66452 13.4901C2.77651 12.6952 2.77651 11.3048 3.66452 10.5099L4.44729 9.80913C4.89986 9.40398 5.14377 8.81511 5.11024 8.20861L5.05225 7.1596C4.98646 5.96956 5.96956 4.98646 7.1596 5.05225L8.20861 5.11024C8.81511 5.14377 9.40398 4.89986 9.80913 4.44729L10.5099 3.66452Z"
            stroke="#292929"
            strokeWidth="2.5"
          ></path>{' '}
          <rect
            x="9.5"
            y="9.5"
            width="0.01"
            height="0.01"
            stroke="#292929"
            strokeWidth="3.75"
            strokeLinejoin="round"
          ></rect>{' '}
          <rect
            x="14.5"
            y="14.5"
            width="0.01"
            height="0.01"
            stroke="#292929"
            strokeWidth="3.75"
            strokeLinejoin="round"
          ></rect>{' '}
          <path
            d="M15 9L9 15"
            stroke="#292929"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>{' '}
        </g>{' '}
        <defs>
          {' '}
          <clipPath id="clip0_429_11262">
            {' '}
            <rect width="24" height="24" fill="white"></rect>{' '}
          </clipPath>{' '}
        </defs>{' '}
      </g>
    </svg>
  ),
  iconWithdraw: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M19 13C19 17.4183 15.4183 21 11 21C6.58172 21 3 17.4183 3 13C3 8.58172 6.58172 5 11 5M11 11V4C11 3.44772 11.449 2.99475 11.9986 3.04924C16.7241 3.51775 20.4823 7.27586 20.9508 12.0014C21.0053 12.551 20.5523 13 20 13H13C11.8954 13 11 12.1046 11 11Z"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>{' '}
      </g>
    </svg>
  ),
  attachment: (
    <svg width="800px" height="800px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="#000000"
        d="M19.0909091,2 C19.5929861,2 20,2.39796911 20,2.88888889 L20,17.1111111 C20,17.6020309 19.5929861,18 19.0909091,18 L0.909090909,18 C0.407013864,18 0,17.6020309 0,17.1111111 L0,2.88888889 C0,2.39796911 0.407013864,2 0.909090909,2 L19.0909091,2 Z M5.41498358,8.41650391 L1.35528564,12.4593235 L1.35528564,16.6760254 L18.6397145,16.6760254 L18.6397145,15.243208 L15.4396522,12.1229367 L12.6626905,14.4561124 C12.4973565,14.5726194 12.3372165,14.6241229 12.1822704,14.6106228 C12.0273243,14.5971228 11.8813994,14.5342746 11.7444957,14.4220785 L5.41498358,8.41650391 Z M18.634732,3.33114963 L1.36244722,3.33114963 L1.36244722,10.5609045 L4.96842818,6.9698622 C5.10609945,6.86625615 5.2524821,6.81445312 5.40757613,6.81445312 C5.56267016,6.81445312 5.69937041,6.86096747 5.81767689,6.95399616 L12.2491594,13.0423991 L15.0544045,10.6911214 C15.1877478,10.594062 15.3280547,10.5455322 15.4753252,10.5455322 C15.6225956,10.5455322 15.761728,10.594062 15.8927224,10.6911214 L18.634732,13.3555356 L18.634732,3.33114963 Z M15.2726045,5.22858343 C16.0257201,5.22858343 16.6362408,5.8255371 16.6362408,6.56191676 C16.6362408,7.29829643 16.0257201,7.8952501 15.2726045,7.8952501 C14.5194889,7.8952501 13.9089681,7.29829643 13.9089681,6.56191676 C13.9089681,5.8255371 14.5194889,5.22858343 15.2726045,5.22858343 Z"
      />
    </svg>
  ),
  editList: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <title></title>{' '}
        <g id="Complete">
          {' '}
          <g id="edit">
            {' '}
            <g>
              {' '}
              <path
                d="M20,16v4a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V6A2,2,0,0,1,4,4H8"
                fill="none"
                stroke="#000000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              ></path>{' '}
              <polygon
                fill="none"
                points="12.5 15.8 22 6.2 17.8 2 8.3 11.5 8 16 12.5 15.8"
                stroke="#000000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              ></polygon>{' '}
            </g>{' '}
          </g>{' '}
        </g>{' '}
      </g>
    </svg>
  ),
  viewIcon: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fill="#000000"
          d="M512 160c320 0 512 352 512 352S832 864 512 864 0 512 0 512s192-352 512-352zm0 64c-225.28 0-384.128 208.064-436.8 288 52.608 79.872 211.456 288 436.8 288 225.28 0 384.128-208.064 436.8-288-52.608-79.872-211.456-288-436.8-288zm0 64a224 224 0 1 1 0 448 224 224 0 0 1 0-448zm0 64a160.192 160.192 0 0 0-160 160c0 88.192 71.744 160 160 160s160-71.808 160-160-71.744-160-160-160z"
        ></path>
      </g>
    </svg>
  ),
  twitter: (
    <svg width="18" height="19" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.78251 21C16.3295 21 20.4592 14.4577 20.4592 8.7938C20.4592 8.60974 20.4592 8.42569 20.4512 8.24163C21.2515 7.63927 21.9478 6.87795 22.5 6.01624C21.7637 6.35925 20.9714 6.58514 20.1391 6.6939C20.9874 6.16683 21.6357 5.32185 21.9478 4.31791C21.1555 4.81152 20.2751 5.16289 19.3387 5.35531C18.5864 4.5187 17.522 4 16.3455 4C14.0806 4 12.2399 5.92421 12.2399 8.29183C12.2399 8.62648 12.2799 8.95276 12.3439 9.27067C8.93457 9.09498 5.90936 7.37992 3.88455 4.78642C3.53241 5.42224 3.33233 6.15846 3.33233 6.94488C3.33233 8.43406 4.06062 9.74754 5.15706 10.5172C4.48479 10.4921 3.85254 10.2997 3.30032 9.98179C3.30032 9.99852 3.30032 10.0153 3.30032 10.0404C3.30032 12.1152 4.71689 13.8553 6.58964 14.2485C6.2455 14.3489 5.88535 14.3991 5.5092 14.3991C5.2451 14.3991 4.989 14.374 4.7409 14.3238C5.2611 16.0305 6.78171 17.2687 8.57443 17.3022C7.16587 18.4567 5.39716 19.1427 3.47639 19.1427C3.14826 19.1427 2.82013 19.126 2.5 19.0842C4.30872 20.2889 6.46959 21 8.78251 21Z"
          fill="#3F3F46"
        ></path>
      </g>
    </svg>
  ),
  fbMessenger: (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.31513 14.9079V18.1382L6.33568 16.421C7.17766 16.6637 8.07268 16.7946 9 16.7946C13.9709 16.7946 18 13.0347 18 8.39732C18 3.75959 13.9709 0 9 0C4.02943 0 0 3.75959 0 8.39732C0 11.0234 1.29198 13.3682 3.31513 14.9079Z"
        fill="#484848"
      ></path>
      <path
        d="M8.03892 6.09741L3.18527 11.2364L7.6025 8.81284L9.91044 11.2364L14.7367 6.09741L10.3685 8.47856L8.03892 6.09741Z"
        fill="white"
      ></path>
    </svg>
  ),
  emailShare: (
    <svg
      width="18"
      height="19"
      fill="#000000"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M22,5V9L12,13,2,9V5A1,1,0,0,1,3,4H21A1,1,0,0,1,22,5ZM2,11.154V19a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V11.154l-10,4Z"></path>
      </g>
    </svg>
  ),
  copyToClipboard: (
    <svg width="18" height="19" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g clipPath="url(#a)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 5h7.795c1.115 0 1.519.116 1.926.334.407.218.727.538.945.945.218.407.334.811.334 1.926V16a1 1 0 1 0 2 0V8.128c0-1.783-.186-2.43-.534-3.082a3.635 3.635 0 0 0-1.512-1.512C18.302 3.186 17.655 3 15.872 3H8a1 1 0 0 0 0 2zm7.721 2.334C15.314 7.116 14.91 7 13.795 7h-7.59c-1.115 0-1.519.116-1.926.334a2.272 2.272 0 0 0-.945.945C3.116 8.686 3 9.09 3 10.205v7.59c0 1.114.116 1.519.334 1.926.218.407.538.727.945.945.407.218.811.334 1.926.334h7.59c1.114 0 1.519-.116 1.926-.334.407-.218.727-.538.945-.945.218-.407.334-.811.334-1.926v-7.59c0-1.115-.116-1.519-.334-1.926a2.272 2.272 0 0 0-.945-.945z"
            fill="#000000"
          ></path>
        </g>
        <defs>
          <clipPath id="a">
            <path fill="#000000" d="M0 0h24v24H0z"></path>
          </clipPath>
        </defs>
      </g>
    </svg>
  ),
  iconMessage: (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 5.45455C9.73557 5.45455 6.65128 5.64867 4.69268 5.79141C4.04222 5.83882 3.53846 6.35372 3.53846 6.98262V7.69328L11.3774 11.8107C11.7646 12.0141 12.2354 12.0141 12.6226 11.8107L20.4615 7.69328V6.98261C20.4615 6.35372 19.9578 5.83882 19.3073 5.79141C17.3487 5.64867 14.2644 5.45455 12 5.45455ZM20.4615 9.35722L13.3698 13.0822C12.5179 13.5296 11.4821 13.5296 10.6302 13.0822L3.53846 9.35722V17.0174C3.53846 17.6463 4.04222 18.1612 4.69268 18.2086C6.65128 18.3513 9.73557 18.5455 12 18.5455C14.2644 18.5455 17.3487 18.3513 19.3073 18.2086C19.9578 18.1612 20.4615 17.6463 20.4615 17.0174V9.35722ZM4.57444 4.34117C6.53421 4.19834 9.67068 4 12 4C14.3293 4 17.4658 4.19834 19.4256 4.34117C20.8902 4.44791 22 5.60588 22 6.98261V17.0174C22 18.3941 20.8902 19.5521 19.4256 19.6588C17.4658 19.8017 14.3293 20 12 20C9.67068 20 6.53421 19.8017 4.57444 19.6588C3.10982 19.5521 2 18.3941 2 17.0174V6.98262C2 5.60589 3.10982 4.44791 4.57444 4.34117Z"
        fill="#4a4a4a"
      />
    </svg>
  ),
  iconBag: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 32 32"
      id="i-cart"
      fill="none"
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      style={{ fill: 'none', stroke: '#4a4a4a' }}
    >
      <path d="M6 6 L30 6 27 19 9 19 M27 23 L10 23 5 2 2 2" />
      <circle cx="25" cy="27" r="2" />
      <circle cx="12" cy="27" r="2" />
    </svg>
  ),
  iconBagFilled: (
    <svg width="24" height="24" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 5H29L26 18H8M26 22H9L4 1H1"
        stroke="#c6488c"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ fill: 'none' }}
      />
      <path
        d="M24 28C25.1046 28 26 27.1046 26 26C26 24.8954 25.1046 24 24 24C22.8954 24 22 24.8954 22 26C22 27.1046 22.8954 28 24 28Z"
        stroke="#c6488c"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ fill: 'none' }}
      />
      <path
        d="M11 28C12.1046 28 13 27.1046 13 26C13 24.8954 12.1046 24 11 24C9.89543 24 9 24.8954 9 26C9 27.1046 9.89543 28 11 28Z"
        stroke="#c6488c"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ fill: 'none' }}
      />
      <path d="M5.13462 5H29L26 18.5L8 18L5.13462 5Z" fill="#c6488c" />
    </svg>
  ),
  clearFilter: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
      <g id="Eraser">
        <path
          fill="#303030"
          d="M20.454,19.028h-7.01l6.62-6.63a2.935,2.935,0,0,0,.87-2.09,2.844,2.844,0,0,0-.87-2.05l-3.42-3.44a2.93,2.93,0,0,0-4.13.01L3.934,13.4a2.946,2.946,0,0,0,0,4.14l1.48,1.49H3.554a.5.5,0,0,0,0,1h16.9A.5.5,0,0,0,20.454,19.028Zm-7.24-13.5a1.956,1.956,0,0,1,2.73,0l3.42,3.44a1.868,1.868,0,0,1,.57,1.35,1.93,1.93,0,0,1-.57,1.37l-5.64,5.64-6.15-6.16Zm-1.19,13.5h-5.2l-2.18-2.2a1.931,1.931,0,0,1,0-2.72l2.23-2.23,6.15,6.15Z"
        />
      </g>
    </svg>
  ),
  filter: (
    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none">
      <path
        d="M14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5M14 5C14 6.10457 13.1046 7 12 7C10.8954 7 10 6.10457 10 5M14 5H20M10 5L4 5M16 12C16 13.1046 16.8954 14 18 14C19.1046 14 20 13.1046 20 12C20 10.8954 19.1046 10 18 10C16.8954 10 16 10.8954 16 12ZM16 12H4M8 19C8 17.8954 7.10457 17 6 17C4.89543 17 4 17.8954 4 19C4 20.1046 4.89543 21 6 21C7.10457 21 8 20.1046 8 19ZM8 19H20"
        stroke="#303030"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  ),
  filter2: (
    <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 6H14M1.5 1H16.5M6.5 11H11.5"
        stroke="#344054"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  bin: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 5.25H15"
        stroke="#605F5F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M7.5 8.25V12.75"
        stroke="#605F5F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M10.5 8.25V12.75"
        stroke="#605F5F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M3.75 5.25L4.5 14.25C4.5 14.6478 4.65804 15.0294 4.93934 15.3107C5.22064 15.592 5.60218 15.75 6 15.75H12C12.3978 15.75 12.7794 15.592 13.0607 15.3107C13.342 15.0294 13.5 14.6478 13.5 14.25L14.25 5.25"
        stroke="#605F5F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M6.75 5.25V3C6.75 2.80109 6.82902 2.61032 6.96967 2.46967C7.11032 2.32902 7.30109 2.25 7.5 2.25H10.5C10.6989 2.25 10.8897 2.32902 11.0303 2.46967C11.171 2.61032 11.25 2.80109 11.25 3V5.25"
        stroke="#605F5F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  png: (
    <svg width="40px" height="40px" viewBox="0 0 480 480" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="#E2E5E7"
        d="M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
      />
      <path fill="#B0B7BD" d="M384,128h96L352,0v96C352,113.6,366.4,128,384,128z" />
      <polygon fill="#CAD1D8" points="480,224 384,128 480,128" />
      <path
        fill="#A066AA"
        d="M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16V416z"
      />
      <g fill="#FFFFFF">
        <path
          d="M92.816,303.152c0-4.224,3.312-8.848,8.688-8.848h29.568c16.624,0,31.6,11.136,31.6,32.496
      c0,20.224-14.976,31.472-31.6,31.472H109.68v16.896c0,5.648-3.552,8.832-8.176,8.832c-4.224,0-8.688-3.184-8.688-8.832
      C92.816,375.168,92.816,303.152,92.816,303.152z M109.68,310.432v31.856h21.376c8.56,0,15.344-7.552,15.344-15.488
      c0-8.96-6.784-16.368-15.344-16.368L109.68,310.432L109.68,310.432z"
        />
        <path
          d="M178.976,304.432c0-4.624,1.024-9.088,7.68-9.088c4.592,0,5.632,1.152,9.072,4.464l42.336,52.976
      v-49.632c0-4.224,3.696-8.848,8.064-8.848c4.608,0,9.072,4.624,9.072,8.848v72.016c0,5.648-3.456,7.792-6.784,8.832
      c-4.464,0-6.656-1.024-10.352-4.464l-42.336-53.744v49.392c0,5.648-3.456,8.832-8.064,8.832s-8.704-3.184-8.704-8.832v-70.752
      H178.976z"
        />
        <path
          d="M351.44,374.16c-9.088,7.536-20.224,10.752-31.472,10.752c-26.88,0-45.936-15.36-45.936-45.808
      c0-25.84,20.096-45.92,47.072-45.92c10.112,0,21.232,3.456,29.168,11.264c7.808,7.664-3.456,19.056-11.12,12.288
      c-4.736-4.624-11.392-8.064-18.048-8.064c-15.472,0-30.432,12.4-30.432,30.432c0,18.944,12.528,30.448,29.296,30.448
      c7.792,0,14.448-2.304,19.184-5.76V348.08h-19.184c-11.392,0-10.24-15.632,0-15.632h25.584c4.736,0,9.072,3.6,9.072,7.568v27.248
      C354.624,369.552,353.616,371.712,351.44,374.16z"
        />
      </g>
      <path
        fill="#CAD1D8"
        d="M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
      />
    </svg>
  ),
  paymentIcon: (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_78_357)">
        <path
          d="M30.8499 43.0534C30.4669 43.0541 30.1022 42.886 29.8537 42.5944L22.9349 34.4923C22.4649 33.9419 22.53 33.1153 23.0803 32.6453C23.6307 32.176 24.4574 32.2411 24.9273 32.7907L31.0151 39.92L46.1354 27.6188C46.6967 27.162 47.5219 27.2468 47.978 27.8081C48.4348 28.3695 48.35 29.1947 47.7887 29.6507L31.6751 42.7596C31.4427 42.9496 31.151 43.0534 30.8499 43.0534Z"
          fill="#2DE1C2"
        />
        <path
          d="M30.4179 68.3437L33.9687 69.891C34.3005 70.0357 34.6784 70.0364 35.011 69.8924L39.012 68.1646C53.06 62.2647 62.1993 48.5148 62.2008 33.2783V15.3294C62.2008 14.8455 61.934 14.4004 61.5071 14.1731L35.1981 0.154245C34.8078 -0.0540638 34.34 -0.0511404 33.9526 0.161554L8.37155 14.1804C7.95201 14.4106 7.6918 14.8506 7.6918 15.3294V33.6416C7.70715 48.6946 16.6257 62.3129 30.4179 68.3437ZM10.3114 16.1049L34.5907 2.79794L59.5812 16.1144V33.2783C59.5783 47.4645 51.0668 60.2649 37.9865 65.7548L37.977 65.7592L34.4935 67.2634L31.4661 65.9426C18.6277 60.3292 10.3253 47.6538 10.3106 33.6416L10.3114 16.1049Z"
          fill="#087ACB"
        />
        <path
          d="M43.5999 58.2695L43.5911 58.2732L40.1069 59.7781L37.0794 58.4581C24.241 52.8447 15.9386 40.1693 15.924 26.157V13.0284L10.3106 16.1048V33.6415C10.3253 47.6538 18.6276 60.3292 31.4661 65.9426L34.4928 67.2626L37.977 65.7577L37.9858 65.754C45.2364 62.701 51.2613 57.3171 55.1066 50.4546C51.8248 53.7934 47.9137 56.4495 43.5999 58.2695Z"
          fill="#E5F0FD"
        />
      </g>
      <defs>
        <clipPath id="clip0_78_357">
          <rect width="70" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  layerVisibilityIcon: (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="2" width="32" height="32" rx="16" fill="#F4EBFF" />
      <rect
        x="2"
        y="2"
        width="32"
        height="32"
        rx="16"
        stroke="#F9F5FF"
        strokeWidth="4"
        fill="none"
      />
      <path
        d="M11.3333 19.6666L17.7615 22.8807C17.8489 22.9244 17.8926 22.9463 17.9385 22.9549C17.9791 22.9625 18.0208 22.9625 18.0614 22.9549C18.1073 22.9463 18.151 22.9244 18.2385 22.8807L24.6666 19.6666M11.3333 16.3333L17.7615 13.1192C17.8489 13.0755 17.8926 13.0536 17.9385 13.045C17.9791 13.0374 18.0208 13.0374 18.0614 13.045C18.1073 13.0536 18.151 13.0755 18.2385 13.1192L24.6666 16.3333L18.2385 19.5474C18.151 19.5911 18.1073 19.613 18.0614 19.6216C18.0208 19.6292 17.9791 19.6292 17.9385 19.6216C17.8926 19.613 17.8489 19.5911 17.7615 19.5474L11.3333 16.3333Z"
        stroke="#7F56D9"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  layerVisibilityBlackIcon: (
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dii_312_2711)">
        <rect x="2" y="1" width="48" height="48" rx="10" fill="white" />
        <rect x="2.5" y="1.5" width="47" height="47" rx="9.5" stroke="#E4E7EC" fill="none" />
        <path
          d="M16 27.5001L25.6422 32.3212C25.7734 32.3868 25.839 32.4196 25.9078 32.4325C25.9687 32.4439 26.0313 32.4439 26.0922 32.4325C26.161 32.4196 26.2266 32.3868 26.3578 32.3212L36 27.5001M16 22.5001L25.6422 17.679C25.7734 17.6134 25.839 17.5806 25.9078 17.5677C25.9687 17.5562 26.0313 17.5562 26.0922 17.5677C26.161 17.5806 26.2266 17.6134 26.3578 17.679L36 22.5001L26.3578 27.3212C26.2266 27.3868 26.161 27.4196 26.0922 27.4325C26.0313 27.4439 25.9687 27.4439 25.9078 27.4325C25.839 27.4196 25.7734 27.3868 25.6422 27.3212L16 22.5001Z"
          stroke="#344054"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <filter
          id="filter0_dii_312_2711"
          x="0"
          y="0"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_312_2711" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_312_2711"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_312_2711" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect3_innerShadow_312_2711"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_312_2711"
            result="effect3_innerShadow_312_2711"
          />
        </filter>
      </defs>
    </svg>
  ),
  addIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 4V20"
        stroke="#000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 12H20"
        stroke="#000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  disabledAddIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 4V20"
        stroke="#dedede"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 12H20"
        stroke="#dedede"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  subtractIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 12L4 12"
        stroke="#000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  disabledSubtractIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 12L4 12"
        stroke="#dedede"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  share: (
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.59 12.51L13.42 16.49M13.41 5.51L6.59 9.49M19 4C19 5.65685 17.6569 7 16 7C14.3431 7 13 5.65685 13 4C13 2.34315 14.3431 1 16 1C17.6569 1 19 2.34315 19 4ZM7 11C7 12.6569 5.65685 14 4 14C2.34315 14 1 12.6569 1 11C1 9.34315 2.34315 8 4 8C5.65685 8 7 9.34315 7 11ZM19 18C19 19.6569 17.6569 21 16 21C14.3431 21 13 19.6569 13 18C13 16.3431 14.3431 15 16 15C17.6569 15 19 16.3431 19 18Z"
        stroke="black"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  soundIcon: (
    <svg
      data-bbox="29.5 49.5 141 101"
      viewBox="0 0 200 200"
      height="200"
      width="200"
      xmlns="http://www.w3.org/2000/svg"
      data-type="shape"
    >
      <g>
        <path d="M95.09 50.352a4.03 4.03 0 0 0-4.231.477L58.7 76.291H33.5c-2.209 0-4 1.773-4 3.961v39.496c0 2.187 1.791 3.961 4 3.961h25.2l32.158 25.463a4.026 4.026 0 0 0 4.231.476 3.959 3.959 0 0 0 2.267-3.57V53.922c0-1.522-.88-2.91-2.266-3.57zm-5.734 87.487L62.6 116.654a4.02 4.02 0 0 0-2.498-.867H37.5V84.213h22.603c.908 0 1.789-.306 2.498-.867l26.756-21.185v75.678zM170.5 100c0 18.637-7.331 36.16-20.645 49.341-.781.773-1.805 1.159-2.828 1.159s-2.048-.387-2.829-1.16a3.933 3.933 0 0 1 .001-5.602C156.001 132.054 162.5 116.521 162.5 100s-6.499-32.054-18.301-43.738a3.935 3.935 0 0 1-.001-5.602 4.03 4.03 0 0 1 5.657-.001C163.169 63.84 170.5 81.363 170.5 100zm-44.121-26.104c7.034 6.964 10.908 16.223 10.908 26.071s-3.874 19.107-10.908 26.071c-.781.773-1.805 1.159-2.828 1.159s-2.048-.387-2.829-1.16a3.933 3.933 0 0 1 .001-5.602c5.522-5.467 8.564-12.736 8.564-20.468s-3.042-15.001-8.564-20.468a3.935 3.935 0 0 1-.001-5.602 4.03 4.03 0 0 1 5.657-.001z"></path>
      </g>
    </svg>
  ),
  binocular: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.5312 11.8647C18.4791 11.719 18.4177 11.5768 18.3477 11.4389L15.0984 4.04669C15.0677 3.9755 15.0237 3.9108 14.9688 3.85607C14.7366 3.62386 14.461 3.43966 14.1576 3.31399C13.8543 3.18832 13.5291 3.12363 13.2008 3.12363C12.8724 3.12363 12.5473 3.18832 12.2439 3.31399C11.9406 3.43966 11.665 3.62386 11.4328 3.85607C11.316 3.973 11.2503 4.13142 11.25 4.29669V6.24982H8.75V4.29669C8.75007 4.21459 8.73395 4.13328 8.70259 4.05741C8.67122 3.98154 8.62521 3.91259 8.56719 3.85451C8.33503 3.6223 8.05941 3.4381 7.75606 3.31243C7.45271 3.18675 7.12757 3.12207 6.79922 3.12207C6.47087 3.12207 6.14573 3.18675 5.84238 3.31243C5.53903 3.4381 5.2634 3.6223 5.03125 3.85451C4.97631 3.90924 4.9323 3.97393 4.90156 4.04513L1.65234 11.4373C1.58226 11.5752 1.52094 11.7175 1.46875 11.8631C1.28477 12.3779 1.21556 12.9267 1.26599 13.471C1.31641 14.0154 1.48524 14.5421 1.76066 15.0144C2.03608 15.4866 2.41141 15.8929 2.86038 16.2048C3.30934 16.5168 3.82107 16.7267 4.35973 16.8201C4.89839 16.9134 5.45094 16.8879 5.97867 16.7452C6.50641 16.6025 6.99657 16.3462 7.41482 15.9941C7.83307 15.6421 8.16929 15.2029 8.39993 14.7072C8.63057 14.2116 8.75005 13.6715 8.75 13.1248V7.49982H11.25V13.1248C11.2497 13.6716 11.369 14.2118 11.5995 14.7076C11.83 15.2033 12.1661 15.6427 12.5843 15.995C13.0025 16.3472 13.4926 16.6037 14.0204 16.7465C14.5481 16.8893 15.1008 16.915 15.6395 16.8218C16.1782 16.7285 16.6901 16.5186 17.1391 16.2067C17.5882 15.8949 17.9636 15.4885 18.2391 15.0163C18.5146 14.544 18.6835 14.0172 18.734 13.4728C18.7845 12.9284 18.7153 12.3795 18.5312 11.8647ZM5.99297 4.66779C6.20134 4.49234 6.46133 4.38975 6.73337 4.37565C7.0054 4.36155 7.2746 4.4367 7.5 4.58966V10.3326C7.01203 9.89447 6.41748 9.59223 5.77592 9.45622C5.13436 9.3202 4.46832 9.35517 3.84453 9.55763L5.99297 4.66779ZM5 15.6248C4.50555 15.6248 4.0222 15.4782 3.61107 15.2035C3.19995 14.9288 2.87952 14.5383 2.6903 14.0815C2.50108 13.6247 2.45157 13.122 2.54804 12.6371C2.6445 12.1521 2.8826 11.7067 3.23223 11.3571C3.58186 11.0074 4.02732 10.7693 4.51227 10.6729C4.99723 10.5764 5.49989 10.6259 5.95671 10.8151C6.41352 11.0043 6.80397 11.3248 7.07867 11.7359C7.35338 12.147 7.5 12.6304 7.5 13.1248C7.5 13.7879 7.23661 14.4237 6.76777 14.8926C6.29893 15.3614 5.66304 15.6248 5 15.6248ZM12.5 4.58888C12.7254 4.43592 12.9946 4.36077 13.2666 4.37487C13.5387 4.38897 13.7987 4.49155 14.007 4.66701L16.1555 9.55607C15.5316 9.35371 14.8655 9.31886 14.224 9.45502C13.5824 9.59118 12.9879 9.89355 12.5 10.3318V4.58888ZM15 15.6248C14.5055 15.6248 14.0222 15.4782 13.6111 15.2035C13.2 14.9288 12.8795 14.5383 12.6903 14.0815C12.5011 13.6247 12.4516 13.122 12.548 12.6371C12.6445 12.1521 12.8826 11.7067 13.2322 11.3571C13.5819 11.0074 14.0273 10.7693 14.5123 10.6729C14.9972 10.5764 15.4999 10.6259 15.9567 10.8151C16.4135 11.0043 16.804 11.3248 17.0787 11.7359C17.3534 12.147 17.5 12.6304 17.5 13.1248C17.5 13.7879 17.2366 14.4237 16.7678 14.8926C16.2989 15.3614 15.663 15.6248 15 15.6248Z"
        fill="black"
      />
    </svg>
  ),
  cubeFocus: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 12.2992V7.70078C15.0004 7.52335 14.9543 7.34892 14.8663 7.19485C14.7783 7.04079 14.6515 6.91246 14.4984 6.82266L10.4875 4.50625C10.3393 4.42068 10.1711 4.37562 10 4.37562C9.82885 4.37562 9.66072 4.42068 9.5125 4.50625L5.50234 6.82266C5.34918 6.91236 5.2222 7.04065 5.13406 7.19472C5.04592 7.34879 4.99969 7.52328 5 7.70078V12.2992C4.99961 12.4766 5.04572 12.6511 5.13372 12.8051C5.22172 12.9592 5.34854 13.0875 5.50156 13.1773L9.5125 15.4938C9.66074 15.5792 9.82887 15.6243 10 15.6243C10.1711 15.6243 10.3393 15.5792 10.4875 15.4938L14.4977 13.1773C14.6508 13.0876 14.7778 12.9594 14.8659 12.8053C14.9541 12.6512 15.0003 12.4767 15 12.2992ZM10 5.66797L13.1711 7.5L10 9.33047L6.82891 7.5L10 5.66797ZM6.25 8.60859L9.375 10.4133V13.9711L6.25 12.1664V8.60859ZM10.625 13.9711V10.4133L13.75 8.60859V12.1664L10.625 13.9711ZM18.125 3.75V6.875C18.125 7.04076 18.0592 7.19973 17.9419 7.31694C17.8247 7.43415 17.6658 7.5 17.5 7.5C17.3342 7.5 17.1753 7.43415 17.0581 7.31694C16.9408 7.19973 16.875 7.04076 16.875 6.875V4.375H14.375C14.2092 4.375 14.0503 4.30915 13.9331 4.19194C13.8158 4.07473 13.75 3.91576 13.75 3.75C13.75 3.58424 13.8158 3.42527 13.9331 3.30806C14.0503 3.19085 14.2092 3.125 14.375 3.125H17.5C17.6658 3.125 17.8247 3.19085 17.9419 3.30806C18.0592 3.42527 18.125 3.58424 18.125 3.75ZM6.25 16.25C6.25 16.4158 6.18415 16.5747 6.06694 16.6919C5.94973 16.8092 5.79076 16.875 5.625 16.875H2.5C2.33424 16.875 2.17527 16.8092 2.05806 16.6919C1.94085 16.5747 1.875 16.4158 1.875 16.25V13.125C1.875 12.9592 1.94085 12.8003 2.05806 12.6831C2.17527 12.5658 2.33424 12.5 2.5 12.5C2.66576 12.5 2.82473 12.5658 2.94194 12.6831C3.05915 12.8003 3.125 12.9592 3.125 13.125V15.625H5.625C5.79076 15.625 5.94973 15.6908 6.06694 15.8081C6.18415 15.9253 6.25 16.0842 6.25 16.25ZM18.125 13.125V16.25C18.125 16.4158 18.0592 16.5747 17.9419 16.6919C17.8247 16.8092 17.6658 16.875 17.5 16.875H14.375C14.2092 16.875 14.0503 16.8092 13.9331 16.6919C13.8158 16.5747 13.75 16.4158 13.75 16.25C13.75 16.0842 13.8158 15.9253 13.9331 15.8081C14.0503 15.6908 14.2092 15.625 14.375 15.625H16.875V13.125C16.875 12.9592 16.9408 12.8003 17.0581 12.6831C17.1753 12.5658 17.3342 12.5 17.5 12.5C17.6658 12.5 17.8247 12.5658 17.9419 12.6831C18.0592 12.8003 18.125 12.9592 18.125 13.125ZM1.875 6.875V3.75C1.875 3.58424 1.94085 3.42527 2.05806 3.30806C2.17527 3.19085 2.33424 3.125 2.5 3.125H5.625C5.79076 3.125 5.94973 3.19085 6.06694 3.30806C6.18415 3.42527 6.25 3.58424 6.25 3.75C6.25 3.91576 6.18415 4.07473 6.06694 4.19194C5.94973 4.30915 5.79076 4.375 5.625 4.375H3.125V6.875C3.125 7.04076 3.05915 7.19973 2.94194 7.31694C2.82473 7.43415 2.66576 7.5 2.5 7.5C2.33424 7.5 2.17527 7.43415 2.05806 7.31694C1.94085 7.19973 1.875 7.04076 1.875 6.875Z"
        fill="black"
      />
    </svg>
  ),
  diamond: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.2193 7.71328L14.8443 2.71328C14.7858 2.64647 14.7137 2.59289 14.6329 2.55612C14.5521 2.51934 14.4643 2.50021 14.3755 2.5H5.62555C5.53675 2.50021 5.44901 2.51934 5.36818 2.55612C5.28735 2.59289 5.21529 2.64647 5.1568 2.71328L0.781795 7.71328C0.679731 7.82981 0.624578 7.98009 0.627032 8.13498C0.629486 8.28987 0.689372 8.43832 0.795077 8.55156L9.54508 17.9266C9.60356 17.9893 9.67431 18.0392 9.75293 18.0734C9.83156 18.1076 9.91638 18.1252 10.0021 18.1252C10.0878 18.1252 10.1727 18.1076 10.2513 18.0734C10.3299 18.0392 10.4007 17.9893 10.4591 17.9266L19.2091 8.55156C19.3144 8.43793 19.3737 8.28926 19.3756 8.13438C19.3775 7.97949 19.3218 7.82943 19.2193 7.71328ZM17.3732 7.5H14.063L11.2505 3.75H14.092L17.3732 7.5ZM5.82711 8.75L8.18101 14.6352L2.68883 8.75H5.82711ZM12.8271 8.75L10.0005 15.8172L7.17398 8.75H12.8271ZM7.50055 7.5L10.0005 4.16641L12.5005 7.5H7.50055ZM14.174 8.75H17.3123L11.8201 14.6352L14.174 8.75ZM5.90914 3.75H8.75055L5.93805 7.5H2.62789L5.90914 3.75Z"
        fill="#121418"
      />
    </svg>
  ),
  web: (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.3281 2.64062C8.72116 2.64063 7.15027 3.11715 5.81412 4.00993C4.47797 4.90272 3.43657 6.17167 2.82161 7.65632C2.20665 9.14097 2.04574 10.7746 2.35925 12.3507C2.67275 13.9268 3.44658 15.3746 4.58289 16.5109C5.71919 17.6472 7.16692 18.421 8.74302 18.7345C10.3191 19.048 11.9528 18.8871 13.4374 18.2721C14.9221 17.6572 16.191 16.6158 17.0838 15.2796C17.9766 13.9435 18.4531 12.3726 18.4531 10.7656C18.4509 8.61144 17.5941 6.54613 16.0709 5.02289C14.5476 3.49965 12.4823 2.6429 10.3281 2.64062ZM17.1758 10.1547C16.9768 10.1453 16.7776 10.1406 16.5781 10.1406C15.4188 10.141 14.2645 10.2944 13.1453 10.5969C12.8725 9.78717 12.5205 9.00632 12.0945 8.26562C13.2055 7.59572 14.2111 6.76511 15.0789 5.80078C16.283 6.94958 17.0283 8.49703 17.1758 10.1547ZM14.1 5.02031C13.3193 5.87811 12.417 6.61671 11.4219 7.2125C10.5884 6.03939 9.56902 5.01023 8.40391 4.16563C9.35971 3.8866 10.3647 3.81852 11.3494 3.96609C12.3341 4.11366 13.275 4.47336 14.107 5.02031H14.1ZM7.01954 4.74063C8.29656 5.54484 9.40989 6.58342 10.3008 7.80156C8.74159 8.52019 7.04497 8.89177 5.32813 8.89062C4.79826 8.89035 4.26898 8.85512 3.74375 8.78516C4.26638 7.06133 5.44189 5.60995 7.01954 4.74063ZM3.45313 10.7656C3.4531 10.514 3.46692 10.2626 3.49453 10.0125C4.10201 10.0978 4.71469 10.1406 5.32813 10.1406C7.28871 10.1425 9.22475 9.70465 10.9938 8.85938C11.3835 9.53241 11.7056 10.2424 11.9555 10.9789C11.2916 11.2283 10.6491 11.5314 10.0344 11.8852C8.31959 12.8758 6.84927 14.2391 5.73203 15.8742C5.01458 15.2306 4.44083 14.443 4.04817 13.5628C3.6555 12.6826 3.45275 11.7295 3.45313 10.7656ZM6.73438 16.625C7.74872 15.1248 9.09088 13.8748 10.6594 12.9695C11.1838 12.6669 11.731 12.4057 12.2961 12.1883C12.4895 13.0465 12.5872 13.9234 12.5875 14.8031C12.5879 15.6584 12.4965 16.5112 12.3148 17.3469C11.3864 17.6273 10.4091 17.708 9.4473 17.5836C8.48546 17.4592 7.56087 17.1325 6.73438 16.625ZM13.6922 16.7602C13.7886 16.1136 13.8372 15.4608 13.8375 14.807C13.8374 13.7952 13.7207 12.7867 13.4898 11.8016C14.4968 11.5298 15.5351 11.3917 16.5781 11.3906C16.776 11.3906 16.9742 11.3956 17.1727 11.4055C17.068 12.5126 16.6968 13.5779 16.0906 14.5103C15.4845 15.4427 14.6616 16.2144 13.6922 16.7594V16.7602Z"
        fill="white"
      />
    </svg>
  ),
  messenger: (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.9578 9.07303C15.0159 9.13108 15.062 9.20001 15.0935 9.27588C15.1249 9.35176 15.1411 9.43309 15.1411 9.51522C15.1411 9.59736 15.1249 9.67869 15.0935 9.75456C15.062 9.83043 15.0159 9.89936 14.9578 9.95741L12.4578 12.4574C12.3998 12.5155 12.3308 12.5616 12.255 12.5931C12.1791 12.6245 12.0978 12.6407 12.0156 12.6407C11.9335 12.6407 11.8522 12.6245 11.7763 12.5931C11.7004 12.5616 11.6315 12.5155 11.5734 12.4574L9.51562 10.3988L7.45781 12.4574C7.34054 12.5747 7.18148 12.6406 7.01562 12.6406C6.84977 12.6406 6.69071 12.5747 6.57344 12.4574C6.45616 12.3401 6.39028 12.1811 6.39028 12.0152C6.39028 11.8494 6.45616 11.6903 6.57344 11.573L9.07344 9.07303C9.13148 9.01492 9.20041 8.96883 9.27629 8.93737C9.35216 8.90592 9.43349 8.88973 9.51562 8.88973C9.59776 8.88973 9.67909 8.90592 9.75496 8.93737C9.83084 8.96883 9.89977 9.01492 9.95781 9.07303L12.0156 11.1316L14.0734 9.07303C14.1315 9.01492 14.2004 8.96883 14.2763 8.93737C14.3522 8.90592 14.4335 8.88973 14.5156 8.88973C14.5978 8.88973 14.6791 8.90592 14.755 8.93737C14.8308 8.96883 14.8998 9.01492 14.9578 9.07303ZM18.8906 10.7652C18.8909 12.168 18.5281 13.5469 17.8373 14.7678C17.1466 15.9887 16.1515 17.01 14.949 17.7323C13.7464 18.4545 12.3774 18.8531 10.9751 18.8893C9.57282 18.9255 8.18504 18.598 6.94688 17.9387L4.28672 18.8254C4.06647 18.8988 3.83012 18.9095 3.60416 18.8562C3.3782 18.8028 3.17155 18.6876 3.00738 18.5235C2.84321 18.3593 2.72801 18.1526 2.67469 17.9267C2.62136 17.7007 2.63202 17.4644 2.70547 17.2441L3.59219 14.584C3.01262 13.4943 2.6889 12.2869 2.64562 11.0535C2.60234 9.82003 2.84063 8.59293 3.3424 7.46533C3.84417 6.33772 4.59623 5.33924 5.5415 4.54568C6.48677 3.75213 7.6004 3.18434 8.79787 2.88544C9.99533 2.58653 11.2452 2.56435 12.4525 2.82059C13.6598 3.07682 14.7929 3.60474 15.7657 4.36426C16.7385 5.12378 17.5255 6.09495 18.067 7.20405C18.6084 8.31314 18.8901 9.53101 18.8906 10.7652ZM17.6406 10.7652C17.6403 9.71063 17.3974 8.67024 16.9307 7.72455C16.464 6.77886 15.7859 5.95322 14.9491 5.3115C14.1122 4.66978 13.1389 4.22918 12.1045 4.02381C11.0701 3.81843 10.0023 3.85377 8.98378 4.1271C7.96522 4.40042 7.0232 4.90441 6.23059 5.60006C5.43798 6.29571 4.81603 7.16438 4.41286 8.13886C4.00969 9.11335 3.83611 10.1675 3.90554 11.2198C3.97498 12.2721 4.28557 13.2943 4.81328 14.2074C4.85757 14.2841 4.88507 14.3693 4.89396 14.4573C4.90285 14.5454 4.89293 14.6344 4.86484 14.7183L3.89062 17.6402L6.8125 16.6652C6.89651 16.6373 6.98551 16.6275 7.07359 16.6365C7.16168 16.6455 7.24684 16.6731 7.32344 16.7176C8.36857 17.3221 9.55448 17.6407 10.7618 17.6413C11.9692 17.642 13.1555 17.3247 14.2013 16.7213C15.2471 16.118 16.1155 15.2499 16.7193 14.2043C17.3231 13.1587 17.6408 11.9726 17.6406 10.7652Z"
        fill="white"
      />
    </svg>
  ),
  messanger: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_248_927)">
        <path
          d="M5.07863 9.35733C5.02683 9.02352 4.99996 8.68155 4.99996 8.33333C4.99996 4.65144 8.00436 1.66667 11.7105 1.66667C15.4166 1.66667 18.421 4.65144 18.421 8.33333C18.421 9.16506 18.2677 9.96121 17.9876 10.6954C17.9295 10.8479 17.9004 10.9242 17.8872 10.9837C17.8741 11.0427 17.869 11.0841 17.8676 11.1445C17.8662 11.2055 17.8744 11.2726 17.891 11.4069L18.2264 14.1321C18.2628 14.4271 18.2809 14.5746 18.2319 14.6819C18.1889 14.7758 18.1125 14.8504 18.0176 14.8913C17.9092 14.9378 17.7622 14.9163 17.4681 14.8732L14.8137 14.4841C14.6751 14.4638 14.6058 14.4536 14.5427 14.454C14.4803 14.4543 14.4371 14.4589 14.3759 14.4718C14.3142 14.4848 14.2353 14.5143 14.0775 14.5734C13.3414 14.8491 12.5437 15 11.7105 15C11.362 15 11.0197 14.9736 10.6855 14.9227M6.35964 18.3333C8.83039 18.3333 10.8333 16.2813 10.8333 13.75C10.8333 11.2187 8.83039 9.16667 6.35964 9.16667C3.88889 9.16667 1.88595 11.2187 1.88595 13.75C1.88595 14.2588 1.96689 14.7483 2.11628 15.2056C2.17943 15.3989 2.21101 15.4956 2.22137 15.5616C2.23219 15.6306 2.23409 15.6693 2.23006 15.7389C2.2262 15.8057 2.2095 15.8811 2.17611 16.0319L1.66666 18.3333L4.16232 17.9925C4.29854 17.9739 4.36665 17.9646 4.42613 17.965C4.48876 17.9654 4.522 17.9688 4.58341 17.9811C4.64174 17.9927 4.72846 18.0233 4.90188 18.0845C5.35882 18.2458 5.84925 18.3333 6.35964 18.3333Z"
          stroke="#344054"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip0_248_927">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  tiktok: (
    <svg
      width="21"
      height="21"
      fill="#000000"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M16.656 1.029c1.637-0.025 3.262-0.012 4.886-0.025 0.054 2.031 0.878 3.859 2.189 5.213l-0.002-0.002c1.411 1.271 3.247 2.095 5.271 2.235l0.028 0.002v5.036c-1.912-0.048-3.71-0.489-5.331-1.247l0.082 0.034c-0.784-0.377-1.447-0.764-2.077-1.196l0.052 0.034c-0.012 3.649 0.012 7.298-0.025 10.934-0.103 1.853-0.719 3.543-1.707 4.954l0.020-0.031c-1.652 2.366-4.328 3.919-7.371 4.011l-0.014 0c-0.123 0.006-0.268 0.009-0.414 0.009-1.73 0-3.347-0.482-4.725-1.319l0.040 0.023c-2.508-1.509-4.238-4.091-4.558-7.094l-0.004-0.041c-0.025-0.625-0.037-1.25-0.012-1.862 0.49-4.779 4.494-8.476 9.361-8.476 0.547 0 1.083 0.047 1.604 0.136l-0.056-0.008c0.025 1.849-0.050 3.699-0.050 5.548-0.423-0.153-0.911-0.242-1.42-0.242-1.868 0-3.457 1.194-4.045 2.861l-0.009 0.030c-0.133 0.427-0.21 0.918-0.21 1.426 0 0.206 0.013 0.41 0.037 0.61l-0.002-0.024c0.332 2.046 2.086 3.59 4.201 3.59 0.061 0 0.121-0.001 0.181-0.004l-0.009 0c1.463-0.044 2.733-0.831 3.451-1.994l0.010-0.018c0.267-0.372 0.45-0.822 0.511-1.311l0.001-0.014c0.125-2.237 0.075-4.461 0.087-6.698 0.012-5.036-0.012-10.060 0.025-15.083z"
          fill="#000000"
        ></path>
      </g>
    </svg>
  ),
  quote: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M8.09 11.6314H3.4C3.48 6.96144 4.4 6.19144 7.27 4.49144C7.6 4.29144 7.71 3.87144 7.51 3.53144C7.32 3.20144 6.89 3.09144 6.56 3.29144C3.18 5.29144 2 6.51144 2 12.3214V17.7114C2 19.4214 3.39 20.8014 5.09 20.8014H8.09C9.85 20.8014 11.18 19.4714 11.18 17.7114V14.7114C11.18 12.9614 9.85 11.6314 8.09 11.6314Z"
          fill="#292D32"
        ></path>{' '}
        <path
          d="M18.9086 11.6314H14.2186C14.2986 6.96144 15.2186 6.19144 18.0886 4.49144C18.4186 4.29144 18.5286 3.87144 18.3286 3.53144C18.1286 3.20144 17.7086 3.09144 17.3686 3.29144C13.9886 5.29144 12.8086 6.51144 12.8086 12.3314V17.7214C12.8086 19.4314 14.1986 20.8114 15.8986 20.8114H18.8986C20.6586 20.8114 21.9886 19.4814 21.9886 17.7214V14.7214C21.9986 12.9614 20.6686 11.6314 18.9086 11.6314Z"
          fill="#292D32"
        ></path>{' '}
      </g>
    </svg>
  ),
  question: (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M11.5801 14.7148C11.5801 14.9003 11.5251 15.0815 11.4221 15.2357C11.3191 15.3899 11.1727 15.51 11.0013 15.581C10.83 15.6519 10.6415 15.6705 10.4597 15.6343C10.2778 15.5982 10.1108 15.5089 9.97967 15.3778C9.84856 15.2466 9.75927 15.0796 9.7231 14.8977C9.68692 14.7159 9.70549 14.5274 9.77644 14.3561C9.8474 14.1848 9.96756 14.0384 10.1217 13.9353C10.2759 13.8323 10.4572 13.7773 10.6426 13.7773C10.8912 13.7773 11.1297 13.8761 11.3055 14.0519C11.4813 14.2277 11.5801 14.4662 11.5801 14.7148ZM10.6426 6.27734C8.91914 6.27734 7.51758 7.53906 7.51758 9.08984V9.40234C7.51758 9.5681 7.58343 9.72708 7.70064 9.84429C7.81785 9.9615 7.97682 10.0273 8.14258 10.0273C8.30834 10.0273 8.46731 9.9615 8.58452 9.84429C8.70173 9.72708 8.76758 9.5681 8.76758 9.40234V9.08984C8.76758 8.23047 9.60899 7.52734 10.6426 7.52734C11.6762 7.52734 12.5176 8.23047 12.5176 9.08984C12.5176 9.94922 11.6762 10.6523 10.6426 10.6523C10.4768 10.6523 10.3179 10.7182 10.2006 10.8354C10.0834 10.9526 10.0176 11.1116 10.0176 11.2773V11.9023C10.0176 12.0681 10.0834 12.2271 10.2006 12.3443C10.3179 12.4615 10.4768 12.5273 10.6426 12.5273C10.8083 12.5273 10.9673 12.4615 11.0845 12.3443C11.2017 12.2271 11.2676 12.0681 11.2676 11.9023V11.8461C12.6926 11.5844 13.7676 10.4477 13.7676 9.08984C13.7676 7.53906 12.366 6.27734 10.6426 6.27734ZM18.7676 10.6523C18.7676 12.2593 18.2911 13.8302 17.3983 15.1664C16.5055 16.5025 15.2365 17.5439 13.7519 18.1589C12.2672 18.7738 10.6336 18.9347 9.05747 18.6212C7.48138 18.3077 6.03364 17.5339 4.89734 16.3976C3.76104 15.2613 2.98721 13.8135 2.6737 12.2375C2.3602 10.6614 2.5211 9.02769 3.13606 7.54304C3.75102 6.05839 4.79242 4.78944 6.12857 3.89665C7.46472 3.00387 9.03561 2.52734 10.6426 2.52734C12.7968 2.52962 14.8621 3.38637 16.3853 4.90961C17.9086 6.43285 18.7653 8.49816 18.7676 10.6523ZM17.5176 10.6523C17.5176 9.2926 17.1144 7.96339 16.3589 6.8328C15.6035 5.70221 14.5298 4.82102 13.2735 4.30067C12.0173 3.78032 10.635 3.64417 9.30134 3.90944C7.96772 4.17472 6.74271 4.8295 5.78122 5.79098C4.81974 6.75247 4.16496 7.97748 3.89968 9.3111C3.63441 10.6447 3.77056 12.0271 4.29091 13.2833C4.81126 14.5395 5.69245 15.6133 6.82304 16.3687C7.95362 17.1241 9.28284 17.5273 10.6426 17.5273C12.4653 17.5253 14.2128 16.8003 15.5017 15.5114C16.7905 14.2226 17.5155 12.4751 17.5176 10.6523Z"
          fill="white"
        />
      </g>
    </svg>
  ),
  whiteLogo: (
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1949 1.78699L12.1964 1.78269L12.1269 1.82278L12.1949 1.78699ZM8.8218 1.89077L2.55713 12.7398L2.77931 12.5291L3.03959 12.2995L3.30928 12.075L3.58365 11.859L3.86796 11.6495L4.16199 11.451L4.45116 11.2645L4.75068 11.0834L5.05934 10.9107L5.37166 10.7494L5.68547 10.6035L6.00475 10.4584L6.33015 10.3265L6.65894 10.2052L6.99196 10.0942L7.32753 9.99349L7.66318 9.90301L8.00276 9.82251L8.34332 9.75527L8.6841 9.69701L9.0291 9.64732L9.37539 9.61079L9.72075 9.58298L10.069 9.56976H10.7606L11.1102 9.58298L11.4556 9.61079L11.8019 9.64732L12.1469 9.69701L12.488 9.75532L12.8314 9.824L12.9622 9.85502L12.9953 9.72939L13.0727 9.39988L13.1402 9.07097L13.1977 8.73825L13.244 8.40478L13.2777 8.07159L13.3045 7.73319L13.3213 7.39926V6.7234L13.3059 6.38808L13.2792 6.05195L13.2441 5.7164L13.1965 5.3858L13.1374 5.05123L13.0699 4.72332L12.9925 4.39417L12.9056 4.06894L12.8061 3.74678L12.6963 3.42862L12.5796 3.11369L12.4509 2.8017L12.3103 2.49522L12.1624 2.18954L12.0036 1.88758L12.0065 1.88608C11.8452 1.6083 11.6139 1.37757 11.3357 1.21687C11.0559 1.05529 10.7386 0.970215 10.4155 0.970215C10.0924 0.970215 9.77507 1.05529 9.49531 1.21687C9.21556 1.37845 8.98323 1.61093 8.8218 1.89077ZM0.964814 15.0718L0.957652 15.069L0.986001 15.0854L0.964814 15.0718ZM14.9833 17.8568L15.2665 17.9418H2.74426L2.74357 17.9418C2.41962 17.9428 2.10113 17.8583 1.82026 17.6969C1.53939 17.5355 1.30608 17.3028 1.14388 17.0224C0.981686 16.742 0.896349 16.4237 0.896485 16.0998C0.896619 15.7785 0.980805 15.4629 1.14061 15.1843L1.14686 15.1883L1.32883 14.904L1.51872 14.6227L1.71478 14.3524L1.92423 14.0853L2.13844 13.8246L2.35873 13.572L2.58911 13.3262L2.82676 13.0857L3.07212 12.853L3.3219 12.6327L3.58231 12.4159L3.84665 12.2078L4.11823 12.0076L4.3992 11.818L4.68122 11.6361L4.9691 11.4619L5.26506 11.2964L5.56307 11.1425L5.8662 11.0015L6.17647 10.8605L6.4872 10.7345L6.80312 10.618L7.12344 10.5112L7.44692 10.4142L7.57191 10.3805L7.61092 10.5076L7.71968 10.8369L7.84245 11.1643L7.9722 11.4865L8.11142 11.803L8.26375 12.115L8.42216 12.4245L8.59211 12.7278L8.76914 13.0204L8.95729 13.3099L9.15168 13.6022L9.35715 13.884L9.57213 14.1589L9.79382 14.4244L10.0232 14.6859L10.2611 14.9368L10.5095 15.1882L10.7635 15.4248L11.0264 15.6599L11.2956 15.8823L11.5731 16.0984L11.576 16.1006L11.857 16.3048L12.1466 16.5003L12.44 16.6896L12.743 16.8711L13.0459 17.0378L13.3601 17.2015L13.6758 17.347L13.9961 17.4926L14.3215 17.6245L14.6502 17.7458L14.9833 17.8568ZM19.6783 15.1778L19.6771 15.1785L13.4203 4.34924L13.4862 4.6294L13.5562 4.96918L13.6175 5.31656L13.6673 5.66221L13.7038 6.01149L13.7315 6.3602L13.7477 6.71262V7.40927L13.7301 7.76022L13.7022 8.11191L13.6674 8.45542L13.6191 8.80394L13.5591 9.15037L13.4891 9.49193L13.4089 9.83296L13.3197 10.1724L13.2167 10.5076L13.1093 10.8326L12.9866 11.16L12.8568 11.4822L12.7176 11.7987L12.5635 12.1143L12.4069 12.4202L12.2367 12.7238L12.0584 13.0161L11.8705 13.3075L11.6773 13.5979L11.4719 13.8797L11.2569 14.1546L11.035 14.4203L10.8048 14.6811L10.7134 14.7793L10.8067 14.8737L11.0525 15.1027L11.3042 15.3277L11.5621 15.5407L11.8291 15.7487L12.1011 15.9464L12.3826 16.1364L12.6643 16.3181L12.9544 16.4919L13.2482 16.6536L13.5465 16.809L13.8517 16.9496L13.8527 16.9501L14.1628 17.091L14.4735 17.217L14.7894 17.3335L15.1098 17.4403L15.4323 17.5371L15.7565 17.6213L16.0859 17.6973L16.4147 17.7633L16.7489 17.8195L17.0818 17.8645L17.416 17.8996L17.7517 17.9235L18.0877 17.9374C18.4093 17.9365 18.7251 17.8514 19.0036 17.6905C19.2834 17.5288 19.5157 17.2964 19.6772 17.0165C19.8387 16.7366 19.9237 16.4191 19.9237 16.096C19.9237 15.7737 19.839 15.4571 19.6783 15.1778Z"
        fill="white"
      />
    </svg>
  ),
  rightAngle: (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.15209 9.10823L4.49468 8.4572L6.4637 6.48818H1.67997V5.53718H6.4637L4.49468 3.57135L5.15209 2.91714L8.24763 6.01268L5.15209 9.10823Z"
        fill="#121418"
      />
    </svg>
  ),
  upArrow: (
    <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="none"
        d="M7 17V1M7 1L1 7M7 1L13 7"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  downArrow: (
    <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="none"
        d="M7 1V17M7 17L13 11M7 17L1 11"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  rightSliderArrow: (
    <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.3223 10.9013L5.20523 9.79505L8.55102 6.44927H0.422448V4.83332H8.55102L5.20523 1.49296L6.3223 0.381316L11.5823 5.6413L6.3223 10.9013Z"
        fill="#121418"
      />
    </svg>
  ),

  leftSliderArrow: (
    <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.67867 10.9013L6.79574 9.79505L3.44996 6.44927H11.5785V4.83332H3.44996L6.79574 1.49296L5.67867 0.381316L0.418693 5.6413L5.67867 10.9013Z"
        fill="#121418"
      />
    </svg>
  ),
  leftAngle: (
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 13L1 7L7 1"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  rightAngle: (
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 13L7 7L1 1"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  iconFreeShipping: (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      width="24px"
      height="24px"
    >
      <g>
        <g>
          <path
            fill="#303030"
            d="M476.158,286.938l-13.259-53.035c3.625-0.77,6.345-3.986,6.345-7.839v-8.551c0-18.566-15.105-33.67-33.67-33.67h-60.392    v-17.637c0-9.136-7.432-16.568-16.568-16.568H246.32l68.24-27.296c4.111-1.644,6.11-6.31,4.466-10.421    c-1.644-4.11-6.307-6.111-10.421-4.466l-55.874,22.349c17.026-10.924,33.871-22.947,40.284-31.355    c12.485-16.369,9.323-39.843-7.046-52.328c-16.369-12.486-39.843-9.323-52.328,7.046c-9.122,11.962-21.158,45.573-28.948,69.258    c-7.79-23.683-19.826-57.296-28.948-69.258c-12.484-16.369-35.959-19.53-52.328-7.046c-16.369,12.484-19.53,35.958-7.046,52.328    c6.413,8.409,23.257,20.431,40.284,31.355l-55.874-22.349c-4.113-1.647-8.777,0.355-10.421,4.466    c-1.645,4.111,0.355,8.777,4.466,10.421l68.24,27.296H50.772c-9.136,0-16.568,7.432-16.568,16.568v145.37    c0,4.427,3.589,8.017,8.017,8.017c4.427,0,8.017-3.589,8.017-8.017v-145.37c0-0.295,0.239-0.534,0.534-0.534h307.841    c0.295,0,0.534,0.239,0.534,0.534v145.372c0,4.427,3.589,8.017,8.017,8.017c4.427,0,8.017-3.589,8.017-8.017v-9.088h94.566    c0.009,0,0.016,0.002,0.025,0.002s0.017-0.001,0.026-0.001c11.636,0.009,21.516,7.647,24.908,18.171h-24.928    c-4.427,0-8.017,3.589-8.017,8.017v17.102c0,13.851,11.268,25.119,25.119,25.119h9.086v35.273h-20.962    c-6.886-19.882-25.787-34.205-47.982-34.205s-41.097,14.322-47.982,34.205h-3.86V345.78c0-4.427-3.589-8.017-8.017-8.017    c-4.427,0-8.017,3.589-8.017,8.017v60.392H192.817c-6.886-19.882-25.787-34.205-47.982-34.205s-41.097,14.322-47.982,34.205    H50.772c-0.295,0-0.534-0.239-0.534-0.534v-17.637h34.739c4.427,0,8.017-3.589,8.017-8.017s-3.589-8.017-8.017-8.017H8.017    c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h26.188v17.637c0,9.136,7.432,16.568,16.568,16.568h43.304    c-0.002,0.178-0.014,0.355-0.014,0.534c0,27.995,22.777,50.772,50.772,50.772s50.772-22.777,50.772-50.772    c0-0.18-0.012-0.356-0.014-0.534h180.67c-0.002,0.178-0.014,0.355-0.014,0.534c0,27.995,22.777,50.772,50.772,50.772    c27.995,0,50.772-22.777,50.772-50.772c0-0.18-0.012-0.356-0.014-0.534h26.203c4.427,0,8.017-3.589,8.017-8.017v-85.511    C512,307.564,496.423,290.022,476.158,286.938z M172.9,121.059c-31.623-19.651-41.003-28.692-43.78-32.334    c-7.123-9.339-5.319-22.732,4.021-29.855c3.85-2.936,8.388-4.355,12.893-4.355c6.422,0,12.776,2.886,16.963,8.376    c7.755,10.168,19.9,44.391,27.918,69.052C185.504,128.757,179.284,125.028,172.9,121.059z M218.473,131.942    c8.018-24.66,20.163-58.882,27.917-69.052c7.123-9.339,20.516-11.142,29.855-4.02c9.34,7.123,11.143,20.516,4.021,29.855    c-2.777,3.641-12.157,12.683-43.778,32.333C230.105,125.026,223.885,128.756,218.473,131.942z M375.182,199.875h60.392    c9.725,0,17.637,7.912,17.637,17.637v0.534h-78.029V199.875z M375.182,286.456V234.08h71.235l13.094,52.376H375.182z     M144.835,457.479c-19.155,0-34.739-15.584-34.739-34.739s15.584-34.739,34.739-34.739c19.155,0,34.739,15.584,34.739,34.739    S163.99,457.479,144.835,457.479z M427.023,457.479c-19.155,0-34.739-15.584-34.739-34.739s15.584-34.739,34.739-34.739    c19.155,0,34.739,15.584,34.739,34.739S446.178,457.479,427.023,457.479z M495.967,354.865h-9.086    c-5.01,0-9.086-4.076-9.086-9.086v-9.086h18.171V354.865z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#303030"
            d="M144.835,406.172c-9.136,0-16.568,7.432-16.568,16.568s7.432,16.568,16.568,16.568c9.136,0,16.568-7.432,16.568-16.568    S153.971,406.172,144.835,406.172z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#303030"
            d="M427.023,406.172c-9.136,0-16.568,7.432-16.568,16.568s7.432,16.568,16.568,16.568c9.136,0,16.568-7.432,16.568-16.568    S436.159,406.172,427.023,406.172z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#303030"
            d="M332.96,371.967H213.244c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017H332.96    c4.427,0,8.017-3.589,8.017-8.017S337.388,371.967,332.96,371.967z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#303030"
            d="M127.733,337.763H25.119c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h102.614    c4.427,0,8.017-3.589,8.017-8.017S132.16,337.763,127.733,337.763z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#303030"
            d="M127.733,218.046H93.528c-4.427,0-8.017,3.589-8.017,8.017v68.409c0,4.427,3.589,8.017,8.017,8.017    s8.017-3.589,8.017-8.017v-26.188h17.637c4.427,0,8.017-3.589,8.017-8.017s-3.589-8.017-8.017-8.017h-17.637V234.08h26.188    c4.427,0,8.017-3.589,8.017-8.017C135.749,221.636,132.16,218.046,127.733,218.046z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#303030"
            d="M190.822,272.043c8.023-5.255,13.337-14.317,13.337-24.602c0-16.209-13.186-29.395-29.395-29.395h-21.378    c-4.427,0-8.017,3.589-8.017,8.017v68.409c0,4.427,3.589,8.017,8.017,8.017s8.017-3.589,8.017-8.017v-17.637h13.346l14.722,22.083    c1.545,2.317,4.086,3.571,6.677,3.571c1.529,0,3.073-0.436,4.439-1.348c3.685-2.455,4.68-7.433,2.223-11.116L190.822,272.043z     M174.764,260.802h-13.361V234.08h13.361c7.368,0,13.361,5.993,13.361,13.361C188.125,254.809,182.132,260.802,174.764,260.802z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#303030"
            d="M256,286.456h-26.188v-18.198c0.177,0.012,0.354,0.027,0.534,0.027h17.102c4.427,0,8.017-3.589,8.017-8.017    s-3.589-8.017-8.017-8.017h-17.102c-0.181,0-0.357,0.015-0.534,0.027V234.08H256c4.427,0,8.017-3.589,8.017-8.017    c0-4.427-3.589-8.017-8.017-8.017h-34.205c-4.427,0-8.017,3.589-8.017,8.017v68.409c0,4.427,3.589,8.017,8.017,8.017H256    c4.427,0,8.017-3.589,8.017-8.017S260.427,286.456,256,286.456z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#303030"
            d="M315.858,286.456H289.67v-18.171h9.086c4.427,0,8.017-3.589,8.017-8.017s-3.589-8.017-8.017-8.017h-9.086V234.08h26.188    c4.427,0,8.017-3.589,8.017-8.017c0-4.427-3.589-8.017-8.017-8.017h-34.205c-4.427,0-8.017,3.589-8.017,8.017v68.409    c0,4.427,3.589,8.017,8.017,8.017h34.205c4.427,0,8.017-3.589,8.017-8.017S320.285,286.456,315.858,286.456z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  ),
  download: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.66666 14.1667L9.99999 17.5M9.99999 17.5L13.3333 14.1667M9.99999 17.5V10M16.6667 13.9524C17.6846 13.1117 18.3333 11.8399 18.3333 10.4167C18.3333 7.88536 16.2813 5.83333 13.75 5.83333C13.5679 5.83333 13.3975 5.73833 13.3051 5.58145C12.2184 3.73736 10.212 2.5 7.91666 2.5C4.46488 2.5 1.66666 5.29822 1.66666 8.75C1.66666 10.4718 2.36286 12.0309 3.48911 13.1613"
        stroke="#344054"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  downAngle: (
    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 1L6.29289 6.29289C6.62623 6.62623 6.79289 6.79289 7 6.79289C7.20711 6.79289 7.37377 6.62623 7.70711 6.29289L13 1"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  upAngle: (
    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 7L6.29289 1.70711C6.62623 1.37377 6.79289 1.20711 7 1.20711C7.20711 1.20711 7.37377 1.37377 7.70711 1.70711L13 7"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  cart: (
    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.919922 1H2.30561C2.81529 1 3.2613 1.34265 3.39262 1.83513L3.77582 3.27209M6.16992 12.25C4.51307 12.25 3.16992 13.5931 3.16992 15.25H18.9199M6.16992 12.25H17.3882C18.5093 9.94936 19.4876 7.56635 20.3116 5.1125C15.55 3.89646 10.5604 3.25 5.41992 3.25C4.87013 3.25 4.32206 3.2574 3.77582 3.27209M6.16992 12.25L3.77582 3.27209M4.66992 18.25C4.66992 18.6642 4.33414 19 3.91992 19C3.50571 19 3.16992 18.6642 3.16992 18.25C3.16992 17.8358 3.50571 17.5 3.91992 17.5C4.33414 17.5 4.66992 17.8358 4.66992 18.25ZM17.4199 18.25C17.4199 18.6642 17.0841 19 16.6699 19C16.2557 19 15.9199 18.6642 15.9199 18.25C15.9199 17.8358 16.2557 17.5 16.6699 17.5C17.0841 17.5 17.4199 17.8358 17.4199 18.25Z"
        stroke="#89898A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  bell: (
    <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.1684 17.0817C14.0629 16.857 15.8898 16.4116 17.6227 15.7719C16.1859 14.177 15.3113 12.0656 15.3113 9.75V9.04919C15.3115 9.03281 15.3115 9.01641 15.3115 9C15.3115 5.68629 12.6252 3 9.31152 3C5.99781 3 3.31152 5.68629 3.31152 9L3.31133 9.75C3.31133 12.0656 2.4368 14.177 1 15.7719C2.73293 16.4116 4.55996 16.857 6.45466 17.0818M12.1684 17.0817C11.2315 17.1928 10.2781 17.25 9.31133 17.25C8.34469 17.25 7.3914 17.1929 6.45466 17.0818M12.1684 17.0817C12.2613 17.3711 12.3115 17.6797 12.3115 18C12.3115 19.6569 10.9684 21 9.31152 21C7.65467 21 6.31152 19.6569 6.31152 18C6.31152 17.6797 6.36171 17.3712 6.45466 17.0818"
        stroke="#89898A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <circle cx="4.5" cy="4.5" r="3.93789" fill="#0055FF" stroke="white" strokeWidth="1.12422" />
    </svg>
  ),
  eyeOpen: (
    <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.544 7.04498C20.848 7.4713 21 7.68447 21 8C21 8.31553 20.848 8.52869 20.544 8.95501C19.1779 10.8706 15.6892 15 11 15C6.31078 15 2.8221 10.8706 1.45604 8.95502C1.15201 8.5287 1 8.31553 1 8C1 7.68447 1.15201 7.47131 1.45604 7.04499C2.8221 5.12944 6.31078 1 11 1C15.6892 1 19.1779 5.12944 20.544 7.04498Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M14 8C14 6.34315 12.6569 5 11 5C9.34315 5 8 6.34315 8 8C8 9.65685 9.34315 11 11 11C12.6569 11 14 9.65685 14 8Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        fill="none"
      />
    </svg>
  ),
  eyeClose: (
    <svg width="22" height="10" viewBox="0 0 22 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 1C21 1 17 7 11 7C5 7 1 1 1 1"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M14 6.5L15.5 9"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M19 4L21 6"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M1 6L3 4"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M8 6.5L6.5 9"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  templates: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.6699 9.37695H9.4812V14.5657H14.6699V9.37695Z"
        stroke="#121418"
        strokeWidth="1.11187"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M6.51623 9.37695H1.32751V14.5657H6.51623V9.37695Z"
        stroke="#121418"
        strokeWidth="1.11187"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14.6699 1.22363H9.4812V6.41235H14.6699V1.22363Z"
        stroke="#121418"
        strokeWidth="1.11187"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M6.51623 1.22363H1.32751V6.41235H6.51623V1.22363Z"
        stroke="#121418"
        strokeWidth="1.11187"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  profile: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>
        <path
          d="M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>
      </g>
    </svg>
  ),
  addUser: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M20 18L17 18M17 18L14 18M17 18V15M17 18V21M11 21H4C4 17.134 7.13401 14 11 14C11.695 14 12.3663 14.1013 13 14.2899M15 7C15 9.20914 13.2091 11 11 11C8.79086 11 7 9.20914 7 7C7 4.79086 8.79086 3 11 3C13.2091 3 15 4.79086 15 7Z"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>
      </g>
    </svg>
  ),
  addSocial: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M5 16V20M6 4V8M7 18H3M8 6H4M13 4L14.7528 8.44437C14.9407 8.92083 15.0347 9.15906 15.1786 9.35994C15.3061 9.538 15.462 9.69391 15.6401 9.82143C15.8409 9.9653 16.0792 10.0593 16.5556 10.2472L21 12L16.5556 13.7528C16.0792 13.9407 15.8409 14.0347 15.6401 14.1786C15.462 14.3061 15.3061 14.462 15.1786 14.6401C15.0347 14.8409 14.9407 15.0792 14.7528 15.5556L13 20L11.2472 15.5556C11.0593 15.0792 10.9653 14.8409 10.8214 14.6401C10.6939 14.462 10.538 14.3061 10.3599 14.1786C10.1591 14.0347 9.92083 13.9407 9.44437 13.7528L5 12L9.44437 10.2472C9.92083 10.0593 10.1591 9.9653 10.3599 9.82143C10.538 9.69391 10.6939 9.538 10.8214 9.35994C10.9653 9.15906 11.0593 8.92083 11.2472 8.44437L13 4Z"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>
      </g>
    </svg>
  ),
  phone: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M10.0376 5.31617L10.6866 6.4791C11.2723 7.52858 11.0372 8.90532 10.1147 9.8278C10.1147 9.8278 10.1147 9.8278 10.1147 9.8278C10.1146 9.82792 8.99588 10.9468 11.0245 12.9755C13.0525 15.0035 14.1714 13.8861 14.1722 13.8853C14.1722 13.8853 14.1722 13.8853 14.1722 13.8853C15.0947 12.9628 16.4714 12.7277 17.5209 13.3134L18.6838 13.9624C20.2686 14.8468 20.4557 17.0692 19.0628 18.4622C18.2258 19.2992 17.2004 19.9505 16.0669 19.9934C14.1588 20.0658 10.9183 19.5829 7.6677 16.3323C4.41713 13.0817 3.93421 9.84122 4.00655 7.93309C4.04952 6.7996 4.7008 5.77423 5.53781 4.93723C6.93076 3.54428 9.15317 3.73144 10.0376 5.31617Z"
          stroke="#000000"
          strokeWidth="1"
          strokeLinecap="round"
          fill="none"
        ></path>{' '}
      </g>
    </svg>
  ),
  envelope: (
    <svg
      fill="#000000"
      width="24"
      height="24"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <g>
          {' '}
          <g>
            {' '}
            <path d="M460.8,51.2H51.2C22.921,51.2,0,74.121,0,102.4v307.2c0,28.279,22.921,51.2,51.2,51.2h409.6 c28.279,0,51.2-22.921,51.2-51.2V102.4C512,74.121,489.079,51.2,460.8,51.2z M25.6,148.745L178.825,256L25.6,363.264V148.745z M486.4,409.6c0,14.114-11.486,25.6-25.6,25.6H51.2c-14.114,0-25.6-11.486-25.6-25.6v-15.104l175.548-122.88l47.505,33.254 c4.446,3.098,10.249,3.098,14.703,0l47.505-33.254L486.4,394.496V409.6z M486.4,363.255L333.175,256L486.4,148.736V363.255z M486.4,117.504L256,278.775L25.6,117.504V102.4c0-14.114,11.486-25.6,25.6-25.6h409.6c14.114,0,25.6,11.486,25.6,25.6V117.504z"></path>{' '}
          </g>{' '}
        </g>{' '}
      </g>
    </svg>
  ),
  email: (
    <svg
      width="24"
      height="24"
      viewBox="0 -2.5 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            id="DribbbleLight-Preview"
            transform="translate(-340.000000, -922.000000)"
            fill="#000000"
          >
            <g id="icons" transform="translate(56.000000, 160.000000)">
              <path
                d="M294,774.474 L284,765.649 L284,777 L304,777 L304,765.649 L294,774.474 Z M294.001,771.812 L284,762.981 L284,762 L304,762 L304,762.981 L294.001,771.812 Z"
                id="email-[#1572]"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  mail: (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#F4EBFF" />
      <rect
        x="4"
        y="4"
        width="48"
        height="48"
        rx="24"
        stroke="#F9F5FF"
        strokeWidth="8"
        fill="none"
      />
      <path
        d="M18 23L26.1649 28.7154C26.8261 29.1783 27.1567 29.4097 27.5163 29.4993C27.8339 29.5785 28.1661 29.5785 28.4837 29.4993C28.8433 29.4097 29.1739 29.1783 29.8351 28.7154L38 23M22.8 36H33.2C34.8802 36 35.7202 36 36.362 35.673C36.9265 35.3854 37.3854 34.9265 37.673 34.362C38 33.7202 38 32.8802 38 31.2V24.8C38 23.1198 38 22.2798 37.673 21.638C37.3854 21.0735 36.9265 20.6146 36.362 20.327C35.7202 20 34.8802 20 33.2 20H22.8C21.1198 20 20.2798 20 19.638 20.327C19.0735 20.6146 18.6146 21.0735 18.327 21.638C18 22.2798 18 23.1198 18 24.8V31.2C18 32.8802 18 33.7202 18.327 34.362C18.6146 34.9265 19.0735 35.3854 19.638 35.673C20.2798 36 21.1198 36 22.8 36Z"
        stroke="#7F56D9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  keyboard: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M7 14H17M6 10H6.01M10 10H10.01M14 10H14.01M18 10H18.01M5.2 18H18.8C19.9201 18 20.4802 18 20.908 17.782C21.2843 17.5903 21.5903 17.2843 21.782 16.908C22 16.4802 22 15.9201 22 14.8V9.2C22 8.0799 22 7.51984 21.782 7.09202C21.5903 6.71569 21.2843 6.40973 20.908 6.21799C20.4802 6 19.9201 6 18.8 6H5.2C4.07989 6 3.51984 6 3.09202 6.21799C2.71569 6.40973 2.40973 6.71569 2.21799 7.09202C2 7.51984 2 8.07989 2 9.2V14.8C2 15.9201 2 16.4802 2.21799 16.908C2.40973 17.2843 2.71569 17.5903 3.09202 17.782C3.51984 18 4.0799 18 5.2 18Z"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>
      </g>
    </svg>
  ),
  settings: (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.49852 10.9497C10.6334 10.9497 11.5534 10.0297 11.5534 8.89476C11.5534 7.75986 10.6334 6.83984 9.49852 6.83984C8.36362 6.83984 7.4436 7.75986 7.4436 8.89476C7.4436 10.0297 8.36362 10.9497 9.49852 10.9497Z"
        stroke="#121418"
        strokeWidth="1.75141"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14.8007 11.0445C14.7053 11.2606 14.6768 11.5003 14.719 11.7327C14.7611 11.9652 14.8719 12.1796 15.0371 12.3485L15.0801 12.3915C15.2133 12.5246 15.319 12.6826 15.3911 12.8566C15.4632 13.0305 15.5004 13.217 15.5004 13.4053C15.5004 13.5936 15.4632 13.7801 15.3911 13.954C15.319 14.128 15.2133 14.286 15.0801 14.4191C14.947 14.5524 14.789 14.6581 14.615 14.7302C14.441 14.8023 14.2546 14.8394 14.0663 14.8394C13.8779 14.8394 13.6915 14.8023 13.5175 14.7302C13.3436 14.6581 13.1855 14.5524 13.0524 14.4191L13.0094 14.3761C12.8406 14.211 12.6261 14.1002 12.3937 14.058C12.1613 14.0159 11.9215 14.0443 11.7054 14.1397C11.4935 14.2305 11.3128 14.3813 11.1855 14.5736C11.0582 14.7658 10.9899 14.991 10.9889 15.2216V15.3434C10.9889 15.7234 10.838 16.0879 10.5692 16.3567C10.3005 16.6254 9.93602 16.7764 9.55598 16.7764C9.17593 16.7764 8.81145 16.6254 8.54271 16.3567C8.27398 16.0879 8.123 15.7234 8.123 15.3434V15.2789C8.11746 15.0418 8.04069 14.8118 7.90269 14.6188C7.76469 14.4259 7.57184 14.2789 7.3492 14.197C7.1331 14.1016 6.89338 14.0732 6.66095 14.1153C6.42853 14.1575 6.21405 14.2683 6.04519 14.4335L6.0022 14.4764C5.86912 14.6097 5.71108 14.7154 5.53712 14.7875C5.36316 14.8596 5.17669 14.8967 4.98838 14.8967C4.80006 14.8967 4.61359 14.8596 4.43963 14.7875C4.26567 14.7154 4.10763 14.6097 3.97455 14.4764C3.84132 14.3434 3.73562 14.1853 3.66351 14.0114C3.5914 13.8374 3.55428 13.6509 3.55428 13.4626C3.55428 13.2743 3.5914 13.0878 3.66351 12.9139C3.73562 12.7399 3.84132 12.5819 3.97455 12.4488L4.01754 12.4058C4.18271 12.2369 4.29352 12.0225 4.33566 11.79C4.3778 11.5576 4.34935 11.3179 4.25398 11.1018C4.16315 10.8899 4.01235 10.7092 3.82012 10.5818C3.6279 10.4545 3.40264 10.3862 3.17208 10.3853H3.05028C2.67023 10.3853 2.30575 10.2343 2.03702 9.9656C1.76828 9.69687 1.61731 9.33239 1.61731 8.95234C1.61731 8.57229 1.76828 8.20781 2.03702 7.93907C2.30575 7.67034 2.67023 7.51937 3.05028 7.51937H3.11477C3.35192 7.51382 3.58192 7.43706 3.77486 7.29905C3.96781 7.16105 4.11478 6.9682 4.19666 6.74556C4.29203 6.52946 4.32049 6.28974 4.27834 6.05731C4.2362 5.82489 4.1254 5.61042 3.96022 5.44156L3.91723 5.39857C3.784 5.26548 3.6783 5.10744 3.60619 4.93348C3.53408 4.75952 3.49696 4.57305 3.49696 4.38474C3.49696 4.19642 3.53408 4.00996 3.60619 3.836C3.6783 3.66204 3.784 3.504 3.91723 3.37091C4.05031 3.23768 4.20836 3.13198 4.38232 3.05987C4.55628 2.98776 4.74274 2.95064 4.93106 2.95064C5.11937 2.95064 5.30584 2.98776 5.4798 3.05987C5.65376 3.13198 5.8118 3.23768 5.94489 3.37091L5.98788 3.4139C6.15674 3.57908 6.37121 3.68988 6.60363 3.73202C6.83606 3.77417 7.07578 3.74572 7.29188 3.65034H7.3492C7.56111 3.55952 7.74185 3.40871 7.86915 3.21648C7.99645 3.02426 8.06477 2.799 8.06568 2.56845V2.44664C8.06568 2.0666 8.21666 1.70211 8.48539 1.43338C8.75413 1.16465 9.11861 1.01367 9.49866 1.01367C9.87871 1.01367 10.2432 1.16465 10.5119 1.43338C10.7807 1.70211 10.9316 2.0666 10.9316 2.44664V2.51113C10.9325 2.74168 11.0009 2.96694 11.1282 3.15917C11.2555 3.35139 11.4362 3.5022 11.6481 3.59302C11.8642 3.6884 12.1039 3.71685 12.3364 3.6747C12.5688 3.63256 12.7833 3.52176 12.9521 3.35658L12.9951 3.31359C13.1282 3.18036 13.2862 3.07467 13.4602 3.00255C13.6342 2.93044 13.8206 2.89332 14.0089 2.89332C14.1973 2.89332 14.3837 2.93044 14.5577 3.00255C14.7316 3.07467 14.8897 3.18036 15.0228 3.31359C15.156 3.44668 15.2617 3.60472 15.3338 3.77868C15.4059 3.95264 15.443 4.13911 15.443 4.32742C15.443 4.51574 15.4059 4.7022 15.3338 4.87616C15.2617 5.05012 15.156 5.20816 15.0228 5.34125L14.9798 5.38424C14.8146 5.5531 14.7038 5.76757 14.6617 5.99999C14.6195 6.23242 14.648 6.47214 14.7433 6.68824V6.74556C14.8342 6.95748 14.985 7.13821 15.1772 7.26551C15.3694 7.39281 15.5947 7.46113 15.8252 7.46205H15.947C16.3271 7.46205 16.6916 7.61302 16.9603 7.88176C17.229 8.15049 17.38 8.51497 17.38 8.89502C17.38 9.27507 17.229 9.63955 16.9603 9.90828C16.6916 10.177 16.3271 10.328 15.947 10.328H15.8825C15.652 10.3289 15.4267 10.3972 15.2345 10.5245C15.0423 10.6518 14.8915 10.8326 14.8007 11.0445V11.0445Z"
        stroke="#121418"
        strokeWidth="1.75141"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  logout: (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.3335 14.1668L12.5002 10.0002L8.3335 5.8335"
        stroke="#121418"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12.5 10H2.5"
        stroke="#121418"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12.5 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H12.5"
        stroke="#121418"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  warning: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      className="iconify iconify--emojione"
      preserveAspectRatio="xMidYMid meet"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M5.9 62c-3.3 0-4.8-2.4-3.3-5.3L29.3 4.2c1.5-2.9 3.9-2.9 5.4 0l26.7 52.5c1.5 2.9 0 5.3-3.3 5.3H5.9z"
          fill="#ffce31"
        ></path>
        <g fill="#121212">
          <path d="M27.8 23.6l2.8 18.5c.3 1.8 2.6 1.8 2.9 0l2.7-18.5c.5-7.2-8.9-7.2-8.4 0"></path>
          <circle cx="32" cy="49.6" r="4.2"></circle>
        </g>
      </g>
    </svg>
  ),
  camera: (
    <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 7.37722C1 7.0269 1 6.85174 1.01462 6.70421C1.1556 5.28127 2.28127 4.1556 3.70421 4.01462C3.85174 4 4.03636 4 4.40558 4C4.54785 4 4.61899 4 4.67939 3.99634C5.45061 3.94963 6.12595 3.46288 6.41414 2.746C6.43671 2.68986 6.45781 2.62657 6.5 2.5C6.54219 2.37343 6.56329 2.31014 6.58586 2.254C6.87405 1.53712 7.54939 1.05037 8.32061 1.00366C8.38101 1 8.44772 1 8.58114 1H13.4189C13.5523 1 13.619 1 13.6794 1.00366C14.4506 1.05037 15.126 1.53712 15.4141 2.254C15.4367 2.31014 15.4578 2.37343 15.5 2.5C15.5422 2.62657 15.5633 2.68986 15.5859 2.746C15.874 3.46288 16.5494 3.94963 17.3206 3.99634C17.381 4 17.4521 4 17.5944 4C17.9636 4 18.1483 4 18.2958 4.01462C19.7187 4.1556 20.8444 5.28127 20.9854 6.70421C21 6.85174 21 7.0269 21 7.37722V15.2C21 16.8802 21 17.7202 20.673 18.362C20.3854 18.9265 19.9265 19.3854 19.362 19.673C18.7202 20 17.8802 20 16.2 20H5.8C4.11984 20 3.27976 20 2.63803 19.673C2.07354 19.3854 1.6146 18.9265 1.32698 18.362C1 17.7202 1 16.8802 1 15.2V7.37722Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M11 15.5C13.2091 15.5 15 13.7091 15 11.5C15 9.29086 13.2091 7.5 11 7.5C8.79086 7.5 7 9.29086 7 11.5C7 13.7091 8.79086 15.5 11 15.5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  edit: (
    <svg width="17" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g id="style=fill">
          <g id="edit">
            <path
              id="Subtract"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.9405 3.12087L21.0618 5.24219C22.2334 6.41376 22.2334 8.31326 21.0618 9.48483L19.2586 11.288L12.8947 4.92403L14.6978 3.12087C15.8694 1.94929 17.7689 1.94929 18.9405 3.12087ZM11.834 5.98469L3.70656 14.1121C3.22329 14.5954 2.91952 15.2292 2.84552 15.9086L2.45151 19.5264C2.31313 20.7969 3.38571 21.8695 4.65629 21.7311L8.27401 21.3371C8.95345 21.2631 9.58725 20.9594 10.0705 20.4761L18.1979 12.3486L11.834 5.98469Z"
              fill="#fff"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  cross: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 1L1 13M1 1L13 13"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  passportIcon: (
    <svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="16.897" y="8.6875" width="39.3954" height="56.1749" rx="6.63222" fill="#E0E6F3" />
      <path
        d="M45.2262 48.648H27.9617C27.4912 48.648 27.1099 48.0314 27.1099 47.2708C27.1099 46.5101 27.4912 45.8936 27.9617 45.8936H45.2262C45.6967 45.8936 46.078 46.5101 46.078 47.2708C46.078 48.0314 45.6967 48.648 45.2262 48.648Z"
        fill="black"
      />
      <path
        d="M51.4972 43.5406H28.2566C27.6232 43.5406 27.1099 42.924 27.1099 42.1634C27.1099 41.4027 27.6232 40.7861 28.2566 40.7861H51.4972C52.1305 40.7861 52.6439 41.4027 52.6439 42.1634C52.6439 42.924 52.1305 43.5406 51.4972 43.5406Z"
        fill="black"
      />
      <g clipPath="url(#clip0_706_17846)">
        <path
          d="M38.7749 19.0215C34.4122 19.0215 30.8794 22.5622 30.8794 26.9249C30.8794 31.2876 34.4122 34.8283 38.7749 34.8283C43.1455 34.8283 46.6862 31.2876 46.6862 26.9249C46.6862 22.5622 43.1455 19.0215 38.7749 19.0215ZM44.2519 23.7635H41.9204C41.6675 22.7756 41.304 21.8272 40.8298 20.9499C42.284 21.4478 43.4932 22.4595 44.2519 23.7635ZM38.7828 20.6338C39.4388 21.5822 39.9525 22.6333 40.2923 23.7635H37.2732C37.6131 22.6333 38.1268 21.5822 38.7828 20.6338ZM32.6656 28.5056C32.5391 27.9997 32.4601 27.4702 32.4601 26.9249C32.4601 26.3796 32.5391 25.85 32.6656 25.3442H35.3369C35.2737 25.8658 35.2263 26.3875 35.2263 26.9249C35.2263 27.4623 35.2737 27.9839 35.3369 28.5056H32.6656ZM33.3136 30.0862H35.6451C35.8981 31.0742 36.2616 32.0226 36.7358 32.8999C35.2816 32.4019 34.0724 31.3982 33.3136 30.0862ZM35.6451 23.7635H33.3136C34.0724 22.4516 35.2816 21.4478 36.7358 20.9499C36.2616 21.8272 35.8981 22.7756 35.6451 23.7635ZM38.7828 33.216C38.1268 32.2676 37.6131 31.2164 37.2732 30.0862H40.2923C39.9525 31.2164 39.4388 32.2676 38.7828 33.216ZM40.6322 28.5056H36.9334C36.8623 27.9839 36.8069 27.4623 36.8069 26.9249C36.8069 26.3875 36.8623 25.8579 36.9334 25.3442H40.6322C40.7033 25.8579 40.7586 26.3875 40.7586 26.9249C40.7586 27.4623 40.7033 27.9839 40.6322 28.5056ZM40.8298 32.8999C41.304 32.0226 41.6675 31.0742 41.9204 30.0862H44.2519C43.4932 31.3903 42.284 32.4019 40.8298 32.8999ZM42.2287 28.5056C42.2919 27.9839 42.3393 27.4623 42.3393 26.9249C42.3393 26.3875 42.2919 25.8658 42.2287 25.3442H44.9C45.0265 25.85 45.1055 26.3796 45.1055 26.9249C45.1055 27.4702 45.0265 27.9997 44.9 28.5056H42.2287Z"
          fill="black"
        />
      </g>
      <path
        d="M16.897 14.5239C16.897 11.3005 19.51 8.6875 22.7333 8.6875V64.8624C19.51 64.8624 16.897 62.2494 16.897 59.0261V14.5239Z"
        fill="black"
      />
      <defs>
        <clipPath id="clip0_706_17846">
          <rect
            width="18.9682"
            height="18.9682"
            fill="white"
            transform="translate(29.2993 17.4404)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  nationalIdIcon: (
    <svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M63.5878 22.4851V51.6874C63.5878 53.7067 61.9512 55.3434 59.9318 55.3434H13.9871C11.9677 55.3434 10.3311 53.7067 10.3311 51.6874V22.4851C10.3311 20.4658 11.9677 18.8291 13.9871 18.8291H59.9317C61.9511 18.829 63.5878 20.4658 63.5878 22.4851V22.4851Z"
        fill="#E0E6F3"
      />
      <path
        d="M58.1039 50.7742H15.8153C15.3106 50.7742 14.9014 50.365 14.9014 49.8603C14.9014 49.3555 15.3106 48.9463 15.8153 48.9463H58.1039C58.6087 48.9463 59.0179 49.3555 59.0179 49.8603C59.0179 50.3649 58.6087 50.7742 58.1039 50.7742Z"
        fill="white"
      />
      <path
        d="M58.1039 47.118H15.8153C15.3106 47.118 14.9014 46.7088 14.9014 46.204C14.9014 45.6992 15.3106 45.29 15.8153 45.29H58.1039C58.6087 45.29 59.0179 45.6992 59.0179 46.204C59.0179 46.7088 58.6087 47.118 58.1039 47.118Z"
        fill="white"
      />
      <path
        d="M58.1036 43.4617H39.5795C39.0747 43.4617 38.6655 43.0525 38.6655 42.5478C38.6655 42.043 39.0747 41.6338 39.5795 41.6338H58.1036C58.6084 41.6338 59.0176 42.043 59.0176 42.5478C59.0176 43.0524 58.6084 43.4617 58.1036 43.4617Z"
        fill="white"
      />
      <path
        d="M58.1036 39.8055H39.5795C39.0747 39.8055 38.6655 39.3963 38.6655 38.8915C38.6655 38.3867 39.0747 37.9775 39.5795 37.9775H58.1036C58.6084 37.9775 59.0176 38.3867 59.0176 38.8915C59.0176 39.3963 58.6084 39.8055 58.1036 39.8055Z"
        fill="white"
      />
      <path
        d="M30.4085 42.6417H19.4861C17.4669 42.6417 15.8301 41.0048 15.8301 38.9856V28.0632C15.8301 26.044 17.467 24.4072 19.4861 24.4072H30.4085C32.4277 24.4072 34.0645 26.0441 34.0645 28.0632V38.9856C34.0645 41.0048 32.4277 42.6417 30.4085 42.6417Z"
        fill="#67728D"
      />
      <path
        d="M30.4085 42.6417H19.4861C17.4669 42.6417 15.8301 41.0048 15.8301 38.9856V28.0632C15.8301 26.044 17.467 24.4072 19.4861 24.4072H30.4085C32.4277 24.4072 34.0645 26.0441 34.0645 28.0632V38.9856C34.0645 41.0048 32.4277 42.6417 30.4085 42.6417Z"
        fill="white"
      />
      <path
        d="M22.0499 28.9668C22.1674 28.9668 22.2793 28.9881 22.3854 29.0306C22.4916 29.0771 22.5826 29.139 22.6584 29.2163C22.7342 29.2937 22.7949 29.3866 22.8404 29.4949C22.8859 29.6032 22.9086 29.7193 22.9086 29.8431C22.9086 29.9669 22.8859 30.0811 22.8404 30.1855C22.7949 30.2939 22.7342 30.3867 22.6584 30.4641C22.5826 30.5454 22.4916 30.6092 22.3854 30.6556C22.2793 30.702 22.1674 30.7253 22.0499 30.7253C21.9286 30.7253 21.8148 30.702 21.7087 30.6556C21.6063 30.6092 21.5172 30.5454 21.4414 30.4641C21.3655 30.3867 21.3068 30.2939 21.2651 30.1855C21.2196 30.0811 21.1968 29.9669 21.1968 29.8431C21.1968 29.7193 21.2196 29.6032 21.2651 29.4949C21.3068 29.3866 21.3655 29.2937 21.4414 29.2163C21.5172 29.139 21.6063 29.0771 21.7087 29.0306C21.8148 28.9881 21.9286 28.9668 22.0499 28.9668ZM26.9142 28.9668C27.0317 28.9668 27.1436 28.9881 27.2498 29.0306C27.3559 29.0771 27.4469 29.139 27.5227 29.2163C27.5986 29.2937 27.6592 29.3866 27.7047 29.4949C27.7502 29.6032 27.773 29.7193 27.773 29.8431C27.773 29.9669 27.7502 30.0811 27.7047 30.1855C27.6592 30.2939 27.5986 30.3867 27.5227 30.4641C27.4469 30.5454 27.3559 30.6092 27.2498 30.6556C27.1436 30.702 27.0317 30.7253 26.9142 30.7253C26.7929 30.7253 26.6792 30.702 26.573 30.6556C26.4706 30.6092 26.3815 30.5454 26.3057 30.4641C26.2299 30.3867 26.1692 30.2939 26.1237 30.1855C26.082 30.0811 26.0612 29.9669 26.0612 29.8431C26.0612 29.7193 26.082 29.6032 26.1237 29.4949C26.1692 29.3866 26.2299 29.2937 26.3057 29.2163C26.3815 29.139 26.4706 29.0771 26.573 29.0306C26.6792 28.9881 26.7929 28.9668 26.9142 28.9668Z"
        fill="black"
      />
      <path
        d="M25.2972 32.0057L25.2972 35.0119L24.1256 35.0119L24.1256 32.0057L25.2972 32.0057Z"
        fill="black"
      />
      <path
        d="M24.8422 37.1887C25.6232 37.1887 26.391 37.092 27.1455 36.8986C27.9037 36.709 28.6127 36.4343 29.2724 36.0745C29.352 36.0319 29.4203 36.0068 29.4771 35.999C29.5378 35.9952 29.589 36.001 29.6307 36.0164C29.6762 36.0319 29.7141 36.0551 29.7444 36.0861C29.7786 36.1209 29.807 36.1596 29.8297 36.2021L30.2051 36.8405C29.7729 37.1268 29.3388 37.3706 28.9027 37.5718C28.4705 37.773 28.0326 37.9374 27.589 38.0651C27.1455 38.1927 26.6943 38.2856 26.2355 38.3436C25.7806 38.4017 25.3161 38.4307 24.8422 38.4307C24.3683 38.4307 23.9038 38.4017 23.4489 38.3436C22.9939 38.2856 22.5446 38.1927 22.1011 38.0651C21.6575 37.9374 21.2177 37.773 20.7817 37.5718C20.444 37.4159 20.0495 37.1989 19.7328 37.0035C19.6406 36.9467 19.555 36.8917 19.4793 36.8405L19.6699 36.5213L19.8604 36.2021C19.8831 36.1596 19.9115 36.1209 19.9457 36.0861C19.976 36.0551 20.0139 36.0319 20.0594 36.0164C20.1011 36.001 20.1523 35.9952 20.213 35.999C20.2698 36.0068 20.3362 36.0319 20.412 36.0745C21.0755 36.4343 21.7845 36.709 22.539 36.8986C23.2934 37.092 24.0612 37.1887 24.8422 37.1887Z"
        fill="black"
      />
      <path
        d="M50.6836 28.7225H39.4716C38.9668 28.7225 38.5576 28.3133 38.5576 27.8085C38.5576 27.3037 38.9668 26.8945 39.4716 26.8945H50.6836C51.1884 26.8945 51.5976 27.3037 51.5976 27.8085C51.5976 28.3133 51.1884 28.7225 50.6836 28.7225Z"
        fill="white"
      />
      <path
        d="M58.1036 25.2264H39.5795C39.0747 25.2264 38.6655 24.8172 38.6655 24.3124C38.6655 23.8076 39.0747 23.3984 39.5795 23.3984H58.1036C58.6084 23.3984 59.0176 23.8076 59.0176 24.3124C59.0176 24.8172 58.6084 25.2264 58.1036 25.2264Z"
        fill="white"
      />
    </svg>
  ),
  licenseIcon: (
    <svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_706_17857)">
        <path
          d="M66.1263 23.6616V54.032C66.1263 56.1321 64.4242 57.8342 62.324 57.8342H14.5415C12.4414 57.8342 10.7393 56.1321 10.7393 54.032V23.6616C10.7393 21.5615 12.4414 19.8594 14.5415 19.8594H62.3239C64.4242 19.8593 66.1263 21.5615 66.1263 23.6616V23.6616Z"
          fill="#E0E6F3"
        />
        <path
          d="M60.4228 53.0827H16.4427C15.9178 53.0827 15.4922 52.6572 15.4922 52.1322C15.4922 51.6072 15.9178 51.1816 16.4427 51.1816H60.4228C60.9478 51.1816 61.3734 51.6072 61.3734 52.1322C61.3734 52.657 60.9478 53.0827 60.4228 53.0827Z"
          fill="white"
        />
        <path
          d="M60.4228 49.279H16.4427C15.9178 49.279 15.4922 48.8534 15.4922 48.3285C15.4922 47.8035 15.9178 47.3779 16.4427 47.3779H60.4228C60.9478 47.3779 61.3734 47.8035 61.3734 48.3285C61.3734 48.8534 60.9478 49.279 60.4228 49.279Z"
          fill="white"
        />
        <path
          d="M60.4227 45.4772H41.1576C40.6326 45.4772 40.207 45.0517 40.207 44.5267C40.207 44.0017 40.6326 43.5762 41.1576 43.5762H60.4227C60.9476 43.5762 61.3732 44.0017 61.3732 44.5267C61.3732 45.0516 60.9476 45.4772 60.4227 45.4772Z"
          fill="white"
        />
        <path
          d="M60.4227 41.6755H41.1576C40.6326 41.6755 40.207 41.2499 40.207 40.7249C40.207 40.2 40.6326 39.7744 41.1576 39.7744H60.4227C60.9476 39.7744 61.3732 40.2 61.3732 40.7249C61.3732 41.2499 60.9476 41.6755 60.4227 41.6755Z"
          fill="white"
        />
        <path
          d="M31.6196 44.625H20.2603C18.1603 44.625 16.458 42.9226 16.458 40.8227V29.4634C16.458 27.3634 18.1604 25.6611 20.2603 25.6611H31.6196C33.7196 25.6611 35.4218 27.3635 35.4218 29.4634V40.8227C35.4218 42.9226 33.7196 44.625 31.6196 44.625Z"
          fill="#67728D"
        />
        <path
          d="M31.6196 44.6249H20.2603C18.1603 44.6249 16.458 42.9226 16.458 40.8227V29.4634C16.458 27.3634 18.1604 25.6611 20.2603 25.6611H31.6196C33.7196 25.6611 35.4218 27.3635 35.4218 29.4634V40.8227C35.4218 42.9226 33.7196 44.6249 31.6196 44.6249Z"
          fill="white"
        />
        <path
          d="M22.9268 30.4033C23.049 30.4033 23.1653 30.4255 23.2757 30.4697C23.3862 30.518 23.4808 30.5824 23.5596 30.6629C23.6385 30.7433 23.7016 30.8399 23.7489 30.9526C23.7962 31.0652 23.8199 31.1859 23.8199 31.3147C23.8199 31.4435 23.7962 31.5622 23.7489 31.6708C23.7016 31.7835 23.6385 31.88 23.5596 31.9605C23.4808 32.045 23.3862 32.1114 23.2757 32.1597C23.1653 32.208 23.049 32.2321 22.9268 32.2321C22.8006 32.2321 22.6823 32.208 22.5719 32.1597C22.4655 32.1114 22.3728 32.045 22.2939 31.9605C22.2151 31.88 22.154 31.7835 22.1106 31.6708C22.0633 31.5622 22.0396 31.4435 22.0396 31.3147C22.0396 31.1859 22.0633 31.0652 22.1106 30.9526C22.154 30.8399 22.2151 30.7433 22.2939 30.6629C22.3728 30.5824 22.4655 30.518 22.5719 30.4697C22.6823 30.4255 22.8006 30.4033 22.9268 30.4033ZM27.9857 30.4033C28.1079 30.4033 28.2243 30.4255 28.3347 30.4697C28.4451 30.518 28.5397 30.5824 28.6186 30.6629C28.6974 30.7433 28.7605 30.8399 28.8078 30.9526C28.8551 31.0652 28.8788 31.1859 28.8788 31.3147C28.8788 31.4435 28.8551 31.5622 28.8078 31.6708C28.7605 31.7835 28.6974 31.88 28.6186 31.9605C28.5397 32.045 28.4451 32.1114 28.3347 32.1597C28.2243 32.208 28.1079 32.2321 27.9857 32.2321C27.8595 32.2321 27.7412 32.208 27.6308 32.1597C27.5244 32.1114 27.4317 32.045 27.3529 31.9605C27.274 31.88 27.2109 31.7835 27.1636 31.6708C27.1202 31.5622 27.0985 31.4435 27.0985 31.3147C27.0985 31.1859 27.1202 31.0652 27.1636 30.9526C27.2109 30.8399 27.274 30.7433 27.3529 30.6629C27.4317 30.5824 27.5244 30.518 27.6308 30.4697C27.7412 30.4255 27.8595 30.4033 27.9857 30.4033Z"
          fill="black"
        />
        <path
          d="M26.304 33.5637L26.304 36.6902L25.0856 36.6902L25.0856 33.5637L26.304 33.5637Z"
          fill="black"
        />
        <path
          d="M25.8308 38.9541C26.6431 38.9541 27.4415 38.8535 28.2262 38.6524C29.0148 38.4552 29.7521 38.1695 30.4382 37.7953C30.521 37.751 30.592 37.7249 30.6511 37.7168C30.7142 37.7128 30.7675 37.7188 30.8108 37.7349C30.8582 37.751 30.8976 37.7752 30.9291 37.8074C30.9646 37.8436 30.9942 37.8838 31.0178 37.9281L31.4082 38.592C30.9587 38.8898 30.5072 39.1433 30.0538 39.3525C29.6043 39.5617 29.1489 39.7327 28.6875 39.8655C28.2262 39.9983 27.757 40.0949 27.2799 40.1552C26.8067 40.2156 26.3237 40.2458 25.8308 40.2458C25.3379 40.2458 24.8549 40.2156 24.3818 40.1552C23.9086 40.0949 23.4414 39.9983 22.98 39.8655C22.5187 39.7327 22.0613 39.5617 21.6079 39.3525C21.2566 39.1904 20.8464 38.9647 20.517 38.7615C20.4212 38.7024 20.3321 38.6452 20.2534 38.592L20.4516 38.26L20.6497 37.9281C20.6734 37.8838 20.7029 37.8436 20.7384 37.8074C20.77 37.7752 20.8094 37.751 20.8567 37.7349C20.9001 37.7188 20.9533 37.7128 21.0164 37.7168C21.0755 37.7249 21.1446 37.751 21.2234 37.7953C21.9134 38.1695 22.6508 38.4552 23.4354 38.6524C24.2201 38.8535 25.0186 38.9541 25.8308 38.9541Z"
          fill="black"
        />
        <path
          d="M52.7052 30.1481H41.0448C40.5198 30.1481 40.0942 29.7226 40.0942 29.1976C40.0942 28.6726 40.5198 28.2471 41.0448 28.2471H52.7052C53.2302 28.2471 53.6558 28.6726 53.6558 29.1976C53.6558 29.7226 53.2302 30.1481 52.7052 30.1481Z"
          fill="white"
        />
        <path
          d="M60.4227 26.5134H41.1576C40.6326 26.5134 40.207 26.0878 40.207 25.5628C40.207 25.0379 40.6326 24.6123 41.1576 24.6123H60.4227C60.9476 24.6123 61.3732 25.0379 61.3732 25.5628C61.3732 26.0878 60.9476 26.5134 60.4227 26.5134Z"
          fill="white"
        />
        <path
          d="M51.5506 31.5322C42.0826 31.5322 34.4062 39.2086 34.4062 48.6765C34.4062 58.1445 42.0826 65.8208 51.5506 65.8208C61.0185 65.8208 68.6949 58.1445 68.6949 48.6765C68.6949 39.2086 61.0185 31.5322 51.5506 31.5322ZM51.5506 35.8183C57.1299 35.8183 61.8425 39.4122 63.6223 44.3905H39.4788C41.2586 39.4122 45.9712 35.8183 51.5506 35.8183ZM51.5506 50.8196C50.3665 50.8196 49.4075 49.8606 49.4075 48.6765C49.4075 47.4925 50.3665 46.5335 51.5506 46.5335C52.7346 46.5335 53.6936 47.4925 53.6936 48.6765C53.6936 49.8606 52.7346 50.8196 51.5506 50.8196ZM38.6923 48.6765C44.5482 48.6765 49.2907 54.3191 49.3904 61.3172C43.3299 60.2789 38.6923 55.0263 38.6923 48.6765ZM53.7107 61.3172C53.8104 54.3191 58.5529 48.6765 64.4088 48.6765C64.4088 55.0263 59.7712 60.2789 53.7107 61.3172Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_706_17857">
          <rect
            width="72.9545"
            height="72.9545"
            fill="white"
            transform="translate(0.117188 0.890625)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  infoCircle: (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 15V11M11 7H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  info: (
    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_706_17841)">
        <path
          d="M17.5265 3.36035C9.71811 3.36035 3.38086 9.69761 3.38086 17.506C3.38086 25.3144 9.71811 31.6517 17.5265 31.6517C25.3349 31.6517 31.6722 25.3144 31.6722 17.506C31.6722 9.69761 25.3349 3.36035 17.5265 3.36035ZM18.9411 24.5788H16.1119V21.7497H18.9411V24.5788ZM18.9411 18.9206H16.1119V10.4332H18.9411V18.9206Z"
          fill="#0055FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_706_17841">
          <rect
            width="33.9496"
            height="33.9496"
            fill="white"
            transform="translate(0.55127 0.53125)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  moreInfo: (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="9" cy="10" r="9" fill="#D9D9D9" />
      <path
        d="M8.24805 11.9084V11.8409C8.25278 11.4006 8.29658 11.0502 8.37944 10.7898C8.46467 10.5294 8.5854 10.3187 8.74165 10.1577C8.8979 9.99669 9.08612 9.84991 9.30629 9.71733C9.44833 9.62737 9.57617 9.52675 9.68981 9.41548C9.80344 9.30421 9.89341 9.17637 9.95969 9.03196C10.026 8.88755 10.0591 8.72775 10.0591 8.55256C10.0591 8.34186 10.0094 8.15956 9.90998 8.00568C9.81055 7.8518 9.67797 7.73343 9.51225 7.65057C9.3489 7.56534 9.16661 7.52273 8.96538 7.52273C8.78308 7.52273 8.60908 7.56061 8.44336 7.63636C8.27764 7.71212 8.14033 7.83049 8.03143 7.99148C7.92253 8.15009 7.85979 8.35488 7.84322 8.60582H6.76367C6.78024 8.17969 6.88796 7.81984 7.08683 7.52628C7.28569 7.23035 7.54847 7.00663 7.87518 6.85511C8.20425 6.7036 8.56765 6.62784 8.96538 6.62784C9.40098 6.62784 9.78214 6.70952 10.1088 6.87287C10.4355 7.03385 10.6889 7.25994 10.8688 7.55114C11.0511 7.83996 11.1422 8.17732 11.1422 8.56321C11.1422 8.82836 11.1008 9.06747 11.0179 9.28054C10.9351 9.49124 10.8167 9.67945 10.6628 9.84517C10.5113 10.0109 10.329 10.1577 10.1159 10.2855C9.91471 10.411 9.75136 10.5412 9.62589 10.6761C9.50278 10.8111 9.41282 10.9709 9.356 11.1555C9.29918 11.3402 9.26841 11.5687 9.26367 11.8409V11.9084H8.24805ZM8.78427 14.0675C8.59014 14.0675 8.42324 13.9988 8.28356 13.8615C8.14388 13.7218 8.07404 13.5537 8.07404 13.3572C8.07404 13.1631 8.14388 12.9974 8.28356 12.8601C8.42324 12.7204 8.59014 12.6506 8.78427 12.6506C8.97603 12.6506 9.14175 12.7204 9.28143 12.8601C9.42347 12.9974 9.4945 13.1631 9.4945 13.3572C9.4945 13.4875 9.46135 13.607 9.39506 13.7159C9.33114 13.8224 9.24592 13.9077 9.13938 13.9716C9.03285 14.0355 8.91448 14.0675 8.78427 14.0675Z"
        fill="white"
      />
    </svg>
  ),
  unCheckIcon: (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1.14237" y="1.5164" width="34.9863" height="34.9863" rx="10.8642" fill="white" />
      <rect
        x="1.14237"
        y="1.5164"
        width="34.9863"
        height="34.9863"
        rx="10.8642"
        stroke="#D0D9ED"
        strokeWidth="1.84138"
        fill="none"
      />
      <path
        d="M25.1273 13.9922L15.6326 23.1991L11.3169 19.0141"
        stroke="white"
        strokeWidth="2.30173"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  checkIcon: (
    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="#F4EBFF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0964 7.39016L9.93638 14.3002L8.03638 12.2702C7.68638 11.9402 7.13638 11.9202 6.73638 12.2002C6.34638 12.4902 6.23638 13.0002 6.47638 13.4102L8.72638 17.0702C8.94638 17.4102 9.32638 17.6202 9.75638 17.6202C10.1664 17.6202 10.5564 17.4102 10.7764 17.0702C11.1364 16.6002 18.0064 8.41016 18.0064 8.41016C18.9064 7.49016 17.8164 6.68016 17.0964 7.38016V7.39016Z"
        fill="#7F56D9"
      />
    </svg>
  ),
  checkCircle: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="#079455"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  checkCircleSuccess: (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#DCFAE6" />
      <rect
        x="4"
        y="4"
        width="48"
        height="48"
        rx="24"
        stroke="#ECFDF3"
        strokeWidth="8"
        fill="none"
      />
      <path
        d="M23.5 28L26.5 31L32.5 25M38 28C38 33.5228 33.5228 38 28 38C22.4772 38 18 33.5228 18 28C18 22.4772 22.4772 18 28 18C33.5228 18 38 22.4772 38 28Z"
        stroke="#079455"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  plus: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99999 4.16666V15.8333M4.16666 9.99999H15.8333"
        stroke="#667085"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  userPlus: (
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dii_330_2892)">
        <rect x="2" y="1" width="48" height="48" rx="10" fill="white" />
        <rect x="2.5" y="1.5" width="47" height="47" rx="9.5" stroke="#E4E7EC" fill="none" />
        <path
          d="M33 34V28M30 31H36M26 28H22C20.1362 28 19.2044 28 18.4693 28.3045C17.4892 28.7105 16.7105 29.4892 16.3045 30.4693C16 31.2044 16 32.1362 16 34M29.5 16.2908C30.9659 16.8841 32 18.3213 32 20C32 21.6787 30.9659 23.1159 29.5 23.7092M27.5 20C27.5 22.2091 25.7091 24 23.5 24C21.2909 24 19.5 22.2091 19.5 20C19.5 17.7909 21.2909 16 23.5 16C25.7091 16 27.5 17.7909 27.5 20Z"
          stroke="#344054"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <filter
          id="filter0_dii_330_2892"
          x="0"
          y="0"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_330_2892" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_330_2892"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_330_2892" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect3_innerShadow_330_2892"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_330_2892"
            result="effect3_innerShadow_330_2892"
          />
        </filter>
      </defs>
    </svg>
  ),
  internet: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.073 11.7171C14.7594 10.5988 15.1218 9.31206 15.12 8.00001L15.12 7.99989L15.12 7.99976C15.1218 6.68771 14.7594 5.4009 14.073 4.28269L14.0691 4.27658C13.4323 3.23873 12.54 2.3815 11.4775 1.78682C10.415 1.19215 9.21766 0.879888 8.00003 0.879883C6.7824 0.879878 5.58511 1.19213 4.52256 1.7868C3.46002 2.38146 2.56772 3.23868 1.93094 4.27654L1.92699 4.28272C1.24232 5.4017 0.88001 6.68804 0.880005 7.99987C0.88 9.31169 1.2423 10.598 1.92696 11.717L1.93098 11.7233C2.56776 12.7611 3.46006 13.6183 4.52259 14.213C5.58513 14.8076 6.78241 15.1199 8.00003 15.1199C9.21765 15.1199 10.4149 14.8076 11.4775 14.213C12.54 13.6183 13.4323 12.7611 14.069 11.7232L14.073 11.7171ZM8.9101 13.8996C8.77443 14.0305 8.61827 14.1384 8.4478 14.2189C8.30788 14.2854 8.15491 14.3199 8 14.3199C7.84509 14.3199 7.69212 14.2854 7.5522 14.2189C7.2278 14.0532 6.95011 13.8088 6.74451 13.5081C6.32461 12.9014 6.01344 12.2262 5.82489 11.5128C6.54919 11.4683 7.27423 11.4456 8.00001 11.4447C8.72547 11.4447 9.45055 11.4674 10.1752 11.5128C10.0709 11.8796 9.94052 12.2385 9.78516 12.5868C9.58058 13.0766 9.28347 13.5223 8.9101 13.8996V13.8996ZM1.69393 8.39989H4.56577C4.58446 9.20124 4.67132 9.99954 4.8254 10.7862C4.04036 10.8552 3.25731 10.9501 2.47627 11.0708C2.01891 10.2503 1.75156 9.33752 1.69393 8.39989ZM2.47627 4.92897C3.257 5.04995 4.04032 5.14486 4.82623 5.21368C4.67184 6.00024 4.58479 6.79853 4.56602 7.59989H1.69393C1.75155 6.66226 2.01891 5.74952 2.47626 4.92897H2.47627ZM7.0899 2.10015C7.22557 1.96923 7.38173 1.86138 7.5522 1.78085C7.69212 1.71437 7.84509 1.67987 8 1.67987C8.15491 1.67987 8.30788 1.71437 8.4478 1.78085C8.7722 1.94655 9.04989 2.19092 9.25549 2.49162C9.67539 3.09838 9.98656 3.77354 10.1751 4.48693C9.4508 4.5315 8.72577 4.5542 8.00001 4.55504C7.27454 4.55503 6.54946 4.53232 5.82476 4.48692C5.92913 4.12013 6.05948 3.76124 6.21485 3.41297C6.41942 2.92318 6.71653 2.47743 7.0899 2.10015ZM14.3061 7.59989H11.4342C11.4155 6.79854 11.3287 6.00023 11.1746 5.21361C11.9597 5.14453 12.7427 5.04964 13.5237 4.92897C13.9811 5.74951 14.2485 6.66225 14.3061 7.59989ZM5.63002 10.724C5.47357 9.95859 5.38521 9.18086 5.36597 8.39989H10.6341C10.6151 9.18085 10.5269 9.95859 10.3706 10.724C9.58124 10.6722 8.79105 10.6458 8.00001 10.6447C7.20953 10.6447 6.41953 10.6711 5.63002 10.724ZM10.37 5.2758C10.5264 6.04118 10.6148 6.81892 10.634 7.59989H5.36588C5.38494 6.81892 5.47314 6.04117 5.62945 5.27576C6.41876 5.32755 7.20895 5.35397 8.00001 5.35503C8.79048 5.35503 9.58048 5.32862 10.37 5.2758V5.2758ZM11.434 8.39989H14.3061C14.2485 9.33752 13.9811 10.2503 13.5237 11.0708C12.743 10.9498 11.9597 10.8549 11.1738 10.7861C11.3282 9.99953 11.4152 9.20124 11.434 8.39989ZM13.0441 4.19265C12.3615 4.29114 11.6768 4.36911 10.9901 4.42657C10.8667 3.96706 10.7075 3.51792 10.514 3.08324C10.3374 2.68323 10.1151 2.30498 9.85166 1.95599C11.1249 2.34648 12.2422 3.12929 13.0441 4.19265ZM3.53107 3.53095C4.26146 2.79987 5.16003 2.25911 6.14801 1.95609C6.13302 1.9755 6.1176 1.99405 6.10283 2.01387C5.59501 2.74491 5.2251 3.56262 5.01137 4.42669C4.32463 4.36853 3.63949 4.29051 2.95594 4.19265C3.13223 3.95914 3.32439 3.73805 3.53107 3.53095ZM2.95593 11.8071C3.63854 11.7086 4.32319 11.6306 5.0099 11.5732C5.13332 12.0327 5.29249 12.4819 5.48597 12.9165C5.66262 13.3165 5.88488 13.6948 6.14834 14.0438C4.87509 13.6533 3.75777 12.8705 2.95593 11.8071V11.8071ZM12.4689 12.4688C11.7386 13.1999 10.84 13.7407 9.85199 14.0437C9.86698 14.0243 9.88239 14.0057 9.89717 13.9859C10.405 13.2549 10.7749 12.4371 10.9886 11.5731C11.6754 11.6312 12.3605 11.7093 13.0441 11.8071C12.8678 12.0406 12.6756 12.2617 12.4689 12.4688V12.4688Z"
        fill="#051036"
      />
    </svg>
  ),
  facebook: (
    <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.62891 8.31543L8.01172 5.7998H5.57812V4.15918C5.57812 3.44824 5.90625 2.79199 7 2.79199H8.12109V0.631836C8.12109 0.631836 7.10938 0.44043 6.15234 0.44043C4.15625 0.44043 2.84375 1.6709 2.84375 3.8584V5.7998H0.601562V8.31543H2.84375V14.4404H5.57812V8.31543H7.62891Z"
        fill="#051036"
      />
    </svg>
  ),
  twitter: (
    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5508 3.59668C13.0977 3.18652 13.5898 2.69434 13.9727 2.12012C13.4805 2.33887 12.9062 2.50293 12.332 2.55762C12.9336 2.20215 13.3711 1.65527 13.5898 0.97168C13.043 1.2998 12.4141 1.5459 11.7852 1.68262C11.2383 1.1084 10.5 0.780273 9.67969 0.780273C8.09375 0.780273 6.80859 2.06543 6.80859 3.65137C6.80859 3.87012 6.83594 4.08887 6.89062 4.30762C4.51172 4.1709 2.37891 3.02246 0.957031 1.2998C0.710938 1.70996 0.574219 2.20215 0.574219 2.74902C0.574219 3.7334 1.06641 4.6084 1.85938 5.12793C1.39453 5.10059 0.929688 4.99121 0.546875 4.77246V4.7998C0.546875 6.19434 1.53125 7.34277 2.84375 7.61621C2.625 7.6709 2.35156 7.72559 2.10547 7.72559C1.91406 7.72559 1.75 7.69824 1.55859 7.6709C1.91406 8.81934 2.98047 9.63965 4.23828 9.66699C3.25391 10.4326 2.02344 10.8975 0.683594 10.8975C0.4375 10.8975 0.21875 10.8701 0 10.8428C1.25781 11.6631 2.76172 12.1279 4.40234 12.1279C9.67969 12.1279 12.5508 7.78027 12.5508 3.97949C12.5508 3.84277 12.5508 3.7334 12.5508 3.59668Z"
        fill="#051036"
      />
    </svg>
  ),
  instagram: (
    <svg width="16" height="17" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.286 8.57C10.286 7.156 9.13 6 7.714 6c-1.416 0-2.57 1.155-2.57 2.57s1.154 2.573 2.57 2.573c1.417 0 2.572-1.155 2.572-2.572zm1.386 0c0 2.19-1.768 3.96-3.958 3.96-2.19 0-3.957-1.77-3.957-3.96 0-2.188 1.768-3.956 3.957-3.956 2.19 0 3.958 1.768 3.958 3.957zm1.085-4.117c0 .512-.412.924-.924.924-.513 0-.925-.412-.925-.924s.412-.924.925-.924c.512 0 .924.41.924.923zm-5.043-2.21c-1.125 0-3.535-.09-4.55.312-.352.14-.613.31-.884.582-.27.27-.442.533-.582.884-.402 1.016-.312 3.426-.312 4.55 0 1.126-.09 3.537.312 4.552.14.35.31.612.582.884.27.27.533.442.884.582 1.015.402 3.425.312 4.55.312s3.536.09 4.55-.312c.352-.14.613-.31.884-.582.272-.272.442-.533.583-.884.403-1.015.312-3.426.312-4.55 0-1.126.09-3.536-.31-4.55-.142-.352-.312-.614-.584-.885-.27-.27-.532-.442-.883-.582-1.015-.402-3.426-.312-4.55-.312zM15.43 8.57c0 1.066.01 2.12-.052 3.186-.06 1.235-.34 2.33-1.245 3.234-.904.904-2 1.185-3.235 1.245-1.064.06-2.12.05-3.184.05s-2.12.01-3.184-.05c-1.235-.06-2.33-.34-3.234-1.245-.904-.904-1.186-2-1.246-3.234C-.01 10.69 0 9.636 0 8.57c0-1.063-.01-2.118.05-3.183.06-1.235.342-2.33 1.246-3.234C2.2 1.25 3.296.968 4.53.907c1.065-.06 2.12-.05 3.184-.05 1.065 0 2.12-.01 3.184.05 1.236.06 2.33.342 3.235 1.246.904.904 1.185 2 1.245 3.234.06 1.065.05 2.12.05 3.184z"
        fillRule="evenodd"
      />
    </svg>
  ),
  linkedin: (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.73438 12.6904V4.51465H0.191406V12.6904H2.73438ZM1.44922 3.4209C2.26953 3.4209 2.92578 2.7373 2.92578 1.91699C2.92578 1.12402 2.26953 0.467773 1.44922 0.467773C0.65625 0.467773 0 1.12402 0 1.91699C0 2.7373 0.65625 3.4209 1.44922 3.4209ZM12.2227 12.6904H12.25V8.20605C12.25 6.01855 11.7578 4.32324 9.1875 4.32324C7.95703 4.32324 7.13672 5.00684 6.78125 5.63574H6.75391V4.51465H4.32031V12.6904H6.86328V8.64355C6.86328 7.57715 7.05469 6.56543 8.36719 6.56543C9.67969 6.56543 9.70703 7.76855 9.70703 8.72559V12.6904H12.2227Z"
        fill="#051036"
      />
    </svg>
  ),
  checkMark: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_283_197)">
        <path
          d="M16.875 5.62539L8.125 14.375L3.75 10.0004"
          stroke="#1A1E25"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip0_283_197">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  doubleCheckMark: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_283_182)">
        <path
          d="M11.5625 6.5625L4.6875 13.4375L1.25 10.0002"
          stroke="url(#paint0_linear_283_182)"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M18.7498 6.5625L11.8748 13.4375L10.0488 11.6116"
          stroke="url(#paint1_linear_283_182)"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_283_182"
          x1="1.25"
          y1="6.9181"
          x2="7.11709"
          y2="15.8817"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#17c0ea" />
          <stop offset="1" stopColor="#17c0ea" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_283_182"
          x1="10.0488"
          y1="6.9181"
          x2="16.2498"
          y2="14.9114"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#17c0ea" />
          <stop offset="1" stopColor="#17c0ea" />
        </linearGradient>
        <clipPath id="clip0_283_182">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  backAngle: (
    <svg
      width="24"
      height="24"
      fill="#000000"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g data-name="Layer 2">
          <g data-name="arrow-ios-back">
            <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0"></rect>
            <path d="M13.83 19a1 1 0 0 1-.78-.37l-4.83-6a1 1 0 0 1 0-1.27l5-6a1 1 0 0 1 1.54 1.28L10.29 12l4.32 5.36a1 1 0 0 1-.78 1.64z"></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  uploadIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0" fill="none"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" fill="none"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10V11H17C18.933 11 20.5 12.567 20.5 14.5C20.5 16.433 18.933 18 17 18H16C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20H17C20.0376 20 22.5 17.5376 22.5 14.5C22.5 11.7793 20.5245 9.51997 17.9296 9.07824C17.4862 6.20213 15.0003 4 12 4C8.99974 4 6.51381 6.20213 6.07036 9.07824C3.47551 9.51997 1.5 11.7793 1.5 14.5C1.5 17.5376 3.96243 20 7 20H8C8.55228 20 9 19.5523 9 19C9 18.4477 8.55228 18 8 18H7C5.067 18 3.5 16.433 3.5 14.5C3.5 12.567 5.067 11 7 11H8V10ZM15.7071 13.2929L12.7071 10.2929C12.3166 9.90237 11.6834 9.90237 11.2929 10.2929L8.29289 13.2929C7.90237 13.6834 7.90237 14.3166 8.29289 14.7071C8.68342 15.0976 9.31658 15.0976 9.70711 14.7071L11 13.4142V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13.4142L14.2929 14.7071C14.6834 15.0976 15.3166 15.0976 15.7071 14.7071C16.0976 14.3166 16.0976 13.6834 15.7071 13.2929Z"
          fill="#000000"
        ></path>
      </g>
    </svg>
  ),
  newsLetterIcon: (
    <svg width="10" height="15" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.91922 2.95605L5.46296 7.49978L0.91922 12.0435L3.21999 14.3443L8.91412 8.65017C9.54946 8.01483 9.54946 6.98474 8.91412 6.3494L3.21999 0.655273L0.91922 2.95605Z"
        fill="white"
      />
    </svg>
  ),
  uploadCloud: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10V11H17C18.933 11 20.5 12.567 20.5 14.5C20.5 16.433 18.933 18 17 18H16C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20H17C20.0376 20 22.5 17.5376 22.5 14.5C22.5 11.7793 20.5245 9.51997 17.9296 9.07824C17.4862 6.20213 15.0003 4 12 4C8.99974 4 6.51381 6.20213 6.07036 9.07824C3.47551 9.51997 1.5 11.7793 1.5 14.5C1.5 17.5376 3.96243 20 7 20H8C8.55228 20 9 19.5523 9 19C9 18.4477 8.55228 18 8 18H7C5.067 18 3.5 16.433 3.5 14.5C3.5 12.567 5.067 11 7 11H8V10ZM15.7071 13.2929L12.7071 10.2929C12.3166 9.90237 11.6834 9.90237 11.2929 10.2929L8.29289 13.2929C7.90237 13.6834 7.90237 14.3166 8.29289 14.7071C8.68342 15.0976 9.31658 15.0976 9.70711 14.7071L11 13.4142V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13.4142L14.2929 14.7071C14.6834 15.0976 15.3166 15.0976 15.7071 14.7071C16.0976 14.3166 16.0976 13.6834 15.7071 13.2929Z"
          fill="#000000"
        ></path>
      </g>
    </svg>
  ),
  submitIcon: (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.1858 0.41959L16.1857 0.419492C15.9822 0.216133 15.6822 0.143742 15.4085 0.230747L15.4083 0.230827L1.33494 4.72522L1.33493 4.72523C1.02383 4.82461 0.809498 5.10962 0.800302 5.43607L0.8003 5.43613C0.791197 5.76253 0.989298 6.05918 1.29442 6.17575L7.90363 8.7017L10.4296 15.3109C10.5436 15.6093 10.8297 15.8053 11.1476 15.8053L11.1688 15.805L11.1693 15.805C11.4957 15.7958 11.7807 15.5815 11.8801 15.2704L11.8801 15.2704L16.3745 1.19708L16.3745 1.19705C16.462 0.923027 16.3892 0.623035 16.1858 0.41959ZM8.77352 7.38811L3.8924 5.52263L14.4564 2.1489L11.0827 12.7129L9.21723 7.83181C9.13915 7.62752 8.97782 7.46618 8.77352 7.38811Z"
        fill="#BBBBBB"
        stroke="#BBBBBB"
        strokeWidth="0.4"
      />
    </svg>
  ),
  uploadCloud: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10V11H17C18.933 11 20.5 12.567 20.5 14.5C20.5 16.433 18.933 18 17 18H16C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20H17C20.0376 20 22.5 17.5376 22.5 14.5C22.5 11.7793 20.5245 9.51997 17.9296 9.07824C17.4862 6.20213 15.0003 4 12 4C8.99974 4 6.51381 6.20213 6.07036 9.07824C3.47551 9.51997 1.5 11.7793 1.5 14.5C1.5 17.5376 3.96243 20 7 20H8C8.55228 20 9 19.5523 9 19C9 18.4477 8.55228 18 8 18H7C5.067 18 3.5 16.433 3.5 14.5C3.5 12.567 5.067 11 7 11H8V10ZM15.7071 13.2929L12.7071 10.2929C12.3166 9.90237 11.6834 9.90237 11.2929 10.2929L8.29289 13.2929C7.90237 13.6834 7.90237 14.3166 8.29289 14.7071C8.68342 15.0976 9.31658 15.0976 9.70711 14.7071L11 13.4142V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13.4142L14.2929 14.7071C14.6834 15.0976 15.3166 15.0976 15.7071 14.7071C16.0976 14.3166 16.0976 13.6834 15.7071 13.2929Z"
          fill="#000000"
        ></path>
      </g>
    </svg>
  ),
  submitIcon: (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.1858 0.41959L16.1857 0.419492C15.9822 0.216133 15.6822 0.143742 15.4085 0.230747L15.4083 0.230827L1.33494 4.72522L1.33493 4.72523C1.02383 4.82461 0.809498 5.10962 0.800302 5.43607L0.8003 5.43613C0.791197 5.76253 0.989298 6.05918 1.29442 6.17575L7.90363 8.7017L10.4296 15.3109C10.5436 15.6093 10.8297 15.8053 11.1476 15.8053L11.1688 15.805L11.1693 15.805C11.4957 15.7958 11.7807 15.5815 11.8801 15.2704L11.8801 15.2704L16.3745 1.19708L16.3745 1.19705C16.462 0.923027 16.3892 0.623035 16.1858 0.41959ZM8.77352 7.38811L3.8924 5.52263L14.4564 2.1489L11.0827 12.7129L9.21723 7.83181C9.13915 7.62752 8.97782 7.46618 8.77352 7.38811Z"
        fill="#BBBBBB"
        stroke="#BBBBBB"
        strokeWidth="0.4"
      />
    </svg>
  ),
  whatsappIcon: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.3789 2.27907 14.6926 2.78382 15.8877C3.06278 16.5481 3.20226 16.8784 3.21953 17.128C3.2368 17.3776 3.16334 17.6521 3.01642 18.2012L2 22L5.79877 20.9836C6.34788 20.8367 6.62244 20.7632 6.87202 20.7805C7.12161 20.7977 7.45185 20.9372 8.11235 21.2162C9.30745 21.7209 10.6211 22 12 22Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M8.58815 12.3773L9.45909 11.2956C9.82616 10.8397 10.2799 10.4153 10.3155 9.80826C10.3244 9.65494 10.2166 8.96657 10.0008 7.58986C9.91601 7.04881 9.41086 7 8.97332 7C8.40314 7 8.11805 7 7.83495 7.12931C7.47714 7.29275 7.10979 7.75231 7.02917 8.13733C6.96539 8.44196 7.01279 8.65187 7.10759 9.07169C7.51023 10.8548 8.45481 12.6158 9.91948 14.0805C11.3842 15.5452 13.1452 16.4898 14.9283 16.8924C15.3481 16.9872 15.558 17.0346 15.8627 16.9708C16.2477 16.8902 16.7072 16.5229 16.8707 16.165C17 15.8819 17 15.5969 17 15.0267C17 14.5891 16.9512 14.084 16.4101 13.9992C15.0334 13.7834 14.3451 13.6756 14.1917 13.6845C13.5847 13.7201 13.1603 14.1738 12.7044 14.5409L11.6227 15.4118"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  ),
  linkedinIcon: (
    <svg width="18" height="18" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M63 6.48529V58.5147C63 59.7043 62.5274 60.8451 61.6863 61.6863C60.8451 62.5274 59.7043 63 58.5147 63H6.48529C5.29572 63 4.15487 62.5274 3.31371 61.6863C2.47256 60.8451 2 59.7043 2 58.5147V6.48529C2 5.29572 2.47256 4.15487 3.31371 3.31371C4.15487 2.47256 5.29572 2 6.48529 2L58.5147 2C59.7043 2 60.8451 2.47256 61.6863 3.31371C62.5274 4.15487 63 5.29572 63 6.48529ZM19.9412 25.3235H10.9706V54.0294H19.9412V25.3235ZM20.7485 15.4559C20.7533 14.7773 20.6243 14.1045 20.369 13.4758C20.1137 12.8471 19.737 12.2748 19.2605 11.7917C18.7841 11.3085 18.2171 10.924 17.592 10.66C16.9669 10.3959 16.2959 10.2576 15.6174 10.2529H15.4559C14.076 10.2529 12.7526 10.8011 11.7768 11.7768C10.8011 12.7526 10.2529 14.076 10.2529 15.4559C10.2529 16.8358 10.8011 18.1592 11.7768 19.1349C12.7526 20.1107 14.076 20.6588 15.4559 20.6588C16.1345 20.6755 16.8097 20.5583 17.443 20.314C18.0763 20.0696 18.6553 19.7029 19.1468 19.2347C19.6383 18.7665 20.0327 18.2061 20.3076 17.5854C20.5824 16.9647 20.7322 16.296 20.7485 15.6174V15.4559ZM54.0294 36.5906C54.0294 27.9609 48.5394 24.6059 43.0853 24.6059C41.2995 24.5165 39.5215 24.8968 37.9286 25.709C36.3357 26.5212 34.9835 27.7369 34.0071 29.2347H33.7559V25.3235H25.3235V54.0294H34.2941V38.7615C34.1644 37.1978 34.657 35.6461 35.6648 34.4434C36.6726 33.2408 38.1142 32.4844 39.6765 32.3385H40.0174C42.87 32.3385 44.9871 34.1326 44.9871 38.6538V54.0294H53.9576L54.0294 36.5906Z"
        stroke="white"
        strokeWidth="3.05"
        strokeLinejoin="round"
      />
    </svg>
  ),
  submitIcon: (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.1858 0.41959L16.1857 0.419492C15.9822 0.216133 15.6822 0.143742 15.4085 0.230747L15.4083 0.230827L1.33494 4.72522L1.33493 4.72523C1.02383 4.82461 0.809498 5.10962 0.800302 5.43607L0.8003 5.43613C0.791197 5.76253 0.989298 6.05918 1.29442 6.17575L7.90363 8.7017L10.4296 15.3109C10.5436 15.6093 10.8297 15.8053 11.1476 15.8053L11.1688 15.805L11.1693 15.805C11.4957 15.7958 11.7807 15.5815 11.8801 15.2704L11.8801 15.2704L16.3745 1.19708L16.3745 1.19705C16.462 0.923027 16.3892 0.623035 16.1858 0.41959ZM8.77352 7.38811L3.8924 5.52263L14.4564 2.1489L11.0827 12.7129L9.21723 7.83181C9.13915 7.62752 8.97782 7.46618 8.77352 7.38811Z"
        fill="#BBBBBB"
        stroke="#BBBBBB"
        strokeWidth="0.4"
      />
    </svg>
  ),
  link: (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.875 0.125L9.5 0.125C9.59946 0.125 9.69484 0.164509 9.76517 0.234835C9.83549 0.305161 9.875 0.400544 9.875 0.5V3.125C9.875 3.33211 9.70711 3.5 9.5 3.5C9.29289 3.5 9.125 3.33211 9.125 3.125V1.40533L3.01516 7.51517C2.86872 7.66161 2.63128 7.66161 2.48484 7.51517C2.33839 7.36872 2.33839 7.13128 2.48484 6.98483L8.59467 0.875L6.875 0.875C6.66789 0.875 6.5 0.707107 6.5 0.5C6.5 0.292893 6.66789 0.125 6.875 0.125ZM1.625 2.375C1.21079 2.375 0.875 2.71079 0.875 3.125V8.375C0.875 8.78921 1.21079 9.125 1.625 9.125H6.875C7.28921 9.125 7.625 8.78921 7.625 8.375V4.25C7.625 4.04289 7.79289 3.875 8 3.875C8.20711 3.875 8.375 4.04289 8.375 4.25V8.375C8.375 9.20343 7.70343 9.875 6.875 9.875H1.625C0.796573 9.875 0.125 9.20343 0.125 8.375V3.125C0.125 2.29657 0.796573 1.625 1.625 1.625H5.75C5.95711 1.625 6.125 1.79289 6.125 2C6.125 2.20711 5.95711 2.375 5.75 2.375H1.625Z"
        fill="#334155"
      />
    </svg>
  ),
  playIcon: (
    <svg
      width="109"
      height="109"
      viewBox="0 0 109 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.5" cx="54.2472" cy="54.2472" r="54.2472" fill="white" />
      <circle cx="54.2451" cy="54.249" r="38.748" fill="white" />
      <path
        d="M65.8769 50.2192C68.9768 52.0089 68.9768 56.4831 65.8769 58.2728L51.9276 66.3265C48.8278 68.1161 44.953 65.879 44.953 62.2996L44.953 46.1924C44.953 42.613 48.8278 40.3759 51.9276 42.1656L65.8769 50.2192Z"
        fill="#121418"
      />
    </svg>
  ),
  whatsappIcon: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.3789 2.27907 14.6926 2.78382 15.8877C3.06278 16.5481 3.20226 16.8784 3.21953 17.128C3.2368 17.3776 3.16334 17.6521 3.01642 18.2012L2 22L5.79877 20.9836C6.34788 20.8367 6.62244 20.7632 6.87202 20.7805C7.12161 20.7977 7.45185 20.9372 8.11235 21.2162C9.30745 21.7209 10.6211 22 12 22Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M8.58815 12.3773L9.45909 11.2956C9.82616 10.8397 10.2799 10.4153 10.3155 9.80826C10.3244 9.65494 10.2166 8.96657 10.0008 7.58986C9.91601 7.04881 9.41086 7 8.97332 7C8.40314 7 8.11805 7 7.83495 7.12931C7.47714 7.29275 7.10979 7.75231 7.02917 8.13733C6.96539 8.44196 7.01279 8.65187 7.10759 9.07169C7.51023 10.8548 8.45481 12.6158 9.91948 14.0805C11.3842 15.5452 13.1452 16.4898 14.9283 16.8924C15.3481 16.9872 15.558 17.0346 15.8627 16.9708C16.2477 16.8902 16.7072 16.5229 16.8707 16.165C17 15.8819 17 15.5969 17 15.0267C17 14.5891 16.9512 14.084 16.4101 13.9992C15.0334 13.7834 14.3451 13.6756 14.1917 13.6845C13.5847 13.7201 13.1603 14.1738 12.7044 14.5409L11.6227 15.4118"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  ),
  playIcon: (
    <svg
      width="109"
      height="109"
      viewBox="0 0 109 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.5" cx="54.2472" cy="54.2472" r="54.2472" fill="white" />
      <circle cx="54.2451" cy="54.249" r="38.748" fill="white" />
      <path
        d="M65.8769 50.2192C68.9768 52.0089 68.9768 56.4831 65.8769 58.2728L51.9276 66.3265C48.8278 68.1161 44.953 65.879 44.953 62.2996L44.953 46.1924C44.953 42.613 48.8278 40.3759 51.9276 42.1656L65.8769 50.2192Z"
        fill="#121418"
      />
    </svg>
  ),
  linkedinIcon: (
    <svg width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M44.4469 0H3.54375C1.58437 0 0 1.54688 0 3.45938V44.5312C0 46.4437 1.58437 48 3.54375 48H44.4469C46.4063 48 48 46.4438 48 44.5406V3.45938C48 1.54688 46.4063 0 44.4469 0ZM14.2406 40.9031H7.11563V17.9906H14.2406V40.9031ZM10.6781 14.8688C8.39063 14.8688 6.54375 13.0219 6.54375 10.7437C6.54375 8.46562 8.39063 6.61875 10.6781 6.61875C12.9563 6.61875 14.8031 8.46562 14.8031 10.7437C14.8031 13.0125 12.9563 14.8688 10.6781 14.8688ZM40.9031 40.9031H33.7875V29.7656C33.7875 27.1125 33.7406 23.6906 30.0844 23.6906C26.3812 23.6906 25.8187 26.5875 25.8187 29.5781V40.9031H18.7125V17.9906H25.5375V21.1219H25.6312C26.5781 19.3219 28.9031 17.4188 32.3625 17.4188C39.5719 17.4188 40.9031 22.1625 40.9031 28.3313V40.9031Z"
        fill="white"
      />
    </svg>
  ),
  submitIcon: (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.1858 0.41959L16.1857 0.419492C15.9822 0.216133 15.6822 0.143742 15.4085 0.230747L15.4083 0.230827L1.33494 4.72522L1.33493 4.72523C1.02383 4.82461 0.809498 5.10962 0.800302 5.43607L0.8003 5.43613C0.791197 5.76253 0.989298 6.05918 1.29442 6.17575L7.90363 8.7017L10.4296 15.3109C10.5436 15.6093 10.8297 15.8053 11.1476 15.8053L11.1688 15.805L11.1693 15.805C11.4957 15.7958 11.7807 15.5815 11.8801 15.2704L11.8801 15.2704L16.3745 1.19708L16.3745 1.19705C16.462 0.923027 16.3892 0.623035 16.1858 0.41959ZM8.77352 7.38811L3.8924 5.52263L14.4564 2.1489L11.0827 12.7129L9.21723 7.83181C9.13915 7.62752 8.97782 7.46618 8.77352 7.38811Z"
        fill="#BBBBBB"
        stroke="#BBBBBB"
        strokeWidth="0.4"
      />
    </svg>
  ),
  whatsappIcon: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.3789 2.27907 14.6926 2.78382 15.8877C3.06278 16.5481 3.20226 16.8784 3.21953 17.128C3.2368 17.3776 3.16334 17.6521 3.01642 18.2012L2 22L5.79877 20.9836C6.34788 20.8367 6.62244 20.7632 6.87202 20.7805C7.12161 20.7977 7.45185 20.9372 8.11235 21.2162C9.30745 21.7209 10.6211 22 12 22Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M8.58815 12.3773L9.45909 11.2956C9.82616 10.8397 10.2799 10.4153 10.3155 9.80826C10.3244 9.65494 10.2166 8.96657 10.0008 7.58986C9.91601 7.04881 9.41086 7 8.97332 7C8.40314 7 8.11805 7 7.83495 7.12931C7.47714 7.29275 7.10979 7.75231 7.02917 8.13733C6.96539 8.44196 7.01279 8.65187 7.10759 9.07169C7.51023 10.8548 8.45481 12.6158 9.91948 14.0805C11.3842 15.5452 13.1452 16.4898 14.9283 16.8924C15.3481 16.9872 15.558 17.0346 15.8627 16.9708C16.2477 16.8902 16.7072 16.5229 16.8707 16.165C17 15.8819 17 15.5969 17 15.0267C17 14.5891 16.9512 14.084 16.4101 13.9992C15.0334 13.7834 14.3451 13.6756 14.1917 13.6845C13.5847 13.7201 13.1603 14.1738 12.7044 14.5409L11.6227 15.4118"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  ),
  playIcon: (
    <svg
      width="109"
      height="109"
      viewBox="0 0 109 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.5" cx="54.2472" cy="54.2472" r="54.2472" fill="white" />
      <circle cx="54.2451" cy="54.249" r="38.748" fill="white" />
      <path
        d="M65.8769 50.2192C68.9768 52.0089 68.9768 56.4831 65.8769 58.2728L51.9276 66.3265C48.8278 68.1161 44.953 65.879 44.953 62.2996L44.953 46.1924C44.953 42.613 48.8278 40.3759 51.9276 42.1656L65.8769 50.2192Z"
        fill="#121418"
      />
    </svg>
  ),
  linkedinIcon: (
    <svg width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M44.4469 0H3.54375C1.58437 0 0 1.54688 0 3.45938V44.5312C0 46.4437 1.58437 48 3.54375 48H44.4469C46.4063 48 48 46.4438 48 44.5406V3.45938C48 1.54688 46.4063 0 44.4469 0ZM14.2406 40.9031H7.11563V17.9906H14.2406V40.9031ZM10.6781 14.8688C8.39063 14.8688 6.54375 13.0219 6.54375 10.7437C6.54375 8.46562 8.39063 6.61875 10.6781 6.61875C12.9563 6.61875 14.8031 8.46562 14.8031 10.7437C14.8031 13.0125 12.9563 14.8688 10.6781 14.8688ZM40.9031 40.9031H33.7875V29.7656C33.7875 27.1125 33.7406 23.6906 30.0844 23.6906C26.3812 23.6906 25.8187 26.5875 25.8187 29.5781V40.9031H18.7125V17.9906H25.5375V21.1219H25.6312C26.5781 19.3219 28.9031 17.4188 32.3625 17.4188C39.5719 17.4188 40.9031 22.1625 40.9031 28.3313V40.9031Z"
        fill="white"
      />
    </svg>
  ),
  reset: (
    <svg
      width="18"
      height="18"
      fill="#000000"
      viewBox="0 0 512 512"
      data-name="Layer 1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M64,256H34A222,222,0,0,1,430,118.15V85h30V190H355V160h67.27A192.21,192.21,0,0,0,256,64C150.13,64,64,150.13,64,256Zm384,0c0,105.87-86.13,192-192,192A192.21,192.21,0,0,1,89.73,352H157V322H52V427H82V393.85A222,222,0,0,0,478,256Z"></path>
      </g>
    </svg>
  ),
  prevIcon: (
    <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.54912 0.43256C5.8085 0.702317 5.80009 1.13127 5.53033 1.39065L1.97269 4.74196L5.53033 8.09326C5.80009 8.35265 5.8085 8.7816 5.54912 9.05135C5.28973 9.32111 4.86078 9.32952 4.59103 9.07014L0.525415 5.23039C0.392552 5.10264 0.317465 4.92628 0.317465 4.74196C0.317465 4.55764 0.392552 4.38127 0.525415 4.25352L4.59103 0.413774C4.86078 0.154393 5.28973 0.162804 5.54912 0.43256Z"
        fill="#202020"
      />
    </svg>
  ),
  nextIcon: (
    <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.823931 9.05084C0.564549 8.78108 0.57296 8.35213 0.842717 8.09275L4.40035 4.74144L0.842716 1.39013C0.572959 1.13075 0.564549 0.701802 0.82393 0.432045C1.08331 0.162289 1.51226 0.153878 1.78202 0.413259L5.84763 4.253C5.9805 4.38076 6.05558 4.55712 6.05558 4.74144C6.05558 4.92576 5.9805 5.10213 5.84763 5.22988L1.78202 9.06962C1.51226 9.32901 1.08331 9.32059 0.823931 9.05084Z"
        fill="#202020"
      />
    </svg>
  ),
  nextArrow: (
    <svg fill="none" width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="19.6875" fill="white" stroke="none" strokeWidth="0.625" />
      <path d="M17.5 13.75L23.75 20L17.5 26.25" stroke="#3D3D3D" strokeWidth="1.5" />
    </svg>
  ),
  filter: (
    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none">
      <path
        d="M14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5M14 5C14 6.10457 13.1046 7 12 7C10.8954 7 10 6.10457 10 5M14 5H20M10 5L4 5M16 12C16 13.1046 16.8954 14 18 14C19.1046 14 20 13.1046 20 12C20 10.8954 19.1046 10 18 10C16.8954 10 16 10.8954 16 12ZM16 12H4M8 19C8 17.8954 7.10457 17 6 17C4.89543 17 4 17.8954 4 19C4 20.1046 4.89543 21 6 21C7.10457 21 8 20.1046 8 19ZM8 19H20"
        stroke="#303030"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  ),
  gridIcon: (
    <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="1.4142"
        y="1.62514"
        width="8.29962"
        height="8.29944"
        rx="2.37936"
        stroke="#596780"
        strokeWidth="1.47294"
        fill="none"
      />
      <rect
        x="12.8165"
        y="1.62514"
        width="8.29962"
        height="8.29944"
        rx="2.37936"
        stroke="#596780"
        strokeWidth="1.47294"
        fill="none"
      />
      <rect
        x="1.4142"
        y="13.026"
        width="8.29962"
        height="8.29944"
        rx="2.37936"
        stroke="#596780"
        strokeWidth="1.47294"
        fill="none"
      />
      <rect
        x="12.8165"
        y="13.026"
        width="8.29962"
        height="8.29944"
        rx="2.37936"
        stroke="#596780"
        strokeWidth="1.47294"
        fill="none"
      />
    </svg>
  ),
  tileIcon: (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.736468"
        y="0.736468"
        width="19.5271"
        height="19.5271"
        rx="2.37936"
        stroke="#596780"
        strokeWidth="1.47294"
        fill="none"
      />
    </svg>
  ),
  legalProperty: (
    <svg
      width="121"
      height="121"
      viewBox="0 0 121 121"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.15" cx="60.3209" cy="60.483" r="59.9107" fill="#0055FF" />
      <path
        d="M60.3173 96.8017C80.2876 96.8017 96.6269 80.4624 96.6269 60.4921C96.6269 40.5219 80.2876 24.1826 60.3173 24.1826C40.3471 24.1826 24.0078 40.5219 24.0078 60.4921C24.0078 80.4624 40.3471 96.8017 60.3173 96.8017Z"
        fill="#0055FF"
      />
      <path d="M43.3516 77.2439H78.6445V41.9511H43.3516V77.2439Z" fill="#777E91" />
    </svg>
  ),
  success: (
    <svg
      width="121"
      height="121"
      viewBox="0 0 121 121"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.15" cx="60.4991" cy="60.483" r="59.9107" fill="#0055FF" />
      <path
        d="M60.496 96.8026C80.4663 96.8026 96.8056 80.4634 96.8056 60.4931C96.8056 40.5229 80.4663 24.1836 60.496 24.1836C40.5258 24.1836 24.1865 40.5229 24.1865 60.4931C24.1865 80.4634 40.5258 96.8026 60.496 96.8026Z"
        fill="#0055FF"
      />
      <path
        d="M45.0649 60.4924L55.3405 70.768L75.928 50.2168"
        stroke="white"
        fill="none"
        strokeWidth="6.53571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  inComplete: (
    <svg
      width="121"
      height="121"
      viewBox="0 0 121 121"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.15" cx="60.4986" cy="60.483" r="59.9107" fill="#FF8E09" />
      <path d="M44.1063 75.4351H78.8928V40.6486H44.1063V75.4351Z" fill="black" />
    </svg>
  ),
  tiltedArrow: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.586 5.65692L6.636 1.70692C6.45384 1.51832 6.35305 1.26571 6.35533 1.00352C6.3576 0.741321 6.46277 0.490508 6.64818 0.3051C6.83359 0.119692 7.0844 0.0145233 7.3466 0.0122448C7.6088 0.00996641 7.8614 0.110761 8.05 0.292919L13.707 5.94992C13.8002 6.04257 13.8741 6.15273 13.9246 6.27407C13.9751 6.3954 14.001 6.52551 14.001 6.65692C14.001 6.78833 13.9751 6.91844 13.9246 7.03977C13.8741 7.16111 13.8002 7.27127 13.707 7.36392L8.05 13.0209C7.95775 13.1164 7.84741 13.1926 7.7254 13.245C7.6034 13.2974 7.47218 13.325 7.3394 13.3262C7.20662 13.3273 7.07494 13.302 6.95205 13.2517C6.82915 13.2015 6.7175 13.1272 6.62361 13.0333C6.52971 12.9394 6.45546 12.8278 6.40518 12.7049C6.3549 12.582 6.3296 12.4503 6.33075 12.3175C6.3319 12.1847 6.35949 12.0535 6.4119 11.9315C6.46431 11.8095 6.54049 11.6992 6.636 11.6069L10.586 7.65692H1C0.734784 7.65692 0.48043 7.55156 0.292893 7.36403C0.105357 7.17649 0 6.92214 0 6.65692C0 6.3917 0.105357 6.13735 0.292893 5.94981C0.48043 5.76228 0.734784 5.65692 1 5.65692H10.586Z"
        fill="#f15772"
      />
    </svg>
  ),
  favorite: (
    <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8791 8.88915L9.0077 15.5L2.13626 8.88915M2.13626 8.88915C1.68302 8.46072 1.32601 7.94577 1.08772 7.37673C0.849422 6.80769 0.734997 6.19689 0.75165 5.58278C0.768302 4.96867 0.915671 4.36456 1.18448 3.8085C1.45328 3.25243 1.8377 2.75645 2.31353 2.3518C2.78935 1.94714 3.34628 1.64257 3.94923 1.45727C4.55218 1.27197 5.1881 1.20994 5.81694 1.27511C6.44578 1.34027 7.05392 1.53121 7.60306 1.83589C8.1522 2.14058 8.63045 2.55242 9.0077 3.04547C9.38657 2.556 9.86538 2.14776 10.4141 1.8463C10.9629 1.54485 11.5698 1.35667 12.1969 1.29354C12.824 1.23042 13.4577 1.2937 14.0585 1.47944C14.6592 1.66517 15.214 1.96936 15.6882 2.37296C16.1623 2.77657 16.5456 3.27089 16.814 3.82501C17.0825 4.37912 17.2303 4.9811 17.2482 5.59326C17.2661 6.20541 17.1538 6.81458 16.9182 7.38262C16.6826 7.95066 16.3289 8.46536 15.8791 8.89449"
        fill="#53265e"
      />
      <path
        d="M15.8791 8.88915L9.0077 15.5L2.13626 8.88915M2.13626 8.88915C1.68302 8.46072 1.32601 7.94577 1.08772 7.37673C0.849422 6.80769 0.734997 6.19689 0.75165 5.58278C0.768302 4.96867 0.915671 4.36456 1.18448 3.8085C1.45328 3.25243 1.8377 2.75645 2.31353 2.3518C2.78935 1.94714 3.34628 1.64257 3.94923 1.45727C4.55218 1.27197 5.1881 1.20994 5.81694 1.27511C6.44578 1.34027 7.05392 1.53121 7.60306 1.83589C8.1522 2.14058 8.63045 2.55242 9.0077 3.04547C9.38657 2.556 9.86538 2.14776 10.4141 1.8463C10.9629 1.54485 11.5698 1.35667 12.1969 1.29354C12.824 1.23042 13.4577 1.2937 14.0585 1.47944C14.6592 1.66517 15.214 1.96936 15.6882 2.37296C16.1623 2.77657 16.5456 3.27089 16.814 3.82501C17.0825 4.37912 17.2303 4.9811 17.2482 5.59326C17.2661 6.20541 17.1538 6.81458 16.9182 7.38262C16.6826 7.95066 16.3289 8.46536 15.8791 8.89449"
        stroke="#53265e"
        strokeWidth="1"
        strokeLinecap="round"
        fill="none"
        strokeLinejoin="round"
      />
    </svg>
  ),
  unfavorite: (
    <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8791 8.88915L9.0077 15.5L2.13626 8.88915M2.13626 8.88915C1.68302 8.46072 1.32601 7.94577 1.08772 7.37673C0.849422 6.80769 0.734997 6.19689 0.75165 5.58278C0.768302 4.96867 0.915671 4.36456 1.18448 3.8085C1.45328 3.25243 1.8377 2.75645 2.31353 2.3518C2.78935 1.94714 3.34628 1.64257 3.94923 1.45727C4.55218 1.27197 5.1881 1.20994 5.81694 1.27511C6.44578 1.34027 7.05392 1.53121 7.60306 1.83589C8.1522 2.14058 8.63045 2.55242 9.0077 3.04547C9.38657 2.556 9.86538 2.14776 10.4141 1.8463C10.9629 1.54485 11.5698 1.35667 12.1969 1.29354C12.824 1.23042 13.4577 1.2937 14.0585 1.47944C14.6592 1.66517 15.214 1.96936 15.6882 2.37296C16.1623 2.77657 16.5456 3.27089 16.814 3.82501C17.0825 4.37912 17.2303 4.9811 17.2482 5.59326C17.2661 6.20541 17.1538 6.81458 16.9182 7.38262C16.6826 7.95066 16.3289 8.46536 15.8791 8.89449"
        stroke="#121212"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  location: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M12 21C15.5 17.4 19 14.1764 19 10.2C19 6.22355 15.866 3 12 3C8.13401 3 5 6.22355 5 10.2C5 14.1764 8.5 17.4 12 21Z"
          stroke="#8e8c8c"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>
        <path
          d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
          stroke="#8e8c8c"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>
      </g>
    </svg>
  ),
  login: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.57757 15.4816C5.1628 16.324 1.45336 18.0441 3.71266 20.1966C4.81631 21.248 6.04549 22 7.59087 22H16.4091C17.9545 22 19.1837 21.248 20.2873 20.1966C22.5466 18.0441 18.8372 16.324 17.4224 15.4816C14.1048 13.5061 9.89519 13.5061 6.57757 15.4816Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M16.5 6.5C16.5 8.98528 14.4853 11 12 11C9.51472 11 7.5 8.98528 7.5 6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        fill="none"
      />
    </svg>
  ),
  commission: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 18C10.6675 18.6224 8.91707 19 7 19C5.93408 19 4.91969 18.8833 4 18.6726C3.4088 18.5372 3.11319 18.4695 2.75898 18.1892C2.55696 18.0294 2.30483 17.7129 2.19412 17.4803C2 17.0725 2 16.677 2 15.886V5.11397C2 4.12914 3.04003 3.45273 4 3.6726C4.91969 3.88325 5.93408 4 7 4C8.91707 4 10.6675 3.62236 12 3C13.3325 2.37764 15.0829 2 17 2C18.0659 2 19.0803 2.11675 20 2.3274C20.5912 2.46281 20.8868 2.53051 21.241 2.81079C21.443 2.97064 21.6952 3.28705 21.8059 3.51966C22 3.92751 22 4.32299 22 5.11397V15.886C22 16.8709 20.96 17.5473 20 17.3274C19.0803 17.1167 18.0659 17 17 17C15.0829 17 13.3325 17.3776 12 18Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M2 21C3.33254 21.6224 5.08293 22 7 22C8.91707 22 10.6675 21.6224 12 21C13.3325 20.3776 15.0829 20 17 20C18.9171 20 20.6675 20.3776 22 21"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M14.5 10.5C14.5 11.8807 13.3807 13 12 13C10.6193 13 9.5 11.8807 9.5 10.5C9.5 9.11929 10.6193 8 12 8C13.3807 8 14.5 9.11929 14.5 10.5Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M5.5 11.5L5.5 11.509"
        stroke="#2A353D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M18.5 9.49219L18.5 9.50117"
        stroke="#2A353D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  shipping: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="17" cy="18" r="2" stroke="#2A353D" strokeWidth="1.5" fill="none" />
      <circle cx="7" cy="18" r="2" stroke="#2A353D" strokeWidth="1.5" fill="none" />
      <path
        d="M5 17.9724C3.90328 17.9178 3.2191 17.7546 2.73223 17.2678C2.24536 16.7809 2.08222 16.0967 2.02755 15M9 18H15M19 17.9724C20.0967 17.9178 20.7809 17.7546 21.2678 17.2678C22 16.5355 22 15.357 22 13V11H17.3C16.5555 11 16.1832 11 15.882 10.9021C15.2731 10.7043 14.7957 10.2269 14.5979 9.61803C14.5 9.31677 14.5 8.94451 14.5 8.2C14.5 7.08323 14.5 6.52485 14.3532 6.07295C14.0564 5.15964 13.3404 4.44358 12.4271 4.14683C11.9752 4 11.4168 4 10.3 4H2"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M2 8H8"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M2 11H6"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14.5 6H16.3212C17.7766 6 18.5042 6 19.0964 6.35371C19.6886 6.70742 20.0336 7.34811 20.7236 8.6295L22 11"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  connections: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.774 18C21.5233 18 22.1193 17.5285 22.6545 16.8691C23.7499 15.5194 21.9513 14.4408 21.2654 13.9126C20.568 13.3756 19.7894 13.0714 19 13M18 11C19.3807 11 20.5 9.88071 20.5 8.5C20.5 7.11929 19.3807 6 18 6"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M3.22596 18C2.47666 18 1.88067 17.5285 1.34555 16.8691C0.250089 15.5194 2.04867 14.4408 2.73465 13.9126C3.43197 13.3756 4.21058 13.0714 5 13M5.5 11C4.11929 11 3 9.88071 3 8.5C3 7.11929 4.11929 6 5.5 6"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M8.0838 15.1112C7.06203 15.743 4.38299 17.0331 6.0147 18.6474C6.81178 19.436 7.69952 20 8.81563 20H15.1844C16.3005 20 17.1882 19.436 17.9853 18.6474C19.617 17.0331 16.938 15.743 15.9162 15.1112C13.5201 13.6296 10.4799 13.6296 8.0838 15.1112Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M15.5 7.5C15.5 9.433 13.933 11 12 11C10.067 11 8.5 9.433 8.5 7.5C8.5 5.567 10.067 4 12 4C13.933 4 15.5 5.567 15.5 7.5Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        fill="none"
      />
    </svg>
  ),
  star: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M9.15316 5.40838C10.4198 3.13613 11.0531 2 12 2C12.9469 2 13.5802 3.13612 14.8468 5.40837L15.1745 5.99623C15.5345 6.64193 15.7144 6.96479 15.9951 7.17781C16.2757 7.39083 16.6251 7.4699 17.3241 7.62805L17.9605 7.77203C20.4201 8.32856 21.65 8.60682 21.9426 9.54773C22.2352 10.4886 21.3968 11.4691 19.7199 13.4299L19.2861 13.9372C18.8096 14.4944 18.5713 14.773 18.4641 15.1177C18.357 15.4624 18.393 15.8341 18.465 16.5776L18.5306 17.2544C18.7841 19.8706 18.9109 21.1787 18.1449 21.7602C17.3788 22.3417 16.2273 21.8115 13.9243 20.7512L13.3285 20.4768C12.6741 20.1755 12.3469 20.0248 12 20.0248C11.6531 20.0248 11.3259 20.1755 10.6715 20.4768L10.0757 20.7512C7.77268 21.8115 6.62118 22.3417 5.85515 21.7602C5.08912 21.1787 5.21588 19.8706 5.4694 17.2544L5.53498 16.5776C5.60703 15.8341 5.64305 15.4624 5.53586 15.1177C5.42868 14.773 5.19043 14.4944 4.71392 13.9372L4.2801 13.4299C2.60325 11.4691 1.76482 10.4886 2.05742 9.54773C2.35002 8.60682 3.57986 8.32856 6.03954 7.77203L6.67589 7.62805C7.37485 7.4699 7.72433 7.39083 8.00494 7.17781C8.28555 6.96479 8.46553 6.64194 8.82547 5.99623L9.15316 5.40838Z"
          fill="#000000"
        ></path>
      </g>
    </svg>
  ),
  startSelling: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.9961 10H11.0111M10.9998 16H11.0148"
        stroke="#2A353D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M7 13H15"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <circle
        cx="1.5"
        cy="1.5"
        r="1.5"
        transform="matrix(1 0 0 -1 16 8.00024)"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M2.77423 11.1439C1.77108 12.2643 1.7495 13.9546 2.67016 15.1437C4.49711 17.5033 6.49674 19.5029 8.85633 21.3298C10.0454 22.2505 11.7357 22.2289 12.8561 21.2258C15.8979 18.5022 18.6835 15.6559 21.3719 12.5279C21.6377 12.2187 21.8039 11.8397 21.8412 11.4336C22.0062 9.63798 22.3452 4.46467 20.9403 3.05974C19.5353 1.65481 14.362 1.99377 12.5664 2.15876C12.1603 2.19608 11.7813 2.36233 11.472 2.62811C8.34412 5.31646 5.49781 8.10211 2.77423 11.1439Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        fill="none"
      />
    </svg>
  ),
  accessibility: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0" fill="none"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" fill="none"></g>
      <g id="SVGRepo_iconCarrier">
        <circle cx="12" cy="12" r="10" stroke="#1C274C" strokeWidth="1.5" fill="none"></circle>
        <path
          d="M14 7C14 8.10457 13.1046 9 12 9C10.8954 9 10 8.10457 10 7C10 5.89543 10.8954 5 12 5C13.1046 5 14 5.89543 14 7Z"
          stroke="#1C274C"
          strokeWidth="1.5"
          fill="none"
        ></path>
        <path
          d="M18 10C18 10 14.4627 11.5 12 11.5C9.53727 11.5 6 10 6 10"
          stroke="#1C274C"
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="none"
        ></path>
        <path
          d="M12 12V13.4522M12 13.4522C12 14.0275 12.1654 14.5906 12.4765 15.0745L15 19M12 13.4522C12 14.0275 11.8346 14.5906 11.5235 15.0745L9 19"
          stroke="#1C274C"
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="none"
        ></path>
      </g>
    </svg>
  ),
  sustainability: (
    <svg
      width="24"
      height="24"
      fill="#000000"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g id="Sustainability_approved">
          <path d="M393.33,141.86c-4.7-5.71-9.13-11.1-11.25-16.21-2.28-5.49-3-12.71-3.82-20.34-1.3-12.64-2.79-27-12.49-36.67s-24-11.19-36.67-12.5c-7.64-.79-14.85-1.54-20.35-3.81-5.1-2.12-10.5-6.56-16.21-11.26-10-8.22-21.3-17.53-35.63-17.53s-25.65,9.31-35.64,17.53c-5.71,4.7-11.1,9.14-16.21,11.26-5.49,2.27-12.71,3-20.34,3.81-12.64,1.31-27,2.79-36.67,12.49s-11.19,24-12.5,36.68c-.79,7.63-1.54,14.85-3.81,20.34-2.12,5.11-6.56,10.5-11.26,16.21-8.21,10-17.52,21.3-17.52,35.64s9.31,25.65,17.52,35.63c4.7,5.71,9.14,11.11,11.26,16.21,2.27,5.49,3,12.71,3.81,20.35,1.31,12.64,2.79,27,12.5,36.67s24,11.18,36.67,12.49c7.63.79,14.85,1.54,20.34,3.82,5.11,2.11,10.5,6.55,16.21,11.25,10,8.22,21.31,17.53,35.64,17.53s25.65-9.31,35.63-17.53c5.71-4.7,11.11-9.14,16.21-11.25,5.5-2.28,12.71-3,20.35-3.82,12.64-1.3,27-2.79,36.67-12.49s11.19-24,12.49-36.67c.79-7.64,1.54-14.85,3.82-20.35,2.12-5.1,6.55-10.5,11.25-16.21,8.22-10,17.53-21.3,17.53-35.63S401.55,151.85,393.33,141.86Zm-13.9,59.83c-5.33,6.48-10.84,13.18-14,20.76-3.28,7.92-4.2,16.8-5.09,25.38-1.1,10.6-2.13,20.61-7.32,25.8s-15.2,6.22-25.8,7.32c-8.58.89-17.46,1.81-25.38,5.09-7.58,3.14-14.28,8.65-20.75,14-8.4,6.91-16.32,13.43-24.2,13.43s-15.81-6.52-24.2-13.43c-6.48-5.33-13.18-10.84-20.75-14-7.92-3.28-16.8-4.2-25.39-5.09-10.6-1.1-20.61-2.13-25.8-7.32s-6.22-15.2-7.31-25.8c-.89-8.58-1.81-17.46-5.1-25.38-3.14-7.58-8.65-14.28-14-20.76C127.48,193.3,121,185.38,121,177.5s6.52-15.81,13.42-24.2c5.33-6.48,10.84-13.18,14-20.76,3.29-7.91,4.21-16.79,5.1-25.38,1.09-10.6,2.13-20.61,7.32-25.8S176,75.14,186.57,74C195.16,73.16,204,72.24,212,69c7.57-3.14,14.27-8.65,20.75-14,8.39-6.9,16.32-13.43,24.2-13.43s15.8,6.53,24.2,13.43c6.47,5.33,13.17,10.84,20.75,14,7.92,3.29,16.8,4.21,25.38,5.09,10.6,1.1,20.61,2.14,25.8,7.32s6.22,15.2,7.32,25.8c.89,8.59,1.81,17.47,5.09,25.38,3.14,7.58,8.65,14.28,14,20.76,6.91,8.39,13.43,16.32,13.43,24.2S386.34,193.3,379.43,201.69Z"></path>
          <path d="M259,94.77a84.89,84.89,0,1,0,84.88,84.89A84.89,84.89,0,0,0,259,94.77Zm45.79,67.67c-32.23,16.49-52.91,51.26-53.12,51.61a10.49,10.49,0,0,1-7.83,5.11,10.1,10.1,0,0,1-1.22.07,10.49,10.49,0,0,1-7.58-3.24l-23.43-24.47A10.5,10.5,0,1,1,226.81,177l14.42,15.06c9.8-13.36,28.59-35.3,54-48.32a10.5,10.5,0,0,1,9.57,18.7Z"></path>
          <path d="M342.73,350.57c-18.59-.89-53.46,1.21-78.31,25.17a79.82,79.82,0,0,0-7.2,8,79.82,79.82,0,0,0-7.2-8c-24.85-24-59.73-26.06-78.31-25.17a23.87,23.87,0,0,0-22.8,22.8c-.88,18.57,1.21,53.45,25.17,78.3,17.28,17.92,42.48,27.25,75,27.75.94,0,18.73,0,21.28-.14,30.11-1.35,53.63-10.61,70-27.61,24-24.85,26.06-59.73,25.18-78.3A23.87,23.87,0,0,0,342.73,350.57ZM227.46,421,221.9,437.8c.86.3,17.55,6.18,26.06,23.59-26.83-.65-47.33-8.11-60.92-22.21-19.27-20-20.9-49.28-20.15-65a5.94,5.94,0,0,1,5.68-5.67c15.67-.75,45,.88,65,20.15,13.5,13,20.9,32.35,22.08,57.53A67.75,67.75,0,0,0,227.46,421Zm99.93,18.15c-11.71,12.16-28.58,19.37-50.21,21.54a24.64,24.64,0,0,0,.6-5.12c.23-21.49-3.23-39.93-10.32-55.16a61.88,61.88,0,0,1,9.45-11.74c17.7-17.06,42.68-20.29,59.06-20.29,2.12,0,4.1,0,5.9.14a5.94,5.94,0,0,1,5.68,5.67C348.29,389.9,346.67,419.19,327.39,439.18Z"></path>
        </g>
      </g>
    </svg>
  ),
  community: (
    <svg
      width="24"
      height="24"
      fill="#000000"
      viewBox="0 0 128 128"
      id="Layer_1"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <path d="M64,42c-13.2,0-24,10.8-24,24s10.8,24,24,24s24-10.8,24-24S77.2,42,64,42z M64,82c-8.8,0-16-7.2-16-16s7.2-16,16-16 s16,7.2,16,16S72.8,82,64,82z"></path>
          <path d="M64,100.8c-14.9,0-29.2,6.2-39.4,17.1l-2.7,2.9l5.8,5.5l2.7-2.9c8.8-9.4,20.7-14.6,33.6-14.6s24.8,5.2,33.6,14.6l2.7,2.9 l5.8-5.5l-2.7-2.9C93.2,107.1,78.9,100.8,64,100.8z"></path>
          <path d="M97,47.9v8c9.4,0,18.1,3.8,24.6,10.7l5.8-5.5C119.6,52.7,108.5,47.9,97,47.9z"></path>
          <path d="M116.1,20c0-10.5-8.6-19.1-19.1-19.1S77.9,9.5,77.9,20S86.5,39.1,97,39.1S116.1,30.5,116.1,20z M85.9,20 c0-6.1,5-11.1,11.1-11.1s11.1,5,11.1,11.1s-5,11.1-11.1,11.1S85.9,26.1,85.9,20z"></path>
          <path d="M31,47.9c-11.5,0-22.6,4.8-30.4,13.2l5.8,5.5c6.4-6.9,15.2-10.7,24.6-10.7V47.9z"></path>
          <path d="M50.1,20C50.1,9.5,41.5,0.9,31,0.9S11.9,9.5,11.9,20S20.5,39.1,31,39.1S50.1,30.5,50.1,20z M31,31.1 c-6.1,0-11.1-5-11.1-11.1S24.9,8.9,31,8.9s11.1,5,11.1,11.1S37.1,31.1,31,31.1z"></path>
        </g>
      </g>
    </svg>
  ),
  groupIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7"
        stroke="#fff"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M14 2.20004C13.3538 2.06886 12.6849 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 11.3151 21.9311 10.6462 21.8 10"
        stroke="#fff"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M16.6031 7.39687L12 12M16.6031 7.39687L16.2781 6.15129C16.0319 5.20771 16.369 4.11915 17.1487 3.33944L18.298 2.19006C18.6041 1.88401 19.0779 1.95969 19.1745 2.33007L19.6909 4.30912L21.6699 4.82548C22.0403 4.92211 22.116 5.39591 21.8099 5.70196L20.6606 6.85135C19.8809 7.63105 18.7923 7.96805 17.8487 7.72186L16.6031 7.39687Z"
        stroke="#fff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  upload: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0" fill="none"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" fill="none"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10V11H17C18.933 11 20.5 12.567 20.5 14.5C20.5 16.433 18.933 18 17 18H16C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20H17C20.0376 20 22.5 17.5376 22.5 14.5C22.5 11.7793 20.5245 9.51997 17.9296 9.07824C17.4862 6.20213 15.0003 4 12 4C8.99974 4 6.51381 6.20213 6.07036 9.07824C3.47551 9.51997 1.5 11.7793 1.5 14.5C1.5 17.5376 3.96243 20 7 20H8C8.55228 20 9 19.5523 9 19C9 18.4477 8.55228 18 8 18H7C5.067 18 3.5 16.433 3.5 14.5C3.5 12.567 5.067 11 7 11H8V10ZM15.7071 13.2929L12.7071 10.2929C12.3166 9.90237 11.6834 9.90237 11.2929 10.2929L8.29289 13.2929C7.90237 13.6834 7.90237 14.3166 8.29289 14.7071C8.68342 15.0976 9.31658 15.0976 9.70711 14.7071L11 13.4142V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13.4142L14.2929 14.7071C14.6834 15.0976 15.3166 15.0976 15.7071 14.7071C16.0976 14.3166 16.0976 13.6834 15.7071 13.2929Z"
          fill="#000000"
        ></path>
      </g>
    </svg>
  ),
  image: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform="rotate(0)"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23 4C23 2.34315 21.6569 1 20 1H4C2.34315 1 1 2.34315 1 4V20C1 21.6569 2.34315 23 4 23H20C21.6569 23 23 21.6569 23 20V4ZM21 4C21 3.44772 20.5523 3 20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4Z"
          fill="#0F0F0F"
        ></path>
        <path
          d="M4.80665 17.5211L9.1221 9.60947C9.50112 8.91461 10.4989 8.91461 10.8779 9.60947L14.0465 15.4186L15.1318 13.5194C15.5157 12.8476 16.4843 12.8476 16.8682 13.5194L19.1451 17.5039C19.526 18.1705 19.0446 19 18.2768 19H5.68454C4.92548 19 4.44317 18.1875 4.80665 17.5211Z"
          fill="#0F0F0F"
        ></path>
        <path
          d="M18 8C18 9.10457 17.1046 10 16 10C14.8954 10 14 9.10457 14 8C14 6.89543 14.8954 6 16 6C17.1046 6 18 6.89543 18 8Z"
          fill="#0F0F0F"
        ></path>
      </g>
    </svg>
  ),
  removeIcon: (
    <svg
      width="10px"
      height="10px"
      viewBox="0 0 10 10"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g strokeWidth="1" fillRule="evenodd">
        <g transform="translate(-821.000000, -311.000000)">
          <g transform="translate(809.000000, 299.000000)">
            <path
              d="M21.5833333,16.5833333 L17.4166667,16.5833333 L17.4166667,12.4170833 C17.4166667,12.1866667 17.2391667,12 17.00875,12 C16.77875,12 16.5920833,12.18625 16.5920833,12.41625 L16.5883333,16.5833333 L12.4166667,16.5833333 C12.18625,16.5833333 12,16.7695833 12,17 C12,17.23 12.18625,17.4166667 12.4166667,17.4166667 L16.5875,17.4166667 L16.5833333,21.5829167 C16.5829167,21.8129167 16.7691667,21.9995833 16.9991667,22 L16.9995833,22 C17.2295833,22 17.41625,21.81375 17.4166667,21.58375 L17.4166667,17.4166667 L21.5833333,17.4166667 C21.8133333,17.4166667 22,17.23 22,17 C22,16.7695833 21.8133333,16.5833333 21.5833333,16.5833333"
              transform="translate(17.000000, 17.000000) rotate(-45.000000) translate(-17.000000, -17.000000) "
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  Costumes: (
    <svg
      fill="#000000"
      width={24}
      height={24}
      viewBox="0 0 556 800"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M555.682 768.117C532.608 510.763 553.226 597.975 464.386 373.516V289.536L500.866 173.819C503.554 165.292 502.197 156.005 497.182 148.602C473.424 113.536 461.133 68.2344 465.874 33.1922C468.251 15.6297 454.574 0 436.871 0H354.947C342.783 0 331.888 7.52187 327.577 18.9C315.822 49.9219 310.84 77.575 277.904 77.575C244.969 77.575 239.999 49.9625 228.23 18.9C223.916 7.52187 213.021 0 200.857 0H118.93C101.207 0 87.5521 15.6469 89.9255 33.1922C94.6646 68.2359 82.3755 113.537 58.6177 148.602C53.6036 156.005 52.2458 165.292 54.9333 173.819L91.413 289.536V373.516C2.55204 598.039 23.1536 511.197 0.119231 768.117C-1.41671 785.239 12.0833 800 29.2708 800H526.532C543.719 800 557.216 785.234 555.682 768.117ZM149.188 58.5359H180.647L185.996 72.6516C200.604 111.202 236.677 136.109 277.901 136.109C319.124 136.109 355.197 111.2 369.805 72.6516L375.154 58.5359H406.613C408.502 95.3828 420.643 134.919 440.952 169.18L413.657 255.761H142.144L114.849 169.18C135.16 134.919 147.302 95.3828 149.188 58.5359ZM405.847 314.298V349.83H149.952V314.298H405.847ZM61.2645 741.464C79.9052 531.18 62.3489 606.019 140.577 408.367H415.226C493.408 605.905 475.901 531.152 494.538 741.464H61.2645Z"
        fill="black"
      />
    </svg>
  ),
  SkatesBlades: (
    <svg
      fill="#000000"
      width={24}
      height={24}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 484.49 484.49"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M452.49,348.708v-38.297c0-25.32-19.757-49.62-44.978-55.321l-0.646-0.131c-0.794-0.143-79.617-14.362-103.028-19.653 c-11.502-2.6-21.592-15.225-21.592-27.018V13.666L60.401,33.8v305.568H0v30h39.003c-6.695,10.294-10.602,22.56-10.602,35.728 c0,36.242,29.485,65.728,65.728,65.728s65.728-29.485,65.728-65.728c0-13.168-3.907-25.434-10.602-35.728h52.064 c-6.695,10.294-10.602,22.56-10.602,35.728c0,36.242,29.485,65.728,65.728,65.728s65.728-29.485,65.728-65.728 c0-13.168-3.907-25.434-10.602-35.728h52.065c-6.695,10.294-10.602,22.56-10.602,35.728c0,36.242,29.485,65.728,65.729,65.728 c36.242,0,65.728-29.485,65.728-65.728C484.49,381.177,471.643,360.207,452.49,348.708z M90.401,61.201l161.845-14.688v47.676 h-57.351v30h57.351v40h-57.351v30h57.351v14.099c0,25.858,19.757,50.579,44.979,56.279c23.464,5.304,97.344,18.657,103.953,19.85 c11.582,2.771,21.313,14.606,21.313,25.995v28.958H90.401V61.201z M129.856,405.096c0,19.7-16.027,35.728-35.728,35.728 s-35.728-16.027-35.728-35.728c0-19.701,16.027-35.728,35.728-35.728S129.856,385.396,129.856,405.096z M292.173,405.096 c0,19.7-16.027,35.728-35.728,35.728s-35.728-16.027-35.728-35.728c0-19.701,16.027-35.728,35.728-35.728 S292.173,385.396,292.173,405.096z M418.763,440.824c-19.701,0-35.729-16.027-35.729-35.728c0-19.701,16.027-35.728,35.729-35.728 c19.7,0,35.728,16.027,35.728,35.728C454.49,424.797,438.463,440.824,418.763,440.824z"></path>
      </g>
    </svg>
  ),
  Practicewear: (
    <svg
      fill="#000000"
      height={24}
      width={24}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 481.758 481.758"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M479.832,173.064c-5.238-10.529-51.881-103.35-76.299-119.953c-23.49-15.975-81.035-40.607-83.474-41.648l-2.809-1.199 l-3,0.575c-0.486,0.093-48.893,9.319-73.372,9.319c-24.46,0-72.886-9.226-73.372-9.319l-3-0.575l-2.809,1.199 c-2.439,1.041-59.983,25.673-83.474,41.647C53.807,69.715,7.164,162.535,1.926,173.064L0,176.935l1.5,4.054 c0.628,1.698,16.181,41.7,84.724,50.834l5.941,0.792l21.049-29.278c9.468,54.128-4.04,181.588-20.761,242.943l-2.404,8.822 l8.573,3.182c1.453,0.54,36.8,13.209,142.256,13.209c105.457,0,140.803-12.669,142.256-13.209l8.573-3.182l-2.404-8.822 c-16.721-61.357-30.229-188.816-20.761-242.943l21.049,29.277l5.941-0.792c68.543-9.134,84.096-49.135,84.724-50.834l1.501-4.054 L479.832,173.064z M295.906,34.326c-9.83,11.487-27.107,24.458-55.027,24.458c-27.927,0-45.206-12.978-55.031-24.459 c16.873,2.703,39.72,5.833,55.031,5.833C256.189,40.158,279.033,37.028,295.906,34.326z M449.647,189.089 c-8.602,7.68-24.27,17.473-50.885,22.019l-35.354-49.177l-7.459,14.588c-7.189,14.061-14.467,47.952-8.305,129.557 c3.671,48.618,11.303,100.419,19.876,135.773c-15.403,3.477-53.097,9.644-126.641,9.644c-66.914,0-108.029-5.398-126.654-9.591 c8.579-35.354,16.217-87.185,19.89-135.826c6.162-81.604-1.115-115.496-8.304-129.557l-7.459-14.588L82.994,211.11 c-40.559-6.89-56.063-25.702-60.913-33.626c19.342-38.317,52.823-97.93,67.389-107.835c16.771-11.405,54.511-28.546,71.503-36.05 c2.966,5.069,7.445,11.601,13.757,18.094c12.016,12.358,33.245,27.091,66.148,27.091c32.903,0,54.133-14.732,66.148-27.091 c6.312-6.492,10.791-13.024,13.758-18.094c16.991,7.504,54.73,24.646,71.502,36.051c14.556,9.897,48.027,69.486,67.375,107.807 C457.92,180.256,454.789,184.496,449.647,189.089z"></path>
      </g>
    </svg>
  ),
  Accessories: (
    <svg
      width={24}
      height={24}
      version="1.1"
      id="Uploaded to svgrepo.com"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-0.96 -0.96 33.92 33.92"
      fill="#000000"
      strokeWidth="0.41600000000000004"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          className="feather_een"
          d="M21.879,20.222C21.316,19.659,21,18.896,21,18.1v-5.284c1.163-0.413,2-1.512,2-2.816V8 c0-1.304-0.837-2.403-2-2.816V4c0-1.105-0.895-2-2-2c0-1.105-0.895-2-2-2h-3c-1.105,0-2,0.895-2,2v3h-1.969 C10.463,4.151,11,2.996,11,2.5C11,1.672,10.328,1,9.5,1S8,1.672,8,2.5c0,0.53,0.612,1.81,1.054,2.667C7.864,5.565,7,6.676,7,8v2 c0,1.304,0.837,2.403,2,2.816v6.385c0,2.652,1.054,5.196,2.929,7.071L16,30.343C17.105,31.448,18.552,32,20,32 c1.448,0,2.895-0.552,4-1.657c2.209-2.209,2.209-5.791,0-8L21.879,20.222z M19,3c0.551,0,1,0.449,1,1v1h-4V4c0-0.551,0.449-1,1-1H19 z M13,2c0-0.551,0.449-1,1-1h3c0.551,0,1,0.449,1,1h-1c-1.105,0-2,0.895-2,2v1h-2V2z M9,2.5C9,2.224,9.224,2,9.5,2 S10,2.224,10,2.486C9.984,2.682,9.788,3.188,9.5,3.81C9.212,3.191,9.016,2.689,9,2.5z M8,10V8c0-1.103,0.897-2,2-2h10 c1.103,0,2,0.897,2,2v2c0,1.103-0.897,2-2,2H10C8.897,12,8,11.103,8,10z M12.636,25.565c-1.7-1.7-2.636-3.96-2.636-6.364V18.49 c2.274,0.467,4,2.443,4,4.853c0,1.016-0.326,1.946-0.853,2.733L12.636,25.565z M23.293,29.636C22.413,30.516,21.244,31,20,31 s-2.413-0.484-3.293-1.364l-2.837-2.837C14.569,25.82,15,24.638,15,23.343c0-2.972-2.163-5.433-5-5.909V13h10v5.1 c0,1.068,0.416,2.073,1.172,2.828l2.121,2.121C25.109,24.866,25.109,27.82,23.293,29.636z"
        ></path>
      </g>
    </svg>
  ),
  sorting: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13.4697 7.53033C13.7626 7.82322 14.2374 7.82322 14.5303 7.53033L15.25 6.81066L15.25 17C15.25 17.4142 15.5858 17.75 16 17.75C16.4142 17.75 16.75 17.4142 16.75 17L16.75 6.81066L17.4697 7.53033C17.7626 7.82322 18.2374 7.82322 18.5303 7.53033C18.8232 7.23744 18.8232 6.76256 18.5303 6.46967L16.5303 4.46967C16.2374 4.17678 15.7626 4.17678 15.4697 4.46967L13.4697 6.46967C13.1768 6.76256 13.1768 7.23744 13.4697 7.53033Z"
        fill="black"
      />
      <path
        d="M8.75 17.1893L9.46967 16.4697C9.76256 16.1768 10.2374 16.1768 10.5303 16.4697C10.8232 16.7626 10.8232 17.2374 10.5303 17.5303L8.53033 19.5303C8.23744 19.8232 7.76256 19.8232 7.46967 19.5303L5.46967 17.5303C5.17678 17.2374 5.17678 16.7626 5.46967 16.4697C5.76256 16.1768 6.23744 16.1768 6.53033 16.4697L7.25 17.1893L7.25 7C7.25 6.58579 7.58579 6.25 8 6.25C8.41421 6.25 8.75 6.58579 8.75 7L8.75 17.1893Z"
        fill="black"
      />
    </svg>
  ),
  trash: (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M18 6L17.1991 18.0129C17.129 19.065 17.0939 19.5911 16.8667 19.99C16.6666 20.3412 16.3648 20.6235 16.0011 20.7998C15.588 21 15.0607 21 14.0062 21H9.99377C8.93927 21 8.41202 21 7.99889 20.7998C7.63517 20.6235 7.33339 20.3412 7.13332 19.99C6.90607 19.5911 6.871 19.065 6.80086 18.0129L6 6M4 6H20M16 6L15.7294 5.18807C15.4671 4.40125 15.3359 4.00784 15.0927 3.71698C14.8779 3.46013 14.6021 3.26132 14.2905 3.13878C13.9376 3 13.523 3 12.6936 3H11.3064C10.477 3 10.0624 3 9.70951 3.13878C9.39792 3.26132 9.12208 3.46013 8.90729 3.71698C8.66405 4.00784 8.53292 4.40125 8.27064 5.18807L8 6M14 10V17M10 10V17"
          stroke="#000000"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>
      </g>
    </svg>
  ),
  suitcase: (
    <svg
      fill="#000000"
      height="200px"
      width="200px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <g>
          {' '}
          <g>
            {' '}
            <path d="M349.659,106.146v-31.22c0-24.1-19.607-43.707-43.707-43.707h-99.902c-24.1,0-43.707,19.607-43.707,43.707v31.22H0V480.78 h512V106.146H349.659z M199.805,74.927c0-3.443,2.801-6.244,6.244-6.244h99.902c3.443,0,6.244,2.801,6.244,6.244v31.22h-112.39 V74.927z M474.537,443.317H37.463V273.646c53.668,19.108,124.105,30.487,199.805,32.102v31.422h37.463v-31.422 c75.7-1.616,146.137-12.995,199.805-32.102V443.317z M474.537,233.593c-50.262,20.311-122.881,32.9-199.805,34.671v-30.996 h-37.463v30.995c-76.924-1.771-149.543-14.36-199.805-34.671V143.61h437.073V233.593z"></path>{' '}
          </g>{' '}
        </g>{' '}
      </g>
    </svg>
  ),
  landscape: (
    <svg fill="#000000" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M3 20h18a1 1 0 0 0 .864-1.504l-7-12c-.359-.615-1.369-.613-1.729 0L9.866 12.1l-1.02-1.632A.998.998 0 0 0 8 10h-.001a1 1 0 0 0-.847.47l-5 8A1 1 0 0 0 3 20zM14 8.985 19.259 18h-5.704l-2.486-3.987L14 8.985zm-5.999 3.9L11.197 18H4.805l3.196-5.115zM6 8c1.654 0 3-1.346 3-3S7.654 2 6 2 3 3.346 3 5s1.346 3 3 3zm0-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"></path>
      </g>
    </svg>
  ),
  plumbing: (
    <svg
      fill="#000000"
      height="200px"
      width="200px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <g>
            <path d="M83.478,189.217c-9.22,0-16.696,7.475-16.696,16.696v217.044c0,9.22,7.475,16.696,16.696,16.696 s16.696-7.475,16.696-16.696V205.913C100.174,196.693,92.699,189.217,83.478,189.217z"></path>
          </g>
        </g>
        <g>
          <g>
            <path d="M463.432,139.133l-75.472,0.126c-19.699,0.031-38.916,3.862-57.121,11.384l-130.491,50.205V152.72l131.898-49.278 c20.674-6.501,35.059-26.065,35.059-47.79c0-27.618-22.469-50.087-50.087-50.087c-0.598,0-1.194,0.032-1.789,0.096L73.407,31.74 c-0.095,0.011-0.188,0.022-0.283,0.033C31.437,36.985,0,72.596,0,114.607c0,11.418,0,358.294,0,375.132 c0,9.22,7.475,16.696,16.696,16.696h166.956c9.22,0,16.696-7.475,16.696-16.696v-91.787l153.067-113.924 c0.156-0.116,0.309-0.235,0.461-0.356c7.084-5.667,15.622-9.288,24.559-10.509v26.665c0,21.864,17.788,39.651,39.652,39.651 h10.435h10.435c21.865,0,39.652-17.788,39.652-39.652v-28.833C497.847,265.597,512,247.914,512,226.975V187.62 C512,161.035,490.535,139.126,463.432,139.133z M166.957,473.043H33.391V155.826h133.565V473.043z M185.648,122.566 c-0.656-0.078-1.319-0.13-1.996-0.13H33.391v-7.828c0-25.164,18.794-46.5,43.742-49.685l240.83-25.95 c8.861,0.391,15.95,7.722,15.95,16.679c0,7.312-4.881,13.889-11.868,15.992c-0.347,0.105-0.69,0.22-1.029,0.347L185.648,122.566z M445.217,299.826c0,3.453-2.808,6.261-6.261,6.261h-20.87c-3.453,0-6.261-2.808-6.261-6.261v-27.13h33.391V299.826z M478.61,226.975h-0.001c0,6.798-5.531,12.329-12.33,12.329h-81.113c-18.78,0-37.2,6.424-51.907,18.1l-132.911,98.922V236.625 l142.679-54.894c0.135-0.052,0.269-0.107,0.403-0.163c14.207-5.894,29.207-8.894,44.587-8.92l75.472-0.126 c0.009,0,0.018,0,0.026,0c8.28,0,15.095,6.692,15.095,15.096V226.975z"></path>
          </g>
        </g>
        <g>
          <g>
            <path d="M440.948,345.022c-3.167-3.527-7.684-5.544-12.426-5.544s-9.259,2.017-12.426,5.544 c-18.504,20.644-54.357,65.857-54.357,94.63c0,36.824,29.959,66.783,66.783,66.783s66.783-29.959,66.783-66.783 C495.304,410.971,459.543,365.768,440.948,345.022z M428.522,473.043c-18.412,0-33.391-14.979-33.391-33.391 c0-10.642,15.692-35.497,33.391-57.627c17.701,22.132,33.391,46.985,33.391,57.627 C461.913,458.064,446.934,473.043,428.522,473.043z"></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  electrical: (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.4164 31H29.5837C30.0096 30.0175 30.5783 29.0337 31.1077 28.1972C31.9501 26.8663 32.8498 25.6684 33.3793 25.0221C34.7882 23.2987 35.668 21.225 35.9229 19.0407C36.1778 16.8563 35.798 14.6443 34.8245 12.6584C33.8509 10.6721 32.3213 8.98968 30.4066 7.80939C28.4915 6.62888 26.2713 6.00036 24.0019 6C21.7326 5.99964 19.5121 6.62747 17.5967 7.80738C15.6816 8.98707 14.1514 10.6691 13.1771 12.6551C12.203 14.6407 11.8225 16.8525 12.0767 19.037C12.3308 21.2216 13.2102 23.2957 14.6187 25.0197C15.1472 25.6656 16.0473 26.8635 16.8906 28.1951C17.4206 29.032 17.9901 30.0165 18.4164 31ZM34.9273 26.2885C36.5762 24.2717 37.6099 21.8396 37.9094 19.2725C38.209 16.7053 37.7621 14.1074 36.6204 11.7782C35.4787 9.44891 33.6885 7.48298 31.4561 6.10687C29.2237 4.73075 26.6398 4.00041 24.0022 4C21.3646 3.99959 18.7806 4.72911 16.5477 6.10453C14.3149 7.47995 12.524 9.44531 11.3816 11.7742C10.2391 14.1031 9.79137 16.7008 10.0901 19.2681C10.3888 21.8354 11.4217 24.2678 13.0699 26.2851C14.0324 27.4611 16.4803 30.8176 17 33H31C31.5197 30.8193 33.9648 27.4628 34.9273 26.2885Z"
          fill="#333333"
        ></path>
        <path d="M19 21L25 12V18H29L23 27L23 21H19Z" fill="#333333"></path>
        <path d="M17 35H31V37H17V35Z" fill="#333333"></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29 41H19L19 42H29V41ZM17 39V42C17 43.1046 17.8954 44 19 44H29C30.1046 44 31 43.1046 31 42V39H17Z"
          fill="#333333"
        ></path>
      </g>
    </svg>
  ),
  remodel: (
    <svg
      fill="#000000"
      height="200px"
      width="200px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 481 481"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <g>
            <g>
              <path d="M203.071,84.461l-34.33-78.469C167.149,2.352,163.553,0,159.581,0c-3.973,0-7.569,2.352-9.162,5.992l-34.33,78.469 c-0.562,1.283-0.822,2.648-0.822,4.008h-0.017V471c0,5.522,4.477,10,10,10h68.66c5.523,0,10-4.478,10-10V88.469h-0.016 C203.894,87.109,203.633,85.744,203.071,84.461z M159.581,34.949l19.04,43.52h-38.08L159.581,34.949z M135.251,367.818V98.469 h14.33v269.35L135.251,367.818L135.251,367.818z M183.911,461h-48.66v-43.756h48.66V461z M183.911,397.244h-48.66v-9.426h48.66 V397.244z M183.911,367.819h-14.33v-0.001V98.469h14.33V367.819z"></path>
              <path d="M355.75,0H228.24c-5.523,0-10,4.477-10,10v461c0,5.522,4.477,10,10,10H355.75c5.523,0,10-4.478,10-10V10 C365.75,4.477,361.273,0,355.75,0z M238.24,461v-53.565h48.851v-20H238.24v-58.467h48.851v-20H238.24V250.5h48.851v-20H238.24 v-58.469h48.851v-20H238.24V93.564h48.851v-20H238.24V20h78.085v406.861h20V20h9.425v441H238.24z"></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  roof: (
    <svg
      fill="#000000"
      height="200px"
      width="200px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 511.999 511.999"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <g>
            <path d="M55.765,281.347v126.738h121.158V281.347H55.765z M146.506,377.668H86.182v-65.904h60.323V377.668z"></path>
          </g>
        </g>
        <g>
          <g>
            <path d="M335.076,408.085h121.158V281.347H335.076V408.085z M365.493,311.764h60.323v65.904h-60.323V311.764z"></path>
          </g>
        </g>
        <g>
          <g>
            <path d="M350.752,48.154H161.247L0,200.787v29.865v30.417v202.776h195.421h121.158h195.421V261.069v-30.417v-29.865 L350.752,48.154z M30.417,213.877L173.36,78.571h165.279l142.943,135.306v16.774H30.417V213.877z M286.161,433.428h-60.323v-0.001 V311.764h60.323V433.428z M481.583,433.427H316.579v-152.08H195.421v152.081H30.417V261.069h451.166V433.427z"></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  message: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M8 11H8.01M12 11H12.01M16 11H16.01M21 20L17.6757 18.3378C17.4237 18.2118 17.2977 18.1488 17.1656 18.1044C17.0484 18.065 16.9277 18.0365 16.8052 18.0193C16.6672 18 16.5263 18 16.2446 18H6.2C5.07989 18 4.51984 18 4.09202 17.782C3.71569 17.5903 3.40973 17.2843 3.21799 16.908C3 16.4802 3 15.9201 3 14.8V7.2C3 6.07989 3 5.51984 3.21799 5.09202C3.40973 4.71569 3.71569 4.40973 4.09202 4.21799C4.51984 4 5.0799 4 6.2 4H17.8C18.9201 4 19.4802 4 19.908 4.21799C20.2843 4.40973 20.5903 4.71569 20.782 5.09202C21 5.51984 21 6.0799 21 7.2V20Z"
          stroke="#000000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>{' '}
      </g>
    </svg>
  ),
  flash: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M6.08998 13.28H9.17998V20.48C9.17998 22.16 10.09 22.5 11.2 21.24L18.77 12.64C19.7 11.59 19.31 10.72 17.9 10.72H14.81V3.52002C14.81 1.84002 13.9 1.50002 12.79 2.76002L5.21998 11.36C4.29998 12.42 4.68998 13.28 6.08998 13.28Z"
          stroke="#292D32"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>{' '}
      </g>
    </svg>
  ),
  shelter: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M2 12.2039C2 9.91549 2 8.77128 2.5192 7.82274C3.0384 6.87421 3.98695 6.28551 5.88403 5.10813L7.88403 3.86687C9.88939 2.62229 10.8921 2 12 2C13.1079 2 14.1106 2.62229 16.116 3.86687L18.116 5.10812C20.0131 6.28551 20.9616 6.87421 21.4808 7.82274C22 8.77128 22 9.91549 22 12.2039V13.725C22 17.6258 22 19.5763 20.8284 20.7881C19.6569 22 17.7712 22 14 22H10C6.22876 22 4.34315 22 3.17157 20.7881C2 19.5763 2 17.6258 2 13.725V12.2039Z"
          stroke="#1C274C"
          strokeWidth="1.5"
        ></path>{' '}
        <path d="M15 18H9" stroke="#1C274C" strokeWidth="1.5" strokeLinecap="round"></path>{' '}
      </g>
    </svg>
  ),
  'real-estate-photography': (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M2 12.2039C2 9.91549 2 8.77128 2.5192 7.82274C3.0384 6.87421 3.98695 6.28551 5.88403 5.10813L7.88403 3.86687C9.88939 2.62229 10.8921 2 12 2C13.1079 2 14.1106 2.62229 16.116 3.86687L18.116 5.10812C20.0131 6.28551 20.9616 6.87421 21.4808 7.82274C22 8.77128 22 9.91549 22 12.2039V13.725C22 17.6258 22 19.5763 20.8284 20.7881C19.6569 22 17.7712 22 14 22H10C6.22876 22 4.34315 22 3.17157 20.7881C2 19.5763 2 17.6258 2 13.725V12.2039Z"
          stroke="#1C274C"
          strokeWidth="1.5"
        ></path>{' '}
        <path d="M15 18H9" stroke="#1C274C" strokeWidth="1.5" strokeLinecap="round"></path>{' '}
      </g>
    </svg>
  ),
  search: (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.72561 11.9145C5.72561 8.56369 8.44199 5.84732 11.7928 5.84732C15.1436 5.84732 17.86 8.56369 17.86 11.9145C17.86 15.2653 15.1436 17.9817 11.7928 17.9817C8.44199 17.9817 5.72561 15.2653 5.72561 11.9145ZM11.7928 4.23193C7.54983 4.23193 4.11023 7.67154 4.11023 11.9145C4.11023 16.1575 7.54983 19.5971 11.7928 19.5971C13.6236 19.5971 15.3047 18.9567 16.6246 17.8878L22.0258 23.2889C22.3412 23.6043 22.8526 23.6043 23.168 23.2889C23.4834 22.9735 23.4834 22.4621 23.168 22.1467L17.7668 16.7454C18.8353 15.4257 19.4754 13.7449 19.4754 11.9145C19.4754 7.67154 16.0358 4.23193 11.7928 4.23193Z"
        fill="#121212"
      />
    </svg>
  ),
  searchIcon: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_82_13322" maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="17">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.666748 0.166992H16.8974V16.3978H0.666748V0.166992Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_82_13322)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.78234 1.41699C4.9965 1.41699 1.9165 4.49616 1.9165 8.28199C1.9165 12.0678 4.9965 15.1478 8.78234 15.1478C12.5673 15.1478 15.6473 12.0678 15.6473 8.28199C15.6473 4.49616 12.5673 1.41699 8.78234 1.41699ZM8.78234 16.3978C4.30734 16.3978 0.666504 12.757 0.666504 8.28199C0.666504 3.80699 4.30734 0.166992 8.78234 0.166992C13.2573 0.166992 16.8973 3.80699 16.8973 8.28199C16.8973 12.757 13.2573 16.3978 8.78234 16.3978Z"
          fill="#BDBDBD"
        />
      </g>
      <mask id="mask1_82_13322" maskUnits="userSpaceOnUse" x="13" y="13" width="5" height="5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3667 13.2559H17.5534V17.4348H13.3667V13.2559Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_82_13322)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.9286 17.4348C16.7694 17.4348 16.6094 17.374 16.4869 17.2523L13.5502 14.324C13.3061 14.0798 13.3052 13.684 13.5494 13.4398C13.7927 13.194 14.1886 13.1957 14.4336 13.4382L17.3702 16.3673C17.6144 16.6115 17.6152 17.0065 17.3711 17.2507C17.2494 17.374 17.0886 17.4348 16.9286 17.4348Z"
          fill="#BDBDBD"
        />
      </g>
    </svg>
  ),
  bookIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="#2A353D" strokeWidth="1.5" />
      <path
        d="M12 8V12L14 14"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  reviewIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.7276 3.44418L15.4874 6.99288C15.7274 7.48687 16.3673 7.9607 16.9073 8.05143L20.0969 8.58575C22.1367 8.92853 22.6167 10.4206 21.1468 11.8925L18.6671 14.3927C18.2471 14.8161 18.0172 15.6327 18.1471 16.2175L18.8571 19.3125C19.417 21.7623 18.1271 22.71 15.9774 21.4296L12.9877 19.6452C12.4478 19.3226 11.5579 19.3226 11.0079 19.6452L8.01827 21.4296C5.8785 22.71 4.57865 21.7522 5.13859 19.3125L5.84851 16.2175C5.97849 15.6327 5.74852 14.8161 5.32856 14.3927L2.84884 11.8925C1.389 10.4206 1.85895 8.92853 3.89872 8.58575L7.08837 8.05143C7.61831 7.9607 8.25824 7.48687 8.49821 6.99288L10.258 3.44418C11.2179 1.51861 12.7777 1.51861 13.7276 3.44418Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  handShakeIcon: (
    <svg
      width="50px"
      height="50px"
      viewBox="0 0 265 203"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M262.551 81.267L183.732 2.44899C180.468 -0.815308 175.175 -0.815866 171.909 2.44899L148.263 26.0938H148.263L130.529 43.8281L112.796 26.0944H112.796L89.1487 2.44843C85.8839 -0.815865 80.5909 -0.816423 77.326 2.44843L2.44892 77.3266C0.880586 78.8944 0 81.0212 0 83.2383C0 85.4559 0.881143 87.5821 2.44892 89.1499L26.0949 112.795C27.7273 114.428 29.8669 115.244 32.0059 115.244C33.2388 115.244 34.4682 114.964 35.6041 114.422L116.734 195.553C116.735 195.553 116.736 195.554 116.736 195.555C121.626 200.444 128.048 202.889 134.47 202.889C140.893 202.889 147.315 200.444 152.204 195.555C156.615 191.145 159.178 185.381 159.51 179.2C165.46 178.872 171.315 176.444 175.85 171.909C180.389 167.37 182.816 161.511 183.142 155.556C189.097 155.231 194.957 152.802 199.496 148.264C199.499 148.261 199.502 148.257 199.506 148.253L229.398 118.361C230.512 118.893 231.736 119.185 232.994 119.185C235.211 119.185 237.338 118.303 238.905 116.736L262.551 93.0902C264.119 91.5225 265 89.3962 265 87.1792C265 84.961 264.119 82.8348 262.551 81.267ZM20.1827 83.2383L83.2382 20.1828L95.062 32.0055L92.573 34.4945L32.0059 95.061L20.1827 83.2383ZM164.027 160.087C160.769 163.344 155.469 163.345 152.208 160.091C152.207 160.089 152.206 160.088 152.204 160.086L140.381 148.263C137.116 144.999 131.823 144.999 128.558 148.263C125.294 151.528 125.294 156.821 128.559 160.086L140.38 171.907C140.38 171.907 140.382 171.908 140.382 171.909C140.383 171.91 140.384 171.912 140.385 171.913C141.962 173.491 142.83 175.589 142.83 177.82C142.83 180.053 141.961 182.152 140.382 183.732C137.122 186.991 131.818 186.991 128.558 183.731C128.558 183.731 128.557 183.73 128.555 183.729L47.7701 102.942L106.885 43.8281L118.707 55.6509L100.973 73.3852C100.971 73.3868 100.97 73.3891 100.968 73.3908C91.1952 83.1697 91.1964 99.0765 100.973 108.854C105.862 113.743 112.284 116.188 118.707 116.188C125.129 116.188 131.551 113.744 136.44 108.855C136.44 108.855 136.44 108.854 136.441 108.854L154.175 91.1201L183.728 120.673C183.729 120.675 183.73 120.675 183.731 120.677L187.68 124.625C189.255 126.204 190.122 128.299 190.122 130.529C190.122 132.759 189.253 134.856 187.678 136.435L187.673 136.44C187.672 136.441 187.671 136.442 187.671 136.443C184.412 139.698 179.115 139.698 175.855 136.446C175.852 136.443 175.85 136.44 175.847 136.437L164.027 124.617C160.762 121.353 155.469 121.353 152.204 124.618C148.94 127.883 148.94 133.176 152.204 136.441L164.02 148.256C164.022 148.258 164.025 148.261 164.027 148.264C167.287 151.523 167.287 156.827 164.027 160.087ZM205.407 118.706L199.498 112.798C199.497 112.797 199.497 112.795 199.496 112.795C199.495 112.794 199.494 112.794 199.494 112.793L195.555 108.853C195.555 108.853 195.554 108.853 195.554 108.852L160.087 73.3852C158.519 71.8174 156.393 70.9368 154.176 70.9368C151.958 70.9368 149.832 71.8174 148.264 73.3852L124.619 97.0306C121.359 100.291 116.055 100.29 112.796 97.0311C109.537 93.7719 109.536 88.4688 112.795 85.209C112.796 85.2084 112.796 85.2084 112.796 85.2079L136.435 61.5686C136.437 61.5669 136.44 61.5653 136.442 61.563C136.444 61.5608 136.446 61.5586 136.448 61.5563L154.176 43.8276L217.231 106.883L205.407 118.706ZM232.994 99.0013L165.998 32.0049L177.82 20.1828L244.816 87.1786L232.994 99.0013Z"
        fill="#292D32"
      />
    </svg>
  ),
  moneySecurity: (
    <svg
      width="50px"
      height="50px"
      viewBox="0 0 170 189"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M161.914 86.7056C161.914 128.941 131.252 168.499 89.3619 180.073C86.5116 180.85 83.4023 180.85 80.552 180.073C38.6617 168.499 8 128.941 8 86.7056V48.7884C8 41.706 13.3551 33.6736 20.0057 30.9961L68.1146 11.3037C78.911 6.89877 91.0893 6.89877 101.886 11.3037L149.994 30.9961C156.559 33.6736 162 41.706 162 48.7884L161.914 86.7056Z"
        stroke="#292D32"
        strokeWidth="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M24 344.001H664"
        stroke="black"
        strokeWidth="48"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M344 664.001C282.24 664.001 232 520.641 232 344.001C232 167.36 282.24 24.0001 344 24.0001C405.76 24.0001 456 167.36 456 344.001"
        stroke="black"
        strokeWidth="48"
        strokeLinecap="round"
        fill="none"
        strokeLinejoin="round"
      />
      <path
        d="M547.811 659.841C609.667 659.841 659.811 609.697 659.811 547.841C659.811 485.985 609.667 435.841 547.811 435.841C485.955 435.841 435.811 485.985 435.811 547.841C435.811 609.697 485.955 659.841 547.811 659.841Z"
        stroke="black"
        strokeWidth="48"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M695.994 696.004L626.874 627.204"
        stroke="black"
        strokeWidth="48"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  checkout: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 750 750"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M567.7 267.7C572.394 263.006 575.032 256.639 575.032 250C575.032 243.361 572.394 236.994 567.7 232.3C563.006 227.606 556.639 224.968 550 224.968C543.361 224.968 536.994 227.606 532.3 232.3L400 364.65L342.7 307.3C340.376 304.976 337.616 303.132 334.579 301.874C331.542 300.616 328.287 299.968 325 299.968C321.713 299.968 318.458 300.616 315.421 301.874C312.384 303.132 309.624 304.976 307.3 307.3C304.976 309.624 303.132 312.384 301.874 315.421C300.616 318.458 299.968 321.713 299.968 325C299.968 328.287 300.616 331.542 301.874 334.579C303.132 337.616 304.976 340.376 307.3 342.7L382.3 417.7C384.622 420.028 387.381 421.875 390.418 423.136C393.456 424.396 396.712 425.045 400 425.045C403.288 425.045 406.544 424.396 409.582 423.136C412.619 421.875 415.378 420.028 417.7 417.7L567.7 267.7Z"
        fill="black"
      />
      <path
        d="M25 0C18.3696 0 12.0107 2.63392 7.32233 7.32233C2.63392 12.0107 0 18.3696 0 25C0 31.6304 2.63392 37.9893 7.32233 42.6777C12.0107 47.3661 18.3696 50 25 50H80.5L100.55 130.35L175.45 529.6C176.522 535.329 179.563 540.503 184.046 544.228C188.528 547.953 194.172 549.995 200 550H250C223.478 550 198.043 560.536 179.289 579.289C160.536 598.043 150 623.478 150 650C150 676.522 160.536 701.957 179.289 720.711C198.043 739.464 223.478 750 250 750C276.522 750 301.957 739.464 320.711 720.711C339.464 701.957 350 676.522 350 650C350 623.478 339.464 598.043 320.711 579.289C301.957 560.536 276.522 550 250 550H600C573.478 550 548.043 560.536 529.289 579.289C510.536 598.043 500 623.478 500 650C500 676.522 510.536 701.957 529.289 720.711C548.043 739.464 573.478 750 600 750C626.522 750 651.957 739.464 670.711 720.711C689.464 701.957 700 676.522 700 650C700 623.478 689.464 598.043 670.711 579.289C651.957 560.536 626.522 550 600 550H650C655.828 549.995 661.472 547.953 665.954 544.228C670.437 540.503 673.478 535.329 674.55 529.6L749.55 129.6C750.225 125.992 750.098 122.279 749.177 118.726C748.255 115.173 746.563 111.866 744.22 109.04C741.876 106.215 738.939 103.94 735.618 102.378C732.296 100.815 728.671 100.003 725 100H144.5L124.25 18.95C122.9 13.5392 119.781 8.73494 115.387 5.30124C110.993 1.86753 105.577 0.00154057 100 0H25ZM220.75 500L155.1 150H694.9L629.25 500H220.75ZM300 650C300 663.261 294.732 675.979 285.355 685.355C275.979 694.732 263.261 700 250 700C236.739 700 224.021 694.732 214.645 685.355C205.268 675.979 200 663.261 200 650C200 636.739 205.268 624.021 214.645 614.645C224.021 605.268 236.739 600 250 600C263.261 600 275.979 605.268 285.355 614.645C294.732 624.021 300 636.739 300 650ZM650 650C650 663.261 644.732 675.979 635.355 685.355C625.979 694.732 613.261 700 600 700C586.739 700 574.021 694.732 564.645 685.355C555.268 675.979 550 663.261 550 650C550 636.739 555.268 624.021 564.645 614.645C574.021 605.268 586.739 600 600 600C613.261 600 625.979 605.268 635.355 614.645C644.732 624.021 650 636.739 650 650Z"
        fill="black"
      />
    </svg>
  ),

  gallary: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.2 19H4.93137C4.32555 19 4.02265 19 3.88238 18.8802C3.76068 18.7763 3.69609 18.6203 3.70865 18.4608C3.72312 18.2769 3.93731 18.0627 4.36569 17.6343L12.8686 9.13137C13.2646 8.73536 13.4627 8.53735 13.691 8.46316C13.8918 8.3979 14.1082 8.3979 14.309 8.46316C14.5373 8.53735 14.7354 8.73535 15.1314 9.13137L19 13V14.2M14.2 19C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2M14.2 19H5.8C4.11984 19 3.27976 19 2.63803 18.673C2.07354 18.3854 1.6146 17.9265 1.32698 17.362C1 16.7202 1 15.8802 1 14.2V5.8C1 4.11984 1 3.27976 1.32698 2.63803C1.6146 2.07354 2.07354 1.6146 2.63803 1.32698C3.27976 1 4.11984 1 5.8 1H14.2C15.8802 1 16.7202 1 17.362 1.32698C17.9265 1.6146 18.3854 2.07354 18.673 2.63803C19 3.27976 19 4.11984 19 5.8V14.2M8.5 6.5C8.5 7.60457 7.60457 8.5 6.5 8.5C5.39543 8.5 4.5 7.60457 4.5 6.5C4.5 5.39543 5.39543 4.5 6.5 4.5C7.60457 4.5 8.5 5.39543 8.5 6.5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  details: (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 15V11M11 7H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  reviews: (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 6.5H10M5 10H13M7.68375 16H14.2C15.8802 16 16.7202 16 17.362 15.673C17.9265 15.3854 18.3854 14.9265 18.673 14.362C19 13.7202 19 12.8802 19 11.2V5.8C19 4.11984 19 3.27976 18.673 2.63803C18.3854 2.07354 17.9265 1.6146 17.362 1.32698C16.7202 1 15.8802 1 14.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V18.3355C1 18.8684 1 19.1348 1.10923 19.2716C1.20422 19.3906 1.34827 19.4599 1.50054 19.4597C1.67563 19.4595 1.88367 19.2931 2.29976 18.9602L4.68521 17.0518C5.17252 16.662 5.41617 16.4671 5.68749 16.3285C5.9282 16.2055 6.18443 16.1156 6.44921 16.0613C6.74767 16 7.0597 16 7.68375 16Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  loction: (
    <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 12C10.6569 12 12 10.6569 12 9C12 7.34315 10.6569 6 9 6C7.34315 6 6 7.34315 6 9C6 10.6569 7.34315 12 9 12Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M9 21C13 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 5 17 9 21Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  calendar: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5 8.33332H2.5M13.3333 1.66666V4.99999M6.66667 1.66666V4.99999M6.5 18.3333H13.5C14.9001 18.3333 15.6002 18.3333 16.135 18.0608C16.6054 17.8212 16.9878 17.4387 17.2275 16.9683C17.5 16.4335 17.5 15.7335 17.5 14.3333V7.33332C17.5 5.93319 17.5 5.23313 17.2275 4.69835C16.9878 4.22794 16.6054 3.84549 16.135 3.60581C15.6002 3.33332 14.9001 3.33332 13.5 3.33332H6.5C5.09987 3.33332 4.3998 3.33332 3.86502 3.60581C3.39462 3.84549 3.01217 4.22794 2.77248 4.69835C2.5 5.23313 2.5 5.93319 2.5 7.33332V14.3333C2.5 15.7335 2.5 16.4335 2.77248 16.9683C3.01217 17.4387 3.39462 17.8212 3.86502 18.0608C4.3998 18.3333 5.09987 18.3333 6.5 18.3333Z"
        stroke="#344054"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  trailer: (
    <svg width="22" height="22" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
      <path
        fill="currentColor"
        d="M48 32C21.5 32 0 53.5 0 80V336c0 26.5 21.5 48 48 48H65.1c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96H488h8H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V80c0-26.5-21.5-48-48-48H48zM80 96c8.8 0 16 7.2 16 16l0 131.2c-11.4 5.9-22.2 12.9-32 21V112c0-8.8 7.2-16 16-16zm96 128c-5.4 0-10.7 .2-16 .7L160 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112.7c-5.3-.5-10.6-.7-16-.7zm80 19.2L256 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 152.2c-9.8-8.1-20.6-15.2-32-21zM368 96c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16zm112 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16s16 7.2 16 16zM176 480a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
      ></path>
    </svg>
  ),
  pickup: (
    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 14V4.2C15 3.0799 15 2.51984 14.782 2.09202C14.5903 1.71569 14.2843 1.40973 13.908 1.21799C13.4802 1 12.9201 1 11.8 1H4.2C3.0799 1 2.51984 1 2.09202 1.21799C1.71569 1.40973 1.40973 1.71569 1.21799 2.09202C1 2.51984 1 3.0799 1 4.2V10.8C1 11.9201 1 12.4802 1.21799 12.908C1.40973 13.2843 1.71569 13.5903 2.09202 13.782C2.51984 14 3.0799 14 4.2 14H15ZM15 14H19.4C19.9601 14 20.2401 14 20.454 13.891C20.6422 13.7951 20.7951 13.6422 20.891 13.454C21 13.2401 21 12.9601 21 12.4V9.66274C21 9.41815 21 9.29586 20.9724 9.18077C20.9479 9.07873 20.9075 8.98119 20.8526 8.89172C20.7908 8.7908 20.7043 8.70432 20.5314 8.53137L18.4686 6.46863C18.2957 6.29568 18.2092 6.2092 18.1083 6.14736C18.0188 6.09253 17.9213 6.05213 17.8192 6.02763C17.7041 6 17.5818 6 17.3373 6H15M8 16.5C8 17.8807 6.88071 19 5.5 19C4.11929 19 3 17.8807 3 16.5C3 15.1193 4.11929 14 5.5 14C6.88071 14 8 15.1193 8 16.5ZM19 16.5C19 17.8807 17.8807 19 16.5 19C15.1193 19 14 17.8807 14 16.5C14 15.1193 15.1193 14 16.5 14C17.8807 14 19 15.1193 19 16.5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),

  pdf: (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.75 4C7.75 2.20508 9.20508 0.75 11 0.75H27C27.1212 0.75 27.2375 0.798159 27.3232 0.883885L38.1161 11.6768C38.2018 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4Z"
        fill="white"
        stroke="#D0D5DD"
        strokeWidth="1.5"
      />
      <path d="M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5" stroke="#D0D5DD" strokeWidth="1.5" />
      <rect x="1" y="18" width="26" height="16" rx="2" fill="#D92D20" />
      <path
        d="M4.8323 30V22.7273H7.70162C8.25323 22.7273 8.72316 22.8326 9.11142 23.0433C9.49967 23.2517 9.7956 23.5417 9.9992 23.9134C10.2052 24.2827 10.3082 24.7088 10.3082 25.1918C10.3082 25.6747 10.204 26.1009 9.99565 26.4702C9.78732 26.8395 9.48547 27.1271 9.09011 27.3331C8.69712 27.5391 8.22127 27.642 7.66255 27.642H5.83372V26.4098H7.41397C7.7099 26.4098 7.95375 26.3589 8.14551 26.2571C8.33964 26.1529 8.48405 26.0097 8.57875 25.8274C8.67581 25.6428 8.72434 25.4309 8.72434 25.1918C8.72434 24.9503 8.67581 24.7396 8.57875 24.5597C8.48405 24.3774 8.33964 24.2365 8.14551 24.1371C7.95138 24.0353 7.70517 23.9844 7.40687 23.9844H6.36994V30H4.8323ZM13.885 30H11.3069V22.7273H13.9063C14.6379 22.7273 15.2676 22.8729 15.7955 23.1641C16.3235 23.4529 16.7295 23.8684 17.0136 24.4105C17.3 24.9527 17.4433 25.6013 17.4433 26.3565C17.4433 27.1141 17.3 27.7652 17.0136 28.3097C16.7295 28.8542 16.3211 29.272 15.7884 29.5632C15.2581 29.8544 14.6237 30 13.885 30ZM12.8445 28.6825H13.8211C14.2757 28.6825 14.658 28.602 14.9681 28.4411C15.2806 28.2777 15.515 28.0256 15.6713 27.6847C15.8299 27.3414 15.9092 26.8987 15.9092 26.3565C15.9092 25.8191 15.8299 25.38 15.6713 25.0391C15.515 24.6982 15.2818 24.4472 14.9717 24.2862C14.6615 24.1252 14.2792 24.0447 13.8247 24.0447H12.8445V28.6825ZM18.5823 30V22.7273H23.3976V23.995H20.1199V25.728H23.078V26.9957H20.1199V30H18.5823Z"
        fill="white"
      />
    </svg>
  ),
  jpeg: (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.75 4C7.75 2.20508 9.20508 0.75 11 0.75H27C27.1212 0.75 27.2375 0.798159 27.3232 0.883885L38.1161 11.6768C38.2018 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4Z"
        fill="white"
        stroke="#D0D5DD"
        strokeWidth="1.5"
      />
      <path d="M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5" stroke="#D0D5DD" strokeWidth="1.5" />
      <path
        d="M25 18H3C1.89543 18 1 18.8954 1 20V32C1 33.1046 1.89543 34 3 34H25C26.1046 34 27 33.1046 27 32V20C27 18.8954 26.1046 18 25 18Z"
        fill="#D92D20"
      />
      <path
        d="M4.83203 29.9993V22.7266H7.70135C8.25296 22.7266 8.72289 22.8319 9.11115 23.0426C9.4994 23.251 9.79533 23.541 9.99893 23.9127C10.2049 24.282 10.3079 24.7081 10.3079 25.1911C10.3079 25.674 10.2037 26.1002 9.99538 26.4695C9.78705 26.8388 9.4852 27.1264 9.08984 27.3324C8.69685 27.5384 8.221 27.6413 7.66228 27.6413H5.83345V26.4091H7.4137C7.70963 26.4091 7.95348 26.3582 8.14524 26.2564C8.33937 26.1522 8.48378 26.009 8.57848 25.8267C8.67554 25.6421 8.72407 25.4302 8.72407 25.1911C8.72407 24.9496 8.67554 24.7389 8.57848 24.559C8.48378 24.3767 8.33937 24.2358 8.14524 24.1364C7.95111 24.0346 7.7049 23.9837 7.4066 23.9837H6.36967V29.9993H4.83203ZM13.8847 29.9993H11.3066V22.7266H13.906C14.6376 22.7266 15.2673 22.8722 15.7952 23.1634C16.3232 23.4522 16.7292 23.8677 17.0133 24.4098C17.2997 24.952 17.443 25.6006 17.443 26.3558C17.443 27.1134 17.2997 27.7645 17.0133 28.309C16.7292 28.8535 16.3208 29.2713 15.7881 29.5625C15.2578 29.8537 14.6234 29.9993 13.8847 29.9993ZM12.8442 28.6818H13.8208C14.2754 28.6818 14.6577 28.6013 14.9678 28.4404C15.2803 28.277 15.5147 28.0249 15.671 27.684C15.8296 27.3407 15.9089 26.898 15.9089 26.3558C15.9089 25.8184 15.8296 25.3793 15.671 25.0384C15.5147 24.6975 15.2815 24.4465 14.9714 24.2855C14.6612 24.1245 14.2789 24.044 13.8244 24.044H12.8442V28.6818ZM18.582 29.9993V22.7266H23.3973V23.9943H20.1196V25.7273H23.0777V26.995H20.1196V29.9993H18.582Z"
        fill="white"
      />
      <path
        d="M25 18H3C1.89543 18 1 18.8954 1 20V32C1 33.1046 1.89543 34 3 34H25C26.1046 34 27 33.1046 27 32V20C27 18.8954 26.1046 18 25 18Z"
        fill="#7F56D9"
      />
      <path
        d="M7.65154 22.7265H9.17134V27.7975C9.17134 28.2662 9.06604 28.6734 8.85534 29.0191C8.64704 29.3647 8.35694 29.6311 7.98534 29.8181C7.61364 30.0051 7.18154 30.0986 6.68914 30.0986C6.25114 30.0986 5.85344 30.0217 5.49594 29.8678C5.14084 29.7116 4.85914 29.4748 4.65074 29.1576C4.44244 28.838 4.33944 28.4367 4.34184 27.9537H5.87234C5.87714 28.1455 5.91614 28.31 5.98954 28.4474C6.06534 28.5823 6.16834 28.6865 6.29854 28.7599C6.43104 28.8309 6.58734 28.8664 6.76724 28.8664C6.95664 28.8664 7.11644 28.8261 7.24664 28.7456C7.37924 28.6628 7.47984 28.5421 7.54854 28.3834C7.61714 28.2248 7.65154 28.0295 7.65154 27.7975V22.7265ZM10.4426 29.9992V22.7265H13.312C13.8636 22.7265 14.3335 22.8318 14.7218 23.0425C15.11 23.2509 15.406 23.5409 15.6096 23.9126C15.8155 24.2819 15.9185 24.708 15.9185 25.191C15.9185 25.6739 15.8143 26.1001 15.606 26.4694C15.3977 26.8387 15.0958 27.1263 14.7005 27.3323C14.3075 27.5383 13.8316 27.6412 13.2729 27.6412H11.4441V26.409H13.0243C13.3203 26.409 13.5641 26.3581 13.7559 26.2563C13.95 26.1521 14.0944 26.0089 14.1891 25.8266C14.2862 25.642 14.3347 25.4301 14.3347 25.191C14.3347 24.9495 14.2862 24.7388 14.1891 24.5589C14.0944 24.3766 13.95 24.2357 13.7559 24.1363C13.5617 24.0345 13.3155 23.9836 13.0172 23.9836H11.9803V29.9992H10.4426ZM21.7397 25.0773C21.69 24.9045 21.6201 24.7518 21.5302 24.6192C21.4402 24.4843 21.3301 24.3706 21.1999 24.2783C21.0721 24.1836 20.9253 24.1114 20.7596 24.0617C20.5962 24.012 20.4151 23.9871 20.2163 23.9871C19.8446 23.9871 19.5179 24.0795 19.2362 24.2641C18.9568 24.4488 18.739 24.7175 18.5827 25.0702C18.4265 25.4206 18.3484 25.8491 18.3484 26.3557C18.3484 26.8624 18.4253 27.2932 18.5792 27.6483C18.7331 28.0035 18.9509 28.2745 19.2326 28.4616C19.5143 28.6462 19.8469 28.7385 20.2305 28.7385C20.5785 28.7385 20.8756 28.677 21.1218 28.5539C21.3704 28.4284 21.5598 28.252 21.69 28.0248C21.8226 27.7975 21.8888 27.5288 21.8888 27.2187L22.2013 27.2648H20.3263V26.1072H23.3697V27.0233C23.3697 27.6626 23.2347 28.2118 22.9648 28.6711C22.695 29.128 22.3233 29.4807 21.8498 29.7293C21.3763 29.9755 20.8342 30.0986 20.2234 30.0986C19.5415 30.0986 18.9426 29.9483 18.4265 29.6476C17.9104 29.3446 17.5079 28.9149 17.2191 28.3586C16.9326 27.7999 16.7894 27.137 16.7894 26.3699C16.7894 25.7804 16.8746 25.2549 17.0451 24.7932C17.2179 24.3292 17.4594 23.9362 17.7695 23.6143C18.0797 23.2923 18.4407 23.0473 18.8526 22.8792C19.2646 22.7111 19.7108 22.627 20.1914 22.627C20.6033 22.627 20.9869 22.6874 21.342 22.8081C21.6971 22.9265 22.012 23.0946 22.2866 23.3124C22.5636 23.5302 22.7897 23.7894 22.9648 24.0901C23.14 24.3884 23.2525 24.7175 23.3022 25.0773H21.7397Z"
        fill="white"
      />
    </svg>
  ),
  doc: (
    <svg
      fill="#000000"
      width="34px"
      height="34px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19.2006 6.667L12.343 0H2.74324C2.01635 0.0021103 1.31986 0.283775 0.805874 0.783477C0.291887 1.28318 0.00217063 1.96032 0 2.667V21.333C0.00217063 22.0397 0.291887 22.7168 0.805874 23.2165C1.31986 23.7162 2.01635 23.9979 2.74324 24H16.4574C17.1843 23.9979 17.8808 23.7162 18.3947 23.2165C18.9087 22.7168 19.1984 22.0397 19.2006 21.333V20H24.001V9.333H19.2006V6.667ZM11.657 2.16L16.9778 7.333H11.657V2.16ZM22.6289 10.667V18.667H6.17152V10.667H22.6289Z" />
      <path d="M12.2941 14.6196C12.2941 15.4716 12.051 16.1241 11.5648 16.5773C11.081 17.0304 10.3813 17.257 9.46558 17.257H8V12.0814H9.62488C10.4698 12.0814 11.1259 12.3044 11.5931 12.7505C12.0604 13.1965 12.2941 13.8196 12.2941 14.6196ZM11.1542 14.6479C11.1542 13.5364 10.6633 12.9806 9.68152 12.9806H9.09741V16.3507H9.56824C10.6255 16.3507 11.1542 15.7831 11.1542 14.6479Z" />
      <path d="M17.4843 14.6621C17.4843 15.5188 17.2719 16.1772 16.8471 16.6375C16.4223 17.0977 15.8134 17.3278 15.0205 17.3278C14.2275 17.3278 13.6186 17.0977 13.1938 16.6375C12.769 16.1772 12.5566 15.5164 12.5566 14.655C12.5566 13.7936 12.769 13.1364 13.1938 12.6832C13.621 12.2277 14.2322 12 15.0275 12C15.8229 12 16.4306 12.2289 16.8507 12.6868C17.2731 13.1446 17.4843 13.8031 17.4843 14.6621ZM13.7071 14.6621C13.7071 15.2403 13.8169 15.6757 14.0363 15.9684C14.2558 16.261 14.5839 16.4073 15.0205 16.4073C15.896 16.4073 16.3338 15.8256 16.3338 14.6621C16.3338 13.4963 15.8984 12.9133 15.0275 12.9133C14.5909 12.9133 14.2617 13.0608 14.0399 13.3558C13.818 13.6485 13.7071 14.0839 13.7071 14.6621Z" />
      <path d="M20.1753 12.9204C19.7623 12.9204 19.4425 13.0762 19.216 13.3877C18.9894 13.6969 18.8761 14.1287 18.8761 14.6833C18.8761 15.8374 19.3092 16.4144 20.1753 16.4144C20.5388 16.4144 20.9789 16.3236 21.4958 16.1418V17.0623C21.071 17.2393 20.5966 17.3278 20.0727 17.3278C19.3198 17.3278 18.744 17.1 18.3451 16.6445C17.9463 16.1867 17.7469 15.5306 17.7469 14.6763C17.7469 14.1382 17.8448 13.6674 18.0407 13.2638C18.2366 12.8579 18.5174 12.5475 18.8832 12.3328C19.2514 12.1156 19.6821 12.0071 20.1753 12.0071C20.678 12.0071 21.1831 12.1286 21.6905 12.3717L21.3365 13.2638C21.1429 13.1718 20.9482 13.0915 20.7524 13.0231C20.5565 12.9546 20.3641 12.9204 20.1753 12.9204Z" />
    </svg>
  ),
  talent: (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#F4EBFF" />
      <rect
        x="4"
        y="4"
        width="48"
        height="48"
        rx="24"
        stroke="#F9F5FF"
        strokeWidth="8"
        fill="none"
      />
      <path
        d="M22.0944 27.2288C22.0322 26.8282 22 26.4179 22 26C22 21.5817 25.6052 18 30.0526 18C34.4999 18 38.1052 21.5817 38.1052 26C38.1052 26.9981 37.9213 27.9535 37.5852 28.8345C37.5154 29.0175 37.4804 29.109 37.4646 29.1804C37.4489 29.2512 37.4428 29.301 37.4411 29.3735C37.4394 29.4466 37.4493 29.5272 37.4692 29.6883L37.8717 32.9585C37.9153 33.3125 37.9371 33.4895 37.8782 33.6182C37.8266 33.731 37.735 33.8205 37.6211 33.8695C37.4911 33.9254 37.3146 33.8995 36.9617 33.8478L33.7765 33.3809C33.6101 33.3565 33.527 33.3443 33.4512 33.3448C33.3763 33.3452 33.3245 33.3507 33.2511 33.3661C33.177 33.3817 33.0823 33.4172 32.893 33.4881C32.0097 33.819 31.0524 34 30.0526 34C29.6344 34 29.2237 33.9683 28.8227 33.9073M23.6316 38C26.5965 38 29 35.5376 29 32.5C29 29.4624 26.5965 27 23.6316 27C20.6667 27 18.2632 29.4624 18.2632 32.5C18.2632 33.1106 18.3603 33.6979 18.5395 34.2467C18.6153 34.4787 18.6532 34.5947 18.6657 34.6739C18.6786 34.7567 18.6809 34.8031 18.6761 34.8867C18.6714 34.9668 18.6514 35.0573 18.6113 35.2383L18 38L20.9948 37.591C21.1583 37.5687 21.24 37.5575 21.3114 37.558C21.3865 37.5585 21.4264 37.5626 21.5001 37.5773C21.5701 37.5912 21.6742 37.6279 21.8823 37.7014C22.4306 37.8949 23.0191 38 23.6316 38Z"
        stroke="#484848"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
        strokeLinejoin="round"
      />
    </svg>
  ),
  efficiency: (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#F4EBFF" />
      <rect
        x="4"
        y="4"
        width="48"
        height="48"
        rx="24"
        stroke="#F9F5FF"
        strokeWidth="8"
        fill="none"
      />
      <path
        d="M29.0001 18L20.0936 28.6879C19.7448 29.1064 19.5703 29.3157 19.5677 29.4925C19.5654 29.6461 19.6338 29.7923 19.7534 29.8889C19.8909 30 20.1633 30 20.7081 30H28.0001L27.0001 38L35.9067 27.3121C36.2555 26.8936 36.4299 26.6843 36.4325 26.5075C36.4348 26.3539 36.3664 26.2077 36.2468 26.1111C36.1094 26 35.8369 26 35.2921 26H28.0001L29.0001 18Z"
        stroke="#484848"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  copy: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.16663 12.5001C3.39006 12.5001 3.00177 12.5001 2.69549 12.3732C2.28711 12.2041 1.96265 11.8796 1.79349 11.4712C1.66663 11.1649 1.66663 10.7767 1.66663 10.0001V4.33341C1.66663 3.39999 1.66663 2.93328 1.84828 2.57676C2.00807 2.26316 2.26304 2.00819 2.57664 1.8484C2.93316 1.66675 3.39987 1.66675 4.33329 1.66675H9.99996C10.7765 1.66675 11.1648 1.66675 11.4711 1.79362C11.8795 1.96277 12.2039 2.28723 12.3731 2.69561C12.5 3.00189 12.5 3.39018 12.5 4.16675M10.1666 18.3334H15.6666C16.6 18.3334 17.0668 18.3334 17.4233 18.1518C17.7369 17.992 17.9918 17.737 18.1516 17.4234C18.3333 17.0669 18.3333 16.6002 18.3333 15.6667V10.1667C18.3333 9.23333 18.3333 8.76662 18.1516 8.4101C17.9918 8.09649 17.7369 7.84153 17.4233 7.68174C17.0668 7.50008 16.6 7.50008 15.6666 7.50008H10.1666C9.23321 7.50008 8.7665 7.50008 8.40998 7.68174C8.09637 7.84153 7.8414 8.09649 7.68162 8.4101C7.49996 8.76662 7.49996 9.23333 7.49996 10.1667V15.6667C7.49996 16.6002 7.49996 17.0669 7.68162 17.4234C7.8414 17.737 8.09637 17.992 8.40998 18.1518C8.7665 18.3334 9.23321 18.3334 10.1666 18.3334Z"
        stroke="#667085"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  confidence: (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#F4EBFF" />
      <rect
        x="4"
        y="4"
        width="48"
        height="48"
        rx="24"
        stroke="#F9F5FF"
        strokeWidth="8"
        fill="none"
      />
      <path
        d="M27 19H23.8C22.1198 19 21.2798 19 20.638 19.327C20.0735 19.6146 19.6146 20.0735 19.327 20.638C19 21.2798 19 22.1198 19 23.8V32.2C19 33.8802 19 34.7202 19.327 35.362C19.6146 35.9265 20.0735 36.3854 20.638 36.673C21.2798 37 22.1198 37 23.8 37H32.2C33.8802 37 34.7202 37 35.362 36.673C35.9265 36.3854 36.3854 35.9265 36.673 35.362C37 34.7202 37 33.8802 37 32.2V29M28 24H32V28M31.5 19.5V18M35.4393 20.5607L36.5 19.5M36.5103 24.5H38.0103M19 29.3471C19.6519 29.4478 20.3199 29.5 21 29.5C25.3864 29.5 29.2653 27.3276 31.6197 24"
        stroke="#484848"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  happyCustomer: (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#F4EBFF" />
      <rect
        x="4"
        y="4"
        width="48"
        height="48"
        rx="24"
        stroke="#F9F5FF"
        strokeWidth="8"
        fill="none"
      />
      <path
        d="M24.9996 30C24.9996 30 26.3121 31.5 28.4996 31.5C30.6871 31.5 31.9996 30 31.9996 30M31.2496 25H31.2596M25.7496 25H25.7596M28.4996 36C33.194 36 36.9996 32.1944 36.9996 27.5C36.9996 22.8056 33.194 19 28.4996 19C23.8052 19 19.9996 22.8056 19.9996 27.5C19.9996 28.45 20.1555 29.3636 20.443 30.2166C20.5512 30.5376 20.6053 30.6981 20.6151 30.8214C20.6247 30.9432 20.6174 31.0286 20.5873 31.1469C20.5568 31.2668 20.4894 31.3915 20.3547 31.6408L18.7191 34.6684C18.4857 35.1002 18.3691 35.3161 18.3952 35.4828C18.4179 35.6279 18.5034 35.7557 18.6288 35.8322C18.7728 35.9201 19.0169 35.8948 19.5052 35.8444L24.6262 35.315C24.7813 35.299 24.8588 35.291 24.9295 35.2937C24.999 35.2963 25.0481 35.3029 25.1159 35.3185C25.1848 35.3344 25.2714 35.3678 25.4448 35.4345C26.3928 35.7998 27.4228 36 28.4996 36ZM31.7496 25C31.7496 25.2761 31.5258 25.5 31.2496 25.5C30.9735 25.5 30.7496 25.2761 30.7496 25C30.7496 24.7239 30.9735 24.5 31.2496 24.5C31.5258 24.5 31.7496 24.7239 31.7496 25ZM26.2496 25C26.2496 25.2761 26.0258 25.5 25.7496 25.5C25.4735 25.5 25.2496 25.2761 25.2496 25C25.2496 24.7239 25.4735 24.5 25.7496 24.5C26.0258 24.5 26.2496 24.7239 26.2496 25Z"
        stroke="#667085"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  faqOpenIcon: (
    <svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="2" width="2" height="14" transform="rotate(-90 0 2)" fill="white" />
    </svg>
  ),
  faqCloseIcon: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 0H8V14H6V0Z" fill="#051036" />
      <path d="M8.74228e-08 8L0 6L14 6V8L8.74228e-08 8Z" fill="#051036" />
    </svg>
  ),
  mail: (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#F4EBFF" />
      <rect
        x="4"
        y="4"
        width="48"
        height="48"
        rx="24"
        stroke="#F9F5FF"
        strokeWidth="8"
        fill="none"
      />
      <path
        d="M18 23L26.1649 28.7154C26.8261 29.1783 27.1567 29.4097 27.5163 29.4993C27.8339 29.5785 28.1661 29.5785 28.4837 29.4993C28.8433 29.4097 29.1739 29.1783 29.8351 28.7154L38 23M22.8 36H33.2C34.8802 36 35.7202 36 36.362 35.673C36.9265 35.3854 37.3854 34.9265 37.673 34.362C38 33.7202 38 32.8802 38 31.2V24.8C38 23.1198 38 22.2798 37.673 21.638C37.3854 21.0735 36.9265 20.6146 36.362 20.327C35.7202 20 34.8802 20 33.2 20H22.8C21.1198 20 20.2798 20 19.638 20.327C19.0735 20.6146 18.6146 21.0735 18.327 21.638C18 22.2798 18 23.1198 18 24.8V31.2C18 32.8802 18 33.7202 18.327 34.362C18.6146 34.9265 19.0735 35.3854 19.638 35.673C20.2798 36 21.1198 36 22.8 36Z"
        stroke="#484848"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  address: (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#F4EBFF" />
      <rect
        x="4"
        y="4"
        width="48"
        height="48"
        rx="24"
        stroke="#F9F5FF"
        strokeWidth="8"
        fill="none"
      />
      <path
        d="M28 28.5C29.6569 28.5 31 27.1569 31 25.5C31 23.8431 29.6569 22.5 28 22.5C26.3431 22.5 25 23.8431 25 25.5C25 27.1569 26.3431 28.5 28 28.5Z"
        stroke="#484848"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M28 38C30 34 36 31.4183 36 26C36 21.5817 32.4183 18 28 18C23.5817 18 20 21.5817 20 26C20 31.4183 26 34 28 38Z"
        stroke="#484848"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  call: (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#F4EBFF" />
      <rect
        x="4"
        y="4"
        width="48"
        height="48"
        rx="24"
        stroke="#F9F5FF"
        strokeWidth="8"
        fill="none"
      />
      <path
        d="M24.3803 24.8532C25.0763 26.3028 26.0251 27.6615 27.2266 28.8631C28.4282 30.0646 29.7869 31.0134 31.2365 31.7094C31.3612 31.7693 31.4235 31.7992 31.5024 31.8222C31.7828 31.904 32.127 31.8453 32.3644 31.6752C32.4313 31.6274 32.4884 31.5702 32.6027 31.4559C32.9523 31.1063 33.1271 30.9315 33.3029 30.8172C33.9658 30.3862 34.8204 30.3862 35.4833 30.8172C35.6591 30.9315 35.8339 31.1063 36.1835 31.4559L36.3783 31.6508C36.9098 32.1822 37.1755 32.448 37.3198 32.7333C37.6069 33.3009 37.6069 33.9712 37.3198 34.5387C37.1755 34.8241 36.9098 35.0898 36.3783 35.6213L36.2207 35.7789C35.6911 36.3085 35.4263 36.5733 35.0662 36.7756C34.6667 37 34.0462 37.1614 33.588 37.16C33.1751 37.1588 32.8928 37.0787 32.3284 36.9185C29.295 36.0575 26.4326 34.433 24.0447 32.045C21.6567 29.6571 20.0322 26.7947 19.1712 23.7613C19.011 23.1969 18.9309 22.9146 18.9297 22.5017C18.9283 22.0435 19.0897 21.423 19.3141 21.0235C19.5164 20.6634 19.7812 20.3986 20.3108 19.869L20.4684 19.7114C20.9999 19.1799 21.2656 18.9142 21.551 18.7699C22.1185 18.4828 22.7888 18.4828 23.3564 18.7699C23.6417 18.9142 23.9075 19.1799 24.4389 19.7114L24.6338 19.9062C24.9834 20.2559 25.1582 20.4307 25.2725 20.6064C25.7035 21.2693 25.7035 22.1239 25.2725 22.7868C25.1582 22.9626 24.9834 23.1374 24.6338 23.487C24.5195 23.6013 24.4623 23.6584 24.4145 23.7253C24.2445 23.9627 24.1858 24.307 24.2675 24.5873C24.2905 24.6662 24.3204 24.7285 24.3803 24.8532Z"
        stroke="#484848"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  attachment: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.4717 11.2426L6.52889 12.1854C5.22714 13.4872 3.11659 13.4872 1.81484 12.1854C0.513094 10.8837 0.513095 8.77311 1.81484 7.47136L2.75765 6.52855M11.2429 7.47136L12.1857 6.52855C13.4875 5.2268 13.4875 3.11625 12.1857 1.81451C10.884 0.512759 8.77344 0.512759 7.4717 1.81451L6.52889 2.75732M4.66696 9.33328L9.33363 4.66661"
        stroke="#98A2B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  checkCircle: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_312_2688)">
        <path
          d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
          stroke="#7F56D9"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip0_312_2688">
          <rect width="24" height="24" rx="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  uncheck: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="19" height="19" rx="5.5" stroke="#D0D5DD" fill="none" />
    </svg>
  ),
  check: (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.75 13L11.25 16.5L18.25 9.50004M24.6667 13C24.6667 19.4434 19.4433 24.6667 13 24.6667C6.55668 24.6667 1.33334 19.4434 1.33334 13C1.33334 6.55672 6.55668 1.33337 13 1.33337C19.4433 1.33337 24.6667 6.55672 24.6667 13Z"
        stroke="#FF914D"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  paymentMethod: (
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dii_312_3124)">
        <rect x="2" y="1" width="48" height="48" rx="10" fill="white" />
        <rect x="2.5" y="1.5" width="47" height="47" rx="9.5" stroke="#E4E7EC" fill="none" />
        <path
          d="M36 23H16M36 24V21.2C36 20.0799 36 19.5198 35.782 19.092C35.5903 18.7157 35.2843 18.4097 34.908 18.218C34.4802 18 33.9201 18 32.8 18H19.2C18.0799 18 17.5198 18 17.092 18.218C16.7157 18.4097 16.4097 18.7157 16.218 19.092C16 19.5198 16 20.0799 16 21.2V28.8C16 29.9201 16 30.4802 16.218 30.908C16.4097 31.2843 16.7157 31.5903 17.092 31.782C17.5198 32 18.0799 32 19.2 32H25.5M32 34C32 34 35 32.5701 35 30.4252V27.9229L32.8124 27.1412C32.2868 26.9529 31.712 26.9529 31.1864 27.1412L29 27.9229V30.4252C29 32.5701 32 34 32 34Z"
          stroke="#344054"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <filter
          id="filter0_dii_312_3124"
          x="0"
          y="0"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_312_3124" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_312_3124"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_312_3124" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect3_innerShadow_312_3124"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_312_3124"
            result="effect3_innerShadow_312_3124"
          />
        </filter>
      </defs>
    </svg>
  ),
  idea: (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 16.6586V19C9 20.1046 9.89543 21 11 21C12.1046 21 13 20.1046 13 19V16.6586M11 1V2M2 11H1M4.5 4.5L3.8999 3.8999M17.5 4.5L18.1002 3.8999M21 11H20M17 11C17 14.3137 14.3137 17 11 17C7.68629 17 5 14.3137 5 11C5 7.68629 7.68629 5 11 5C14.3137 5 17 7.68629 17 11Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  bookkeeping: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V16.5M16 13H11.5M16 9H12.5M16 17H8M6 10V4.5C6 3.67157 6.67157 3 7.5 3C8.32843 3 9 3.67157 9 4.5V10C9 11.6569 7.65685 13 6 13C4.34315 13 3 11.6569 3 10V6"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  accounts: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 9.00002V17M9.5 9.00002V17M14.5 9.00002V17M19 9.00002V17M3 18.6L3 19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7952 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7952 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V18.6C21 18.04 21 17.7599 20.891 17.546C20.7951 17.3579 20.6422 17.2049 20.454 17.109C20.2401 17 19.9601 17 19.4 17H4.6C4.03995 17 3.75992 17 3.54601 17.109C3.35785 17.2049 3.20487 17.3579 3.10899 17.546C3 17.7599 3 18.04 3 18.6ZM11.6529 3.07715L4.25291 4.7216C3.80585 4.82094 3.58232 4.87062 3.41546 4.99082C3.26829 5.09685 3.15273 5.24092 3.08115 5.40759C3 5.59654 3 5.82553 3 6.28349L3 7.40002C3 7.96007 3 8.2401 3.10899 8.45401C3.20487 8.64217 3.35785 8.79515 3.54601 8.89103C3.75992 9.00002 4.03995 9.00002 4.6 9.00002H19.4C19.9601 9.00002 20.2401 9.00002 20.454 8.89103C20.6422 8.79515 20.7951 8.64217 20.891 8.45401C21 8.2401 21 7.96007 21 7.40002V6.2835C21 5.82553 21 5.59655 20.9188 5.40759C20.8473 5.24092 20.7317 5.09685 20.5845 4.99082C20.4177 4.87062 20.1942 4.82094 19.7471 4.7216L12.3471 3.07715C12.2176 3.04837 12.1528 3.03398 12.0874 3.02824C12.0292 3.02314 11.9708 3.02314 11.9126 3.02824C11.8472 3.03398 11.7824 3.04837 11.6529 3.07715Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  tax: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 5C13 6.10457 10.5376 7 7.5 7C4.46243 7 2 6.10457 2 5M13 5C13 3.89543 10.5376 3 7.5 3C4.46243 3 2 3.89543 2 5M13 5V6.5M2 5V17C2 18.1046 4.46243 19 7.5 19M7.5 11C7.33145 11 7.16468 10.9972 7 10.9918C4.19675 10.9 2 10.0433 2 9M7.5 15C4.46243 15 2 14.1046 2 13M22 11.5C22 12.6046 19.5376 13.5 16.5 13.5C13.4624 13.5 11 12.6046 11 11.5M22 11.5C22 10.3954 19.5376 9.5 16.5 9.5C13.4624 9.5 11 10.3954 11 11.5M22 11.5V19C22 20.1046 19.5376 21 16.5 21C13.4624 21 11 20.1046 11 19V11.5M22 15.25C22 16.3546 19.5376 17.25 16.5 17.25C13.4624 17.25 11 16.3546 11 15.25"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  services: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.5 15L18.5 12L15.5 9M8.5 9L5.5 12L8.5 15M13 7L11 17M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  money: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5295 8.35186C12.9571 8.75995 12.2566 9 11.5 9C9.567 9 8 7.433 8 5.5C8 3.567 9.567 2 11.5 2C12.753 2 13.8522 2.65842 14.4705 3.64814M6 20.0872H8.61029C8.95063 20.0872 9.28888 20.1277 9.61881 20.2086L12.3769 20.8789C12.9753 21.0247 13.5988 21.0388 14.2035 20.9214L17.253 20.3281C18.0585 20.1712 18.7996 19.7854 19.3803 19.2205L21.5379 17.1217C22.154 16.5234 22.154 15.5524 21.5379 14.9531C20.9832 14.4134 20.1047 14.3527 19.4771 14.8103L16.9626 16.6449C16.6025 16.9081 16.1643 17.0498 15.7137 17.0498H13.2855L14.8311 17.0498C15.7022 17.0498 16.4079 16.3633 16.4079 15.5159V15.2091C16.4079 14.5055 15.9156 13.892 15.2141 13.7219L12.8286 13.1417C12.4404 13.0476 12.0428 13 11.6431 13C10.6783 13 8.93189 13.7988 8.93189 13.7988L6 15.0249M20 6.5C20 8.433 18.433 10 16.5 10C14.567 10 13 8.433 13 6.5C13 4.567 14.567 3 16.5 3C18.433 3 20 4.567 20 6.5ZM2 14.6L2 20.4C2 20.9601 2 21.2401 2.10899 21.454C2.20487 21.6422 2.35785 21.7951 2.54601 21.891C2.75992 22 3.03995 22 3.6 22H4.4C4.96005 22 5.24008 22 5.45399 21.891C5.64215 21.7951 5.79513 21.6422 5.89101 21.454C6 21.2401 6 20.9601 6 20.4V14.6C6 14.0399 6 13.7599 5.89101 13.546C5.79513 13.3578 5.64215 13.2049 5.45399 13.109C5.24008 13 4.96005 13 4.4 13L3.6 13C3.03995 13 2.75992 13 2.54601 13.109C2.35785 13.2049 2.20487 13.3578 2.10899 13.546C2 13.7599 2 14.0399 2 14.6Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  cashflow: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 10H2M11 19L18.8 19C19.9201 19 20.4802 19 20.908 18.782C21.2843 18.5903 21.5903 18.2843 21.782 17.908C22 17.4802 22 16.9201 22 15.8V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H17M11 19L13 21M11 19L13 17M7 19H5.2C4.07989 19 3.51984 19 3.09202 18.782C2.71569 18.5903 2.40973 18.2843 2.21799 17.908C2 17.4802 2 16.9201 2 15.8V8.2C2 7.0799 2 6.51984 2.21799 6.09202C2.40973 5.71569 2.7157 5.40973 3.09202 5.21799C3.51984 5 4.0799 5 5.2 5H13M13 5L11 7M13 5L11 3"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  wordpress: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 9H2M14 17.5L16.5 15L14 12.5M10 12.5L7.5 15L10 17.5M2 7.8L2 16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V7.8C22 6.11984 22 5.27977 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3L6.8 3C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  design: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V8.4C3 8.96005 3 9.24008 3.10899 9.45399C3.20487 9.64215 3.35785 9.79513 3.54601 9.89101C3.75992 10 4.03995 10 4.6 10H8.4C8.96005 10 9.24008 10 9.45399 9.89101C9.64215 9.79513 9.79513 9.64215 9.89101 9.45399C10 9.24008 10 8.96005 10 8.4V4.6C10 4.03995 10 3.75992 9.89101 3.54601C9.79513 3.35785 9.64215 3.20487 9.45399 3.10899C9.24008 3 8.96005 3 8.4 3Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4 3H15.6C15.0399 3 14.7599 3 14.546 3.10899C14.3578 3.20487 14.2049 3.35785 14.109 3.54601C14 3.75992 14 4.03995 14 4.6V8.4C14 8.96005 14 9.24008 14.109 9.45399C14.2049 9.64215 14.3578 9.79513 14.546 9.89101C14.7599 10 15.0399 10 15.6 10H19.4C19.9601 10 20.2401 10 20.454 9.89101C20.6422 9.79513 20.7951 9.64215 20.891 9.45399C21 9.24008 21 8.96005 21 8.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4 14H15.6C15.0399 14 14.7599 14 14.546 14.109C14.3578 14.2049 14.2049 14.3578 14.109 14.546C14 14.7599 14 15.0399 14 15.6V19.4C14 19.9601 14 20.2401 14.109 20.454C14.2049 20.6422 14.3578 20.7951 14.546 20.891C14.7599 21 15.0399 21 15.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V15.6C21 15.0399 21 14.7599 20.891 14.546C20.7951 14.3578 20.6422 14.2049 20.454 14.109C20.2401 14 19.9601 14 19.4 14Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.4 14H4.6C4.03995 14 3.75992 14 3.54601 14.109C3.35785 14.2049 3.20487 14.3578 3.10899 14.546C3 14.7599 3 15.0399 3 15.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H8.4C8.96005 21 9.24008 21 9.45399 20.891C9.64215 20.7951 9.79513 20.6422 9.89101 20.454C10 20.2401 10 19.9601 10 19.4V15.6C10 15.0399 10 14.7599 9.89101 14.546C9.79513 14.3578 9.64215 14.2049 9.45399 14.109C9.24008 14 8.96005 14 8.4 14Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  webdev: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 18L22 12L16 6M8 6L2 12L8 18"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  deleteEvent: (
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 17H19M19 10.5V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H5.8C4.11984 3 3.27976 3 2.63803 3.32698C2.07354 3.6146 1.6146 4.07354 1.32698 4.63803C1 5.27976 1 6.11984 1 7.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H10.5M19 9H1M14 1V5M6 1V5"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  security: (
    <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 10H5M7 14H5M13 6H5M17 9V5.8C17 4.11984 17 3.27976 16.673 2.63803C16.3854 2.07354 15.9265 1.6146 15.362 1.32698C14.7202 1 13.8802 1 12.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H9.5M15 20C15 20 18 18.5701 18 16.4252V13.9229L15.8124 13.1412C15.2868 12.9529 14.712 12.9529 14.1864 13.1412L12 13.9229V16.4252C12 18.5701 15 20 15 20Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  checkListIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="#DCFAE6" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0964 7.39004L9.93641 14.3L8.03641 12.27C7.68641 11.94 7.13641 11.92 6.73641 12.2C6.34641 12.49 6.23641 13 6.47641 13.41L8.72641 17.07C8.94641 17.41 9.32641 17.62 9.75641 17.62C10.1664 17.62 10.5564 17.41 10.7764 17.07C11.1364 16.6 18.0064 8.41004 18.0064 8.41004C18.9064 7.49004 17.8164 6.68004 17.0964 7.38004V7.39004Z"
        fill="#17B26A"
      />
    </svg>
  ),
  faqOpenIcon: (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 11H15M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        stroke="#98A2B3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  close: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.22676 4.22676C4.5291 3.92441 5.01929 3.92441 5.32163 4.22676L12 10.9051L18.6784 4.22676C18.9807 3.92441 19.4709 3.92441 19.7732 4.22676C20.0756 4.5291 20.0756 5.01929 19.7732 5.32163L13.0949 12L19.7732 18.6784C20.0756 18.9807 20.0756 19.4709 19.7732 19.7732C19.4709 20.0756 18.9807 20.0756 18.6784 19.7732L12 13.0949L5.32163 19.7732C5.01929 20.0756 4.5291 20.0756 4.22676 19.7732C3.92441 19.4709 3.92441 18.9807 4.22676 18.6784L10.9051 12L4.22676 5.32163C3.92441 5.01929 3.92441 4.5291 4.22676 4.22676Z"
        fill="#030D45"
      />
    </svg>
  ),
  faqCloseIcon: (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 7V15M7 11H15M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        stroke="#98A2B3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  bagEmpty: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 32 32"
      id="i-cart"
      fill="none"
      stroke="#4a4a4a"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <path d="M6 6 L30 6 27 19 9 19 M27 23 L10 23 5 2 2 2" fill="none" />
      <circle cx="25" cy="27" r="2" fill="none" />
      <circle cx="12" cy="27" r="2" fill="none" />
    </svg>
  ),
  bagFilled: (
    <svg width="24" height="24" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 5H29L26 18H8M26 22H9L4 1H1"
        stroke="#53265e"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M24 28C25.1046 28 26 27.1046 26 26C26 24.8954 25.1046 24 24 24C22.8954 24 22 24.8954 22 26C22 27.1046 22.8954 28 24 28Z"
        stroke="#53265e"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M11 28C12.1046 28 13 27.1046 13 26C13 24.8954 12.1046 24 11 24C9.89543 24 9 24.8954 9 26C9 27.1046 9.89543 28 11 28Z"
        stroke="#53265e"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path d="M5.13462 5H29L26 18.5L8 18L5.13462 5Z" fill="#53265e" />
    </svg>
  ),
  heart: (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3783 5.88622C9.66902 4.10486 6.79049 4.0794 4.92308 5.90387C4.91717 5.90965 4.91116 5.91534 4.90506 5.92092C3.09331 7.58038 3.06654 10.3577 4.92308 12.1716L4.92796 12.1763L11.9374 19.1469L19.0769 12.1716C19.0828 12.1658 19.0888 12.1601 19.0949 12.1545C20.9067 10.495 20.9335 7.71772 19.0769 5.90387C17.2195 4.08919 14.3268 4.08919 12.4694 5.90387C12.3227 6.04722 12.125 6.12596 11.9202 6.12264C11.7154 6.11933 11.5204 6.03424 11.3783 5.88622ZM11.9465 4.31813C9.59468 2.40387 6.12292 2.58601 3.85838 4.79012C1.36802 7.08049 1.39686 10.8778 3.84702 13.2742C3.84785 13.275 3.84869 13.2759 3.84952 13.2767L11.391 20.7763C11.689 21.0727 12.1688 21.0748 12.4694 20.7811L20.1419 13.2851C22.6328 10.9939 22.603 7.19491 20.1505 4.79876C17.8724 2.57305 14.397 2.41284 11.9465 4.31813Z"
        fill="#4a4a4a"
      />
    </svg>
  ),
  heartFilled: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 491 437"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M222.5 426.7C228.6 432.8 236.8 436.2 245.4 436.2C253.9 436.2 262.3 432.7 268.3 426.7L448 247C475.3 219.7 490.3 183.4 490.4 144.9C490.4 106.3 475.4 70 448.1 42.7C420.8 15.4 384.6 0.400011 346 0.400011C308.1 0.400011 272.4 14.9 245.3 41.3C218.1 14.8 182.3 0.200012 144.3 0.200012C105.8 0.200012 69.6 15.2 42.3 42.4C15 69.7 0 106 0 144.6C0 183.1 15.1 219.4 42.4 246.7L222.5 426.7Z"
        fill="#c6488c"
      />
    </svg>
  ),
  disabledSubtractIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 12L4 12"
        stroke="#dedede"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  disabledAddIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 4V20"
        stroke="#dedede"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 12H20"
        stroke="#dedede"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  iconShield: (
    <svg width="24px" height="24px" id="Capa_1" x="0px" y="0px" viewBox="0 0 297.891 297.891">
      <g>
        <path d="M264.148,40.644L153.978,0.89C152.334,0.297,150.64,0,148.917,0c-1.731,0-3.449,0.3-5.101,0.899L34.041,40.653   c-5.933,2.152-10.096,7.789-10.096,14.101v94.191c0,21.029,6.778,42.061,19.713,62.51c9.915,15.673,23.715,31.043,40.802,45.686   c28.57,24.482,56.918,38.604,58.109,39.193c2.096,1.037,4.402,1.557,6.681,1.557c2.245,0,4.505-0.504,6.577-1.512   c1.191-0.58,29.526-14.482,58.123-38.867c17.104-14.584,30.697-29.954,40.619-45.682c12.93-20.493,19.375-41.65,19.375-62.885   V54.754C273.945,48.432,270.095,42.788,264.148,40.644z M47.945,148.875V65.969c0-3.156,1.934-5.975,4.901-7.051l93.312-33.947   c0.832-0.301,1.787-0.523,2.787-0.523v124.498h101.711c0.006,0,0.013,0.135,0.013,0.221c-0.02,27.129-13.684,54.016-40.607,80.195   c-21.025,20.445-44.912,35.036-57.199,41.919c-1.139,0.639-2.917,0.94-3.917,0.94c0-2.333,0-121.982,0-123.314L47.945,148.875z" />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  ),
  leftArrow: (
    <svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.60582 10.9499L11.5209 2.65916C11.6835 2.50868 11.8109 2.3212 11.8934 2.11113C11.9759 1.90107 12.0113 1.674 11.9969 1.44738C11.9824 1.22076 11.9186 1.00061 11.8102 0.803854C11.7018 0.607096 11.5518 0.438962 11.3716 0.312369C11.0717 0.0849373 10.7046 -0.0241251 10.3353 0.00447951C9.966 0.0330841 9.61824 0.197511 9.35359 0.468668L0.460189 9.85468C0.315154 9.99388 0.199352 10.1631 0.120131 10.3517C0.04091 10.5402 2.68221e-07 10.7439 2.68221e-07 10.9499C2.68221e-07 11.1559 0.04091 11.3596 0.120131 11.5482C0.199352 11.7367 0.315154 11.906 0.460189 12.0452L9.35359 21.4312C9.61824 21.7023 9.966 21.8668 10.3353 21.8954C10.7046 21.924 11.0717 21.8149 11.3716 21.5875C11.5518 21.4609 11.7018 21.2927 11.8102 21.096C11.9186 20.8992 11.9824 20.6791 11.9969 20.4525C12.0113 20.2258 11.9759 19.9988 11.8934 19.7887C11.8109 19.5786 11.6835 19.3912 11.5209 19.2407L3.60582 10.9499Z"
        fill="white"
      />
    </svg>
  ),
  rightArrow: (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.15209 9.10823L4.49468 8.4572L6.4637 6.48818H1.67997V5.53718H6.4637L4.49468 3.57135L5.15209 2.91714L8.24763 6.01268L5.15209 9.10823Z"
        fill="#121418"
      />
    </svg>
  ),
  previousArrow: (
    <svg
      style={{ transform: 'rotate(180deg)' }}
      fill="none"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="19.6875" fill="white" stroke="none" strokeWidth="0.625" />
      <path d="M17.5 13.75L23.75 20L17.5 26.25" stroke="#3D3D3D" strokeWidth="1.5" />
    </svg>
  ),
  noResults: (
    <svg
      width="160"
      height="157"
      viewBox="0 0 160 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_55_11958)">
        <path
          d="M101.575 35.5344H58.4615C57.4791 35.5355 56.5372 35.9264 55.8425 36.6211C55.1478 37.3158 54.7569 38.2577 54.7557 39.2401V135.059L54.2616 135.21L43.6853 138.449C43.1841 138.602 42.6427 138.549 42.18 138.303C41.7173 138.058 41.3711 137.638 41.2173 137.137L9.75763 34.3757C9.60453 33.8744 9.65671 33.3329 9.9027 32.8701C10.1487 32.4073 10.5684 32.0611 11.0695 31.9076L27.3676 26.9172L74.6163 12.4547L90.9143 7.46427C91.1623 7.38794 91.423 7.36127 91.6813 7.38578C91.9397 7.41029 92.1906 7.48551 92.4199 7.60713C92.6491 7.72875 92.8521 7.89438 93.0173 8.09455C93.1825 8.29471 93.3065 8.52548 93.3824 8.77365L101.424 35.0402L101.575 35.5344Z"
          fill="#FAFAFA"
        />
        <path
          d="M110.982 35.0404L101.291 3.38308C101.129 2.85561 100.866 2.36509 100.515 1.93953C100.164 1.51398 99.7326 1.16174 99.2455 0.902944C98.7584 0.644146 98.2251 0.48386 97.676 0.431251C97.127 0.378641 96.573 0.434739 96.0456 0.596334L73.1315 7.61015L25.8853 22.0751L2.97119 29.0913C1.90672 29.4182 1.01543 30.1541 0.492947 31.1374C-0.0295344 32.1207 -0.140517 33.2712 0.184365 34.3363L33.3092 142.528C33.5731 143.388 34.1056 144.14 34.8286 144.675C35.5516 145.21 36.4269 145.499 37.3263 145.5C37.7425 145.5 38.1564 145.438 38.5541 145.315L54.2617 140.507L54.7558 140.354V139.837L54.2617 139.988L38.4084 144.843C37.4688 145.129 36.4539 145.031 35.5865 144.57C34.719 144.11 34.0697 143.323 33.7811 142.385L0.658807 34.1905C0.515786 33.7253 0.465939 33.2364 0.512119 32.7519C0.5583 32.2674 0.699596 31.7967 0.927927 31.3669C1.15626 30.9371 1.46714 30.5565 1.84275 30.247C2.21837 29.9375 2.65135 29.7051 3.1169 29.5632L26.031 22.5469L73.2773 8.08449L96.1914 1.06821C96.5445 0.960444 96.9117 0.905497 97.2809 0.905153C98.0732 0.906932 98.8441 1.16237 99.4808 1.63406C100.117 2.10575 100.586 2.7689 100.819 3.52638L110.466 35.0404L110.619 35.5345H111.133L110.982 35.0404Z"
          fill="#E0E0E0"
        />
        <path
          d="M148.883 144.237H65.379C64.8223 144.237 64.2885 144.015 63.8948 143.622C63.5011 143.228 63.2797 142.694 63.2791 142.138V42.0814C63.2797 41.5246 63.5011 40.9909 63.8948 40.5972C64.2885 40.2035 64.8222 39.9821 65.379 39.9814H148.883C149.439 39.9821 149.973 40.2035 150.367 40.5972C150.761 40.9909 150.982 41.5246 150.983 42.0814V142.138C150.982 142.694 150.76 143.228 150.367 143.622C149.973 144.015 149.439 144.237 148.883 144.237Z"
          fill="#FAFAFA"
        />
        <path
          d="M110.466 35.04H58.4615C57.3481 35.0416 56.2807 35.4846 55.4935 36.2719C54.7062 37.0592 54.2632 38.1265 54.2616 39.2399V139.988L54.7557 139.837V39.2399C54.7569 38.2575 55.1477 37.3156 55.8424 36.6209C56.5371 35.9262 57.479 35.5353 58.4615 35.5341H110.619L110.466 35.04ZM155.8 35.04H58.4615C57.3481 35.0416 56.2807 35.4846 55.4935 36.2719C54.7062 37.0592 54.2632 38.1265 54.2616 39.2399V152.39C54.2632 153.503 54.7062 154.571 55.4935 155.358C56.2807 156.145 57.3481 156.588 58.4615 156.59H155.8C156.913 156.588 157.981 156.145 158.768 155.358C159.555 154.571 159.998 153.503 160 152.39V39.2399C159.998 38.1265 159.555 37.0592 158.768 36.2719C157.981 35.4846 156.913 35.0416 155.8 35.04ZM159.506 152.39C159.505 153.372 159.114 154.314 158.419 155.009C157.724 155.704 156.783 156.094 155.8 156.096H58.4615C57.479 156.094 56.5371 155.704 55.8424 155.009C55.1477 154.314 54.7569 153.372 54.7557 152.39V39.2399C54.7569 38.2575 55.1477 37.3156 55.8424 36.6209C56.5371 35.9262 57.479 35.5353 58.4615 35.5341H155.8C156.783 35.5353 157.724 35.9262 158.419 36.6209C159.114 37.3156 159.505 38.2575 159.506 39.2399V152.39Z"
          fill="#E0E0E0"
        />
        <path
          d="M129.86 45.911H84.4021C83.8126 45.9103 83.2474 45.6759 82.8306 45.259C82.4137 44.8422 82.1793 44.277 82.1786 43.6875V32.8172C82.1793 32.2277 82.4137 31.6626 82.8306 31.2457C83.2474 30.8289 83.8126 30.5944 84.4021 30.5938H129.86C130.449 30.5944 131.014 30.8289 131.431 31.2457C131.848 31.6626 132.082 32.2277 132.083 32.8172V43.6875C132.082 44.277 131.848 44.8422 131.431 45.259C131.014 45.6759 130.449 45.9103 129.86 45.911Z"
          fill="#C6488C"
        />
        <path
          d="M107.131 31.3342C109.86 31.3342 112.072 29.1221 112.072 26.3932C112.072 23.6643 109.86 21.4521 107.131 21.4521C104.402 21.4521 102.19 23.6643 102.19 26.3932C102.19 29.1221 104.402 31.3342 107.131 31.3342Z"
          fill="#C6488C"
        />
        <path
          d="M107.131 29.4029C108.793 29.4029 110.14 28.0555 110.14 26.3933C110.14 24.7312 108.793 23.3838 107.131 23.3838C105.469 23.3838 104.121 24.7312 104.121 26.3933C104.121 28.0555 105.469 29.4029 107.131 29.4029Z"
          fill="#FAFAFA"
        />
        <path
          d="M30.3086 31.9887C29.8325 31.9883 29.369 31.8354 28.9861 31.5523C28.6032 31.2692 28.3211 30.8709 28.1812 30.4157L24.9991 20.0218C24.9136 19.7426 24.8839 19.4493 24.9118 19.1586C24.9396 18.868 25.0245 18.5856 25.1615 18.3278C25.2984 18.0699 25.4849 17.8416 25.7102 17.6557C25.9354 17.4699 26.1951 17.3303 26.4743 17.2449L69.9404 3.93773C70.5043 3.76566 71.1134 3.82435 71.634 4.1009C72.1547 4.37745 72.5443 4.84927 72.7175 5.4128L75.8996 15.8069C76.0715 16.3707 76.0128 16.9798 75.7363 17.5004C75.4597 18.021 74.988 18.4107 74.4245 18.5839L30.9582 31.8911C30.7478 31.9557 30.5288 31.9886 30.3086 31.9887Z"
          fill="#C6488C"
        />
        <path
          d="M46.9779 11.5159C49.7068 11.5159 51.919 9.3037 51.919 6.57483C51.919 3.84597 49.7068 1.63379 46.9779 1.63379C44.249 1.63379 42.0369 3.84597 42.0369 6.57483C42.0369 9.3037 44.249 11.5159 46.9779 11.5159Z"
          fill="#C6488C"
        />
        <path
          d="M46.9778 9.70394C48.7058 9.70394 50.1066 8.30311 50.1066 6.57511C50.1066 4.84711 48.7058 3.44629 46.9778 3.44629C45.2498 3.44629 43.849 4.84711 43.849 6.57511C43.849 8.30311 45.2498 9.70394 46.9778 9.70394Z"
          fill="#FAFAFA"
        />
      </g>
      <defs>
        <clipPath id="clip0_55_11958">
          <rect width="160" height="156.18" fill="white" transform="translate(0 0.410156)" />
        </clipPath>
      </defs>
    </svg>
  ),
  iconShare: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.3927 8.03168L18.6457 6.51461C17.3871 5.42153 16.8937 4.83352 16.2121 5.04139C15.3622 5.30059 15.642 6.93609 15.642 7.48824C14.3206 7.48824 12.9468 7.38661 11.6443 7.59836C7.34453 8.29742 6 11.3566 6 14.6525C7.21697 13.9065 8.43274 13.0746 9.8954 12.7289C11.7212 12.2973 13.7603 12.5032 15.642 12.5032C15.642 13.0554 15.3622 14.6909 16.2121 14.9501C16.9844 15.1856 17.3871 14.5699 18.6457 13.4769L20.3927 11.9598C21.4642 11.0293 22 10.564 22 9.99574C22 9.4275 21.4642 8.96223 20.3927 8.03168Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M10.5676 3C6.70735 3.00694 4.68594 3.10152 3.39411 4.39073C2 5.78202 2 8.02125 2 12.4997C2 16.9782 2 19.2174 3.3941 20.6087C4.78821 22 7.03198 22 11.5195 22C16.0071 22 18.2509 22 19.645 20.6087C20.6156 19.64 20.9104 18.2603 21 16"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  userCircle: (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.3163 18.4384C4.92462 17.0052 6.34492 16 8 16H14C15.6551 16 17.0754 17.0052 17.6837 18.4384M15 8.5C15 10.7091 13.2091 12.5 11 12.5C8.79086 12.5 7 10.7091 7 8.5C7 6.29086 8.79086 4.5 11 4.5C13.2091 4.5 15 6.29086 15 8.5ZM21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  imageUpload: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.2 19H4.93137C4.32555 19 4.02265 19 3.88238 18.8802C3.76068 18.7763 3.69609 18.6203 3.70865 18.4608C3.72312 18.2769 3.93731 18.0627 4.36569 17.6343L12.8686 9.13137C13.2646 8.73536 13.4627 8.53735 13.691 8.46316C13.8918 8.3979 14.1082 8.3979 14.309 8.46316C14.5373 8.53735 14.7354 8.73535 15.1314 9.13137L19 13V14.2M14.2 19C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2M14.2 19H5.8C4.11984 19 3.27976 19 2.63803 18.673C2.07354 18.3854 1.6146 17.9265 1.32698 17.362C1 16.7202 1 15.8802 1 14.2V5.8C1 4.11984 1 3.27976 1.32698 2.63803C1.6146 2.07354 2.07354 1.6146 2.63803 1.32698C3.27976 1 4.11984 1 5.8 1H14.2C15.8802 1 16.7202 1 17.362 1.32698C17.9265 1.6146 18.3854 2.07354 18.673 2.63803C19 3.27976 19 4.11984 19 5.8V14.2M8.5 6.5C8.5 7.60457 7.60457 8.5 6.5 8.5C5.39543 8.5 4.5 7.60457 4.5 6.5C4.5 5.39543 5.39543 4.5 6.5 4.5C7.60457 4.5 8.5 5.39543 8.5 6.5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  customer: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.57757 15.4816C5.1628 16.324 1.45336 18.0441 3.71266 20.1966C4.81631 21.248 6.04549 22 7.59087 22H16.4091C17.9545 22 19.1837 21.248 20.2873 20.1966C22.5466 18.0441 18.8372 16.324 17.4224 15.4816C14.1048 13.5061 9.89519 13.5061 6.57757 15.4816Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 6.5C16.5 8.98528 14.4853 11 12 11C9.51472 11 7.5 8.98528 7.5 6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5Z"
        stroke="#2A353D"
        strokeWidth="1.5"
      />
    </svg>
  ),
  shop: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 10.5V15.5C3 18.3284 3 19.7426 3.87868 20.6213C4.75736 21.5 6.17157 21.5 9 21.5H15C17.8284 21.5 19.2426 21.5 20.1213 20.6213C21 19.7426 21 18.3284 21 15.5V10.5"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15 17C14.3159 17.6072 13.2268 18 12 18C10.7732 18 9.68409 17.6072 9 17"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2.91199 5.23509L2.19806 5.0053H2.19806L2.91199 5.23509ZM2.22827 7.35933L2.94219 7.58912L2.22827 7.35933ZM21.088 5.23509L20.3741 5.46488V5.46488L21.088 5.23509ZM21.7717 7.35933L22.4857 7.12954L21.7717 7.35933ZM9.65635 9.77316C9.36534 9.47841 8.89047 9.47538 8.59572 9.7664C8.30096 10.0574 8.29793 10.5323 8.58895 10.827L9.65635 9.77316ZM15.4112 9.77261C15.1202 9.47778 14.6454 9.47464 14.3505 9.76559C14.0557 10.0565 14.0526 10.5314 14.3435 10.8262L15.4112 9.77261ZM2.37533 9.57004L2.98333 9.13091L2.98333 9.13091L2.37533 9.57004ZM10.8727 8.68818C10.9766 8.28722 10.7358 7.87792 10.3349 7.77399C9.9339 7.67006 9.52461 7.91085 9.42068 8.31182L10.8727 8.68818ZM16.6267 8.68818C16.7306 8.28722 16.4899 7.87792 16.0889 7.77399C15.6879 7.67006 15.2786 7.91085 15.1747 8.31182L16.6267 8.68818ZM21.6247 9.57004L21.0167 9.13091V9.13091L21.6247 9.57004ZM21.9735 8.70667L21.2325 8.59103V8.59103L21.9735 8.70667ZM2.0265 8.70667L1.28547 8.82231L2.0265 8.70667ZM4.05507 2.87752L3.60645 2.27649L3.60645 2.27649L4.05507 2.87752ZM2.19806 5.0053L1.51434 7.12954L2.94219 7.58912L3.62592 5.46488L2.19806 5.0053ZM20.3741 5.46488L21.0578 7.58912L22.4857 7.12954L21.8019 5.0053L20.3741 5.46488ZM6.57622 3.25H17.4238V1.75H6.57622V3.25ZM11.9993 10.75C11.0804 10.75 10.2518 10.3762 9.65635 9.77316L8.58895 10.827C9.45574 11.705 10.6646 12.25 11.9993 12.25V10.75ZM17.7547 10.75C16.8355 10.75 16.0066 10.376 15.4112 9.77261L14.3435 10.8262C15.2104 11.7046 16.4196 12.25 17.7547 12.25V10.75ZM6.2453 10.75C5.01112 10.75 3.67028 10.082 2.98333 9.13091L1.76733 10.0092C2.75148 11.3718 4.55603 12.25 6.2453 12.25V10.75ZM9.42068 8.31182C9.05796 9.71116 7.77553 10.75 6.2453 10.75V12.25C8.46912 12.25 10.341 10.7393 10.8727 8.68818L9.42068 8.31182ZM15.1747 8.31182C14.812 9.71116 13.5296 10.75 11.9993 10.75V12.25C14.2231 12.25 16.0951 10.7393 16.6267 8.68818L15.1747 8.31182ZM21.0167 9.13091C20.3297 10.082 18.9889 10.75 17.7547 10.75V12.25C19.444 12.25 21.2485 11.3718 22.2327 10.0092L21.0167 9.13091ZM21.0578 7.58912C21.2449 8.1704 21.2777 8.30138 21.2325 8.59103L22.7145 8.82231C22.8208 8.1415 22.6686 7.69774 22.4857 7.12954L21.0578 7.58912ZM22.2327 10.0092C22.3174 9.89189 22.4327 9.73648 22.5243 9.53046C22.617 9.32192 22.6717 9.09674 22.7145 8.82231L21.2325 8.59103C21.1996 8.80184 21.1709 8.88229 21.1536 8.92111C21.1353 8.96244 21.114 8.99609 21.0167 9.13091L22.2327 10.0092ZM21.8019 5.0053C21.5947 4.36137 21.4214 3.81957 21.2309 3.39553C21.0333 2.95545 20.7871 2.57024 20.3936 2.27649L19.4963 3.47854C19.6085 3.56231 19.7215 3.69586 19.8627 4.01018C20.0111 4.34054 20.1565 4.78877 20.3741 5.46488L21.8019 5.0053ZM17.4238 3.25C18.1135 3.25 18.5655 3.25121 18.9105 3.292C19.2346 3.33033 19.3863 3.39642 19.4963 3.47854L20.3936 2.27649C19.9978 1.9811 19.5607 1.85843 19.0866 1.80238C18.6333 1.74879 18.0777 1.75 17.4238 1.75V3.25ZM1.51434 7.12954C1.33145 7.69774 1.17923 8.1415 1.28547 8.82231L2.76753 8.59103C2.72233 8.30137 2.7551 8.1704 2.94219 7.58912L1.51434 7.12954ZM2.98333 9.13091C2.88596 8.99609 2.86474 8.96244 2.84636 8.92111C2.82911 8.88229 2.80043 8.80184 2.76753 8.59103L1.28547 8.82231C1.3283 9.09674 1.383 9.32192 1.47571 9.53046C1.5673 9.73648 1.68263 9.89189 1.76733 10.0092L2.98333 9.13091ZM3.62592 5.46488C3.84354 4.78877 3.98895 4.34054 4.13735 4.01018C4.27854 3.69586 4.39148 3.56231 4.5037 3.47854L3.60645 2.27649C3.21291 2.57024 2.96674 2.95545 2.76906 3.39553C2.57858 3.81957 2.40532 4.36137 2.19806 5.0053L3.62592 5.46488ZM6.57622 1.75C5.9223 1.75 5.36666 1.74879 4.9134 1.80238C4.43932 1.85843 4.00218 1.9811 3.60645 2.27649L4.5037 3.47854C4.61373 3.39642 4.76536 3.33033 5.08952 3.292C5.43449 3.25121 5.88655 3.25 6.57622 3.25V1.75Z"
        fill="#2A353D"
      />
    </svg>
  ),
  dashboardHome: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 17C14.2005 17.6224 13.1502 18 12 18C10.8498 18 9.79952 17.6224 9 17"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2.35139 13.2135C1.99837 10.9162 1.82186 9.76763 2.25617 8.74938C2.69047 7.73112 3.65403 7.03443 5.58114 5.64106L7.02099 4.6C9.41829 2.86667 10.6169 2 12 2C13.3831 2 14.5817 2.86667 16.979 4.6L18.4189 5.64106C20.346 7.03443 21.3095 7.73112 21.7438 8.74938C22.1781 9.76763 22.0016 10.9162 21.6486 13.2135L21.3476 15.1724C20.8471 18.4289 20.5969 20.0572 19.429 21.0286C18.2611 22 16.5537 22 13.1388 22H10.8612C7.44633 22 5.73891 22 4.571 21.0286C3.40309 20.0572 3.15287 18.4289 2.65243 15.1724L2.35139 13.2135Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  ),
  dashboardPayouts: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 14C16 14.8284 16.6716 15.5 17.5 15.5C18.3284 15.5 19 14.8284 19 14C19 13.1716 18.3284 12.5 17.5 12.5C16.6716 12.5 16 13.1716 16 14Z"
        stroke="#2A353D"
        strokeWidth="1.5"
      />
      <path
        d="M10 7H16C18.8284 7 20.2426 7 21.1213 7.87868C22 8.75736 22 10.1716 22 13V15C22 17.8284 22 19.2426 21.1213 20.1213C20.2426 21 18.8284 21 16 21H10C6.22876 21 4.34315 21 3.17157 19.8284C2 18.6569 2 16.7712 2 13V11C2 7.22876 2 5.34315 3.17157 4.17157C4.34315 3 6.22876 3 10 3H14C14.93 3 15.395 3 15.7765 3.10222C16.8117 3.37962 17.6204 4.18827 17.8978 5.22354C18 5.60504 18 6.07003 18 7"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  dashboardInbox: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 18.6458V8.05426C4 5.20025 4 3.77325 4.87868 2.88663C5.75736 2 7.17157 2 10 2H14C16.8284 2 18.2426 2 19.1213 2.88663C20 3.77325 20 5.20025 20 8.05426V18.6458C20 20.1575 20 20.9133 19.538 21.2108C18.7831 21.6971 17.6161 20.6774 17.0291 20.3073C16.5441 20.0014 16.3017 19.8485 16.0325 19.8397C15.7417 19.8301 15.4949 19.9768 14.9709 20.3073L13.06 21.5124C12.5445 21.8374 12.2868 22 12 22C11.7132 22 11.4555 21.8374 10.94 21.5124L9.02913 20.3073C8.54415 20.0014 8.30166 19.8485 8.03253 19.8397C7.74172 19.8301 7.49493 19.9768 6.97087 20.3073C6.38395 20.6774 5.21687 21.6971 4.46195 21.2108C4 20.9133 4 20.1575 4 18.6458Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 11H8"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 7L8 7"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  listings: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="1.5"
        cy="1.5"
        r="1.5"
        transform="matrix(1 0 0 -1 16 8.00024)"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.77423 11.1439C1.77108 12.2643 1.7495 13.9546 2.67016 15.1437C4.49711 17.5033 6.49674 19.5029 8.85633 21.3298C10.0454 22.2505 11.7357 22.2289 12.8561 21.2258C15.8979 18.5022 18.6835 15.6559 21.3719 12.5279C21.6377 12.2187 21.8039 11.8397 21.8412 11.4336C22.0062 9.63798 22.3452 4.46467 20.9403 3.05974C19.5353 1.65481 14.362 1.99377 12.5664 2.15876C12.1603 2.19608 11.7813 2.36233 11.472 2.62811C8.34412 5.31646 5.49781 8.10211 2.77423 11.1439Z"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
      />
      <path
        d="M7 14.0002L10 17.0002"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  rentals: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="#2A353D" strokeWidth="1.5" />
      <path
        d="M12 8V12L14 14"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  offerIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.46433 9.34375C2.21579 9.34375 1.98899 9.14229 2.00041 8.87895C2.06733 7.33687 2.25481 6.33298 2.78008 5.53884C3.08228 5.08196 3.45765 4.68459 3.88923 4.36468C5.05575 3.5 6.70139 3.5 9.99266 3.5H14.0074C17.2986 3.5 18.9443 3.5 20.1108 4.36468C20.5424 4.68459 20.9177 5.08196 21.2199 5.53884C21.7452 6.33289 21.9327 7.33665 21.9996 8.87843C22.011 9.14208 21.7839 9.34375 21.5351 9.34375C20.1493 9.34375 19.0259 10.533 19.0259 12C19.0259 13.467 20.1493 14.6562 21.5351 14.6562C21.7839 14.6562 22.011 14.8579 21.9996 15.1216C21.9327 16.6634 21.7452 17.6671 21.2199 18.4612C20.9177 18.918 20.5424 19.3154 20.1108 19.6353C18.9443 20.5 17.2986 20.5 14.0074 20.5H9.99266C6.70139 20.5 5.05575 20.5 3.88923 19.6353C3.45765 19.3154 3.08228 18.918 2.78008 18.4612C2.25481 17.667 2.06733 16.6631 2.00041 15.1211C1.98899 14.8577 2.21579 14.6562 2.46433 14.6562C3.85012 14.6562 4.97352 13.467 4.97352 12C4.97352 10.533 3.85012 9.34375 2.46433 9.34375Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 14.5L14.5 9.5"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 9.5H9.51122M14.4888 14.5H14.5"
        stroke="#2A353D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  profile: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
      />
      <circle cx="16.5" cy="7.5" r="1.5" stroke={ICON_STROKE_COLOR} strokeWidth="1.5" />
      <path
        d="M2 14.1354C2.66663 14.0455 3.3406 14.0011 4.01569 14.0027C6.87163 13.9466 9.65761 14.7729 11.8765 16.3342C13.9345 17.7821 15.3805 19.7749 16 22"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M13 18C14.7015 16.6733 16.5345 15.9928 18.3862 16.0001C19.4362 15.999 20.4812 16.2216 21.5 16.6617"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  ),
  contact: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="4"
        y="2"
        width="17.5"
        height="20"
        rx="4"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
      />
      <path
        d="M10.59 13.7408C9.96125 14.162 8.31261 15.0221 9.31674 16.0983C9.80725 16.624 10.3536 17 11.0404 17H14.9596C15.6464 17 16.1928 16.624 16.6833 16.0983C17.6874 15.0221 16.0388 14.162 15.41 13.7408C13.9355 12.7531 12.0645 12.7531 10.59 13.7408Z"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
      />
      <path
        d="M15 9C15 10.1046 14.1046 11 13 11C11.8954 11 11 10.1046 11 9C11 7.89543 11.8954 7 13 7C14.1046 7 15 7.89543 15 9Z"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
      />
      <path
        d="M5 6L2.5 6M5 12L2.5 12M5 18H2.5"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  shipping2: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="17" cy="18" r="2" stroke={ICON_STROKE_COLOR} strokeWidth="1.5" />
      <circle cx="7" cy="18" r="2" stroke={ICON_STROKE_COLOR} strokeWidth="1.5" />
      <path
        d="M5 17.9724C3.90328 17.9178 3.2191 17.7546 2.73223 17.2678C2.24536 16.7809 2.08222 16.0967 2.02755 15M9 18H15M19 17.9724C20.0967 17.9178 20.7809 17.7546 21.2678 17.2678C22 16.5355 22 15.357 22 13V11H17.3C16.5555 11 16.1832 11 15.882 10.9021C15.2731 10.7043 14.7957 10.2269 14.5979 9.61803C14.5 9.31677 14.5 8.94451 14.5 8.2C14.5 7.08323 14.5 6.52485 14.3532 6.07295C14.0564 5.15964 13.3404 4.44358 12.4271 4.14683C11.9752 4 11.4168 4 10.3 4H2"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 8H8"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 11H6"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 6H16.3212C17.7766 6 18.5042 6 19.0964 6.35371C19.6886 6.70742 20.0336 7.34811 20.7236 8.6295L22 11"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  password: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9982 2.00009C8.99043 2.00009 7.04018 4.01908 4.73371 4.75499C3.79589 5.05422 3.32697 5.20383 3.1372 5.41474C2.94743 5.62565 2.89186 5.93384 2.78072 6.55023C1.59143 13.1461 4.1909 19.2441 10.3903 21.6176C11.0564 21.8726 11.3894 22.0001 12.0015 22.0001C12.6135 22.0001 12.9466 21.8726 13.6126 21.6176C19.8116 19.244 22.4086 13.1461 21.219 6.55022C21.1078 5.93373 21.0522 5.62549 20.8624 5.41458C20.6726 5.20367 20.2037 5.05414 19.2659 4.75508C16.9585 4.01924 15.0061 2.00009 11.9982 2.00009Z"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 7.00009L12 9.00009"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  card: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 12C2 8.46252 2 6.69377 3.0528 5.5129C3.22119 5.32403 3.40678 5.14935 3.60746 4.99087C4.86213 4 6.74142 4 10.5 4H13.5C17.2586 4 19.1379 4 20.3925 4.99087C20.5932 5.14935 20.7788 5.32403 20.9472 5.5129C22 6.69377 22 8.46252 22 12C22 15.5375 22 17.3062 20.9472 18.4871C20.7788 18.676 20.5932 18.8506 20.3925 19.0091C19.1379 20 17.2586 20 13.5 20H10.5C6.74142 20 4.86213 20 3.60746 19.0091C3.40678 18.8506 3.22119 18.676 3.0528 18.4871C2 17.3062 2 15.5375 2 12Z"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M10 16H11.5"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14.5 16L18 16"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path d="M2 9H22" stroke={ICON_STROKE_COLOR} strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  ),
  paypal: (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M5.50971 2.90194C5.55646 2.66823 5.76166 2.5 6 2.5H14.2602C16.4993 2.5 18.1625 4.57346 17.6768 6.75926L17.0101 9.75926C16.6543 11.3606 15.2339 12.5 13.5935 12.5H9.89039L8.48508 18.1213C8.42943 18.3439 8.22944 18.5 8 18.5H3C2.85021 18.5 2.7083 18.4328 2.61333 18.317C2.51836 18.2012 2.48034 18.0488 2.50971 17.9019L5.50971 2.90194ZM6.40991 3.5L3.60991 17.5H7.60962L9.01493 11.8787C9.07058 11.6561 9.27057 11.5 9.5 11.5H13.5935C14.7652 11.5 15.7798 10.6862 16.034 9.54233L16.7006 6.54233C17.0476 4.98104 15.8595 3.5 14.2602 3.5H6.40991Z"
        fill="black"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M17.2602 6.5H17V5.5H17.2602C19.4993 5.5 21.1625 7.57346 20.6768 9.75926L20.0101 12.7593C19.6543 14.3606 18.2339 15.5 16.5935 15.5H12.8904L11.4851 21.1213C11.4294 21.3439 11.2294 21.5 11 21.5H6C5.85021 21.5 5.7083 21.4328 5.61333 21.317C5.51836 21.2012 5.48034 21.0488 5.50971 20.9019L6.10971 17.9019L7.09029 18.0981L6.60991 20.5H10.6096L12.0149 14.8787C12.0706 14.6561 12.2706 14.5 12.5 14.5H16.5935C17.7652 14.5 18.7798 13.6862 19.034 12.5423L19.7006 9.54233C20.0476 7.98104 18.8595 6.5 17.2602 6.5Z"
        fill="black"
        fillRule="evenodd"
      />
    </svg>
  ),
  payout: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 14C16 14.8284 16.6716 15.5 17.5 15.5C18.3284 15.5 19 14.8284 19 14C19 13.1716 18.3284 12.5 17.5 12.5C16.6716 12.5 16 13.1716 16 14Z"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
      />
      <path
        d="M10 7H16C18.8284 7 20.2426 7 21.1213 7.87868C22 8.75736 22 10.1716 22 13V15C22 17.8284 22 19.2426 21.1213 20.1213C20.2426 21 18.8284 21 16 21H10C6.22876 21 4.34315 21 3.17157 19.8284C2 18.6569 2 16.7712 2 13V11C2 7.22876 2 5.34315 3.17157 4.17157C4.34315 3 6.22876 3 10 3H14C14.93 3 15.395 3 15.7765 3.10222C16.8117 3.37962 17.6204 4.18827 17.8978 5.22354C18 5.60504 18 6.07003 18 7"
        stroke={ICON_STROKE_COLOR}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  trackingPlane: (
    <svg fill="#000000" height="15px" width="20px" version="1.1" id="Layer_1" viewBox="0 0 128 128">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path d="M56.1,11.2c0-9.1,13.8-9.1,13.8,0.3v38.3L123.4,82v14.1L70.1,78.6v28.6l12.3,9.7V128l-19-5.9l-19,5.9v-11.2l12.2-9.7V78.6 L3.2,96.1V82l52.8-32.2V11.2z"></path>{' '}
      </g>
    </svg>
  ),
  orderIssues: (
    <svg
      width={24}
      height={16}
      fill="#000000"
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M960 1242.342c62.23 0 112.941 50.71 112.941 112.94 0 62.231-50.71 112.942-112.941 112.942-62.23 0-112.941-50.71-112.941-112.941 0-62.23 50.71-112.941 112.941-112.941Zm89.336-892.01c114.862 29.704 208.264 123.106 237.968 237.967 23.378 90.466 10.729 183.304-35.464 261.46-45.515 77.138-121.186 133.947-207.586 156.084-13.779 3.614-27.783 14.795-27.783 31.962v91.595H903.529v-91.595c0-66.183 46.306-124.235 112.716-141.29 57.6-14.795 107.971-52.743 138.353-104.131 30.833-52.292 39.19-114.635 23.378-175.85-19.651-75.67-81.204-137.223-156.875-156.875-70.927-18.183-143.435-3.953-199.341 39.304-55.68 43.143-87.642 108.31-87.642 178.673H621.176c0-105.6 47.888-203.294 131.464-268.01 83.69-64.828 191.774-86.287 296.696-59.294ZM960-.01c-529.355 0-960 430.644-960 960 0 529.355 430.645 960 960 960 529.468 0 960-430.645 960-960 0-529.356-430.532-960-960-960"
          fillRule="evenodd"
        ></path>{' '}
      </g>
    </svg>
  ),
  deliveryInfo: (
    <svg
      width={24}
      height={16}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <rect x="0" fill="none" width="24" height="24"></rect>{' '}
        <g>
          {' '}
          <path d="M18 8h-2V7c0-1.105-.895-2-2-2H4c-1.105 0-2 .895-2 2v10h2c0 1.657 1.343 3 3 3s3-1.343 3-3h4c0 1.657 1.343 3 3 3s3-1.343 3-3h2v-5l-4-4zM7 18.5c-.828 0-1.5-.672-1.5-1.5s.672-1.5 1.5-1.5 1.5.672 1.5 1.5-.672 1.5-1.5 1.5zM4 14V7h10v7H4zm13 4.5c-.828 0-1.5-.672-1.5-1.5s.672-1.5 1.5-1.5 1.5.672 1.5 1.5-.672 1.5-1.5 1.5z"></path>{' '}
        </g>{' '}
      </g>
    </svg>
  ),
  featureIcon1: (
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dii_4984_402441)">
        <rect x="2" y="1" width="48" height="48" rx="10" fill="white" />
        <rect x="2.5" y="1.5" width="47" height="47" rx="9.5" stroke="#E4E7EC" fill="none" />
        <path
          d="M20.0944 24.2288C20.0322 23.8282 20 23.4179 20 23C20 18.5817 23.6052 15 28.0526 15C32.4999 15 36.1052 18.5817 36.1052 23C36.1052 23.9981 35.9213 24.9535 35.5852 25.8345C35.5154 26.0175 35.4804 26.109 35.4646 26.1804C35.4489 26.2512 35.4428 26.301 35.4411 26.3735C35.4394 26.4466 35.4493 26.5272 35.4692 26.6883L35.8717 29.9585C35.9153 30.3125 35.9371 30.4895 35.8782 30.6182C35.8266 30.731 35.735 30.8205 35.6211 30.8695C35.4911 30.9254 35.3146 30.8995 34.9617 30.8478L31.7765 30.3809C31.6101 30.3565 31.527 30.3443 31.4512 30.3448C31.3763 30.3452 31.3245 30.3507 31.2511 30.3661C31.177 30.3817 31.0823 30.4172 30.893 30.4881C30.0097 30.819 29.0524 31 28.0526 31C27.6344 31 27.2237 30.9683 26.8227 30.9073M21.6316 35C24.5965 35 27 32.5376 27 29.5C27 26.4624 24.5965 24 21.6316 24C18.6667 24 16.2632 26.4624 16.2632 29.5C16.2632 30.1106 16.3603 30.6979 16.5395 31.2467C16.6153 31.4787 16.6532 31.5947 16.6657 31.6739C16.6786 31.7567 16.6809 31.8031 16.6761 31.8867C16.6714 31.9668 16.6514 32.0573 16.6113 32.2383L16 35L18.9948 34.591C19.1583 34.5687 19.24 34.5575 19.3114 34.558C19.3865 34.5585 19.4264 34.5626 19.5001 34.5773C19.5701 34.5912 19.6742 34.6279 19.8823 34.7014C20.4306 34.8949 21.0191 35 21.6316 35Z"
          stroke="#344054"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <filter
          id="filter0_dii_4984_402441"
          x="0"
          y="0"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4984_402441" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4984_402441"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_4984_402441" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect3_innerShadow_4984_402441"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_4984_402441"
            result="effect3_innerShadow_4984_402441"
          />
        </filter>
      </defs>
    </svg>
  ),
  featureIcon2: (
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dii_4984_402449)">
        <rect x="2" y="1" width="48" height="48" rx="10" fill="white" />
        <rect x="2.5" y="1.5" width="47" height="47" rx="9.5" stroke="#E4E7EC" fill="none" />
        <path
          d="M26.9999 15L18.0933 25.6879C17.7445 26.1064 17.5701 26.3157 17.5674 26.4925C17.5651 26.6461 17.6336 26.7923 17.7531 26.8889C17.8906 27 18.163 27 18.7079 27H25.9999L24.9999 35L33.9064 24.3121C34.2552 23.8936 34.4296 23.6843 34.4323 23.5075C34.4346 23.3539 34.3661 23.2077 34.2466 23.1111C34.1091 23 33.8367 23 33.2918 23H25.9999L26.9999 15Z"
          stroke="#344054"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <filter
          id="filter0_dii_4984_402449"
          x="0"
          y="0"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4984_402449" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4984_402449"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_4984_402449" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect3_innerShadow_4984_402449"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_4984_402449"
            result="effect3_innerShadow_4984_402449"
          />
        </filter>
      </defs>
    </svg>
  ),
  featureIcon3: (
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dii_4984_402457)">
        <rect x="2" y="1" width="48" height="48" rx="10" fill="white" />
        <rect x="2.5" y="1.5" width="47" height="47" rx="9.5" stroke="#E4E7EC" fill="none" />
        <path
          d="M25 16H21.8C20.1198 16 19.2798 16 18.638 16.327C18.0735 16.6146 17.6146 17.0735 17.327 17.638C17 18.2798 17 19.1198 17 20.8V29.2C17 30.8802 17 31.7202 17.327 32.362C17.6146 32.9265 18.0735 33.3854 18.638 33.673C19.2798 34 20.1198 34 21.8 34H30.2C31.8802 34 32.7202 34 33.362 33.673C33.9265 33.3854 34.3854 32.9265 34.673 32.362C35 31.7202 35 30.8802 35 29.2V26M26 21H30V25M29.5 16.5V15M33.4393 17.5607L34.5 16.5M34.5103 21.5H36.0103M17 26.3471C17.6519 26.4478 18.3199 26.5 19 26.5C23.3864 26.5 27.2653 24.3276 29.6197 21"
          stroke="#344054"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <filter
          id="filter0_dii_4984_402457"
          x="0"
          y="0"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4984_402457" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4984_402457"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_4984_402457" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect3_innerShadow_4984_402457"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_4984_402457"
            result="effect3_innerShadow_4984_402457"
          />
        </filter>
      </defs>
    </svg>
  ),
  featureIcon4: (
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dii_4984_402465)">
        <rect x="2" y="1" width="48" height="48" rx="10" fill="white" />
        <rect x="2.5" y="1.5" width="47" height="47" rx="9.5" stroke="#E4E7EC" fill="none" />
        <path
          d="M22.9996 27C22.9996 27 24.3121 28.5 26.4996 28.5C28.6871 28.5 29.9996 27 29.9996 27M29.2496 22H29.2596M23.7496 22H23.7596M26.4996 33C31.194 33 34.9996 29.1944 34.9996 24.5C34.9996 19.8056 31.194 16 26.4996 16C21.8052 16 17.9996 19.8056 17.9996 24.5C17.9996 25.45 18.1555 26.3636 18.443 27.2166C18.5512 27.5376 18.6053 27.6981 18.6151 27.8214C18.6247 27.9432 18.6174 28.0286 18.5873 28.1469C18.5568 28.2668 18.4894 28.3915 18.3547 28.6408L16.7191 31.6684C16.4857 32.1002 16.3691 32.3161 16.3952 32.4828C16.4179 32.6279 16.5034 32.7557 16.6288 32.8322C16.7728 32.9201 17.0169 32.8948 17.5052 32.8444L22.6262 32.315C22.7813 32.299 22.8588 32.291 22.9295 32.2937C22.999 32.2963 23.0481 32.3029 23.1159 32.3185C23.1848 32.3344 23.2714 32.3678 23.4448 32.4345C24.3928 32.7998 25.4228 33 26.4996 33ZM29.7496 22C29.7496 22.2761 29.5258 22.5 29.2496 22.5C28.9735 22.5 28.7496 22.2761 28.7496 22C28.7496 21.7239 28.9735 21.5 29.2496 21.5C29.5258 21.5 29.7496 21.7239 29.7496 22ZM24.2496 22C24.2496 22.2761 24.0258 22.5 23.7496 22.5C23.4735 22.5 23.2496 22.2761 23.2496 22C23.2496 21.7239 23.4735 21.5 23.7496 21.5C24.0258 21.5 24.2496 21.7239 24.2496 22Z"
          stroke="#344054"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <filter
          id="filter0_dii_4984_402465"
          x="0"
          y="0"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4984_402465" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4984_402465"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_4984_402465" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect3_innerShadow_4984_402465"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_4984_402465"
            result="effect3_innerShadow_4984_402465"
          />
        </filter>
      </defs>
    </svg>
  ),
  featureIcon5: (
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dii_4984_402473)">
        <rect x="2" y="1" width="48" height="48" rx="10" fill="white" />
        <rect x="2.5" y="1.5" width="47" height="47" rx="9.5" stroke="#E4E7EC" fill="none" />
        <path
          d="M23 22V19C23 17.3431 21.6569 16 20 16C18.3431 16 17 17.3431 17 19C17 20.6569 18.3431 22 20 22H23ZM23 22V28M23 22H29M23 28V31C23 32.6569 21.6569 34 20 34C18.3431 34 17 32.6569 17 31C17 29.3431 18.3431 28 20 28H23ZM23 28H29M29 28H32C33.6569 28 35 29.3431 35 31C35 32.6569 33.6569 34 32 34C30.3431 34 29 32.6569 29 31V28ZM29 28V22M29 22V19C29 17.3431 30.3431 16 32 16C33.6569 16 35 17.3431 35 19C35 20.6569 33.6569 22 32 22H29Z"
          stroke="#344054"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <filter
          id="filter0_dii_4984_402473"
          x="0"
          y="0"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4984_402473" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4984_402473"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_4984_402473" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect3_innerShadow_4984_402473"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_4984_402473"
            result="effect3_innerShadow_4984_402473"
          />
        </filter>
      </defs>
    </svg>
  ),
  featureIcon6: (
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dii_4984_402481)">
        <rect x="2" y="1" width="48" height="48" rx="10" fill="white" />
        <rect x="2.5" y="1.5" width="47" height="47" rx="9.5" stroke="#E4E7EC" fill="none" />
        <path
          d="M34.9996 24.5C34.9996 29.1944 31.194 33 26.4996 33C25.4228 33 24.3928 32.7998 23.4448 32.4345C23.2714 32.3678 23.1848 32.3344 23.1159 32.3185C23.0481 32.3029 22.999 32.2963 22.9295 32.2937C22.8588 32.291 22.7813 32.299 22.6262 32.315L17.5052 32.8444C17.0169 32.8948 16.7728 32.9201 16.6288 32.8322C16.5034 32.7557 16.4179 32.6279 16.3952 32.4828C16.3691 32.3161 16.4857 32.1002 16.7191 31.6684L18.3547 28.6408C18.4894 28.3915 18.5568 28.2668 18.5873 28.1469C18.6174 28.0286 18.6247 27.9432 18.6151 27.8214C18.6053 27.6981 18.5512 27.5376 18.443 27.2166C18.1555 26.3636 17.9996 25.45 17.9996 24.5C17.9996 19.8056 21.8052 16 26.4996 16C31.194 16 34.9996 19.8056 34.9996 24.5Z"
          stroke="#344054"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.4965 21.9493C25.5968 20.9104 24.0965 20.631 22.9692 21.5822C21.842 22.5335 21.6833 24.124 22.5685 25.2491C23.117 25.9461 24.4935 27.2191 25.4616 28.087C25.8172 28.4057 25.995 28.5651 26.2084 28.6293C26.3914 28.6844 26.6017 28.6844 26.7847 28.6293C26.9981 28.5651 27.1759 28.4057 27.5315 28.087C28.4996 27.2191 29.8761 25.9461 30.4246 25.2491C31.3098 24.124 31.1705 22.5235 30.0238 21.5822C28.8772 20.641 27.3963 20.9104 26.4965 21.9493Z"
          stroke="#344054"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <filter
          id="filter0_dii_4984_402481"
          x="0"
          y="0"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4984_402481" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4984_402481"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_4984_402481" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect3_innerShadow_4984_402481"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_4984_402481"
            result="effect3_innerShadow_4984_402481"
          />
        </filter>
      </defs>
    </svg>
  ),
  tshirt: (
    <svg width={24} height={24} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M3 1H6L8 3L10 1H13H16V5L13 6V16H3V6L0 5V1H3Z" fill="#000000"></path>{' '}
      </g>
    </svg>
  ),
};

const Icons = ({ name }) => {
  return icons[name] || <></>;
};

export default Icons;
